<template>
  <div class="acitvityAll">
    <div class="backBox">
      <img
        class="pointer"
        @click="toSetting()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">数据统计</span>
    </div>
    <div class="actName">
      <img
        class="actName_img"
        src="@/assets/thdImg/common/icon_lw.png"
        style="margin-right: 20px"
        alt=""
      />
      <div class="actName_info">
        <span>活动名称：{{ rowData.activityName }}</span>
        <div v-if="fitersChooseIF([35], '!=')">
          活动时间：{{ rowData.startTime }} 至 {{ rowData.endTime }}
        </div>
        <template v-else-if="rowData.ruleDto">
          <div>
            确权时间：{{ rowData.ruleDto.lockStartTime }} 至
            {{ rowData.ruleDto.lockEndTime }}
          </div>
          <div>
            下单时间：{{ rowData.ruleDto.orderStartTime }} 至
            {{ rowData.ruleDto.orderEndTime }}
          </div>
          <div>
            确认收货时间：{{ rowData.ruleDto.finishStartTime }} 至
            {{ rowData.ruleDto.finishEndTime }}
          </div>
        </template>
        <div>活动类型：{{ rowData.activityTypeStr }}</div>
      </div>
    </div>
    <el-tabs
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
      class="formSty"
    >
      <!-- 后端暂不做活动统计，前端需改逻辑隐藏，包括初始化逻辑 -->
      <el-tab-pane label="活动统计" name="first">
        <div class="section-right-content-box">
          <div style="margin: 20px 0px 20px 0px">
            <el-form label-width="10px">
              <el-form-item>
                <span style="margin-right: 20px">统计时间 :</span>
                <el-radio
                  v-model="queryForm.evaluateTime"
                  @change="timeChange"
                  v-for="item in options.evaluateTimeOpt"
                  :key="item.value"
                  :label="item.value"
                  >{{ item.label }}</el-radio
                >
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="postForm.startDate"
                    type="date"
                    :placeholder="'选择日期时间'"
                    size="small"
                    :disabled="
                      queryForm.evaluateTime != 0 || !queryForm.evaluateTime
                    "
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    style="width: 120px; font-size: 12px"
                    class="time1"
                    :clearable="false"
                  ></el-date-picker>
                  <div
                    class="time_to_text"
                    :class="{
                      to_text_disabled:
                        queryForm.evaluateTime != 0 || !queryForm.evaluateTime,
                    }"
                  >
                    至
                  </div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="postForm.endDate"
                    type="date"
                    :placeholder="'选择日期时间'"
                    size="small"
                    :disabled="
                      queryForm.evaluateTime != 0 || !queryForm.evaluateTime
                    "
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    style="width: 145px; font-size: 12px"
                    class="time2"
                    :clearable="true"
                  ></el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    @click="clearTimeSendTime()"
                  ></i>
                  <img
                    src="@/assets/images/select_date.svg"
                    alt
                    class="date_icon2"
                  />
                </div>
                <el-button
                  class="b1"
                  style="margin-left: 20px"
                  @click="querySeach()"
                  ><span style="marginleft: 4px">
                    <i
                      class="el-icon-search"
                      style="
                        display: inline-block;
                        width: 14px;
                        height: 12px;
                        fontweight: bold;
                        margin-right: 4px;
                      "
                    ></i
                    >查询</span
                  ></el-button
                >
                <el-button
                  class="b2"
                  style="margin-left: 20px"
                  @click="queryOne()"
                  ><span style="marginleft: 4px">重置</span></el-button
                >
              </el-form-item>

              <!-- 积分确权定制特殊处理 -->
              <el-form-item v-if="fitersChooseIF([35])">
                <div>
                  <span>投放渠道：</span>
                  <el-select
                    size="small"
                    v-model="postForm.channelCode"
                    style="width: 280px"
                  >
                    <el-option
                      v-for="(item, index) in batchTypeList"
                      :key="index"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                  <!-- <el-button class="b1" style="margin-left: 20px" @click="export_get"
                  ><span style="marginleft: 4px">
                    导出</span
                  ></el-button
                > -->
                  <el-button
                    style="margin-bottom: 20px; margin-left: 6px"
                    @click="export_get"
                    v-preventReClick
                    ><span> 导出</span></el-button
                  >
                </div>
              </el-form-item>

              <!-- 下单冲榜导出功能 -->
              <el-form-item v-if="fitersChooseIF([36,39])">
                <div class="export-box">
                  <el-button type="primary" @click="export_get">导出</el-button>
                </div>
              </el-form-item>

              <!-- 派样回购礼导出功能 -->
              <el-form-item el-form-item v-if="fitersChooseIF([37])">
                <div class="export-box">
                  <el-button type="primary" @click="export_get">导出</el-button>
                </div>
              </el-form-item>
              <!-- 除了一些特殊活动外, 其他活动的数据统计-导出 -->
              <el-form-item v-if="fitersChooseIF([37,35,36,39], '!=')">
                <el-dropdown @command="exportRule($event)" style="float:right">
                  <el-button type="default"
                    >导出 <i class="el-icon-arrow-down ml-5"></i
                  ></el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="setting">导出字段设置</el-dropdown-item>
                    <el-dropdown-item command="exportAll">导出数据（全部）</el-dropdown-item>
                    <el-dropdown-item command="exportSetting">导出数据（按设置）</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-form-item>
            </el-form>
          </div>
          <div class="background data-title-wrap">
            <div>
              <span class="title"></span>&nbsp;
              <span class="tips">转化分析</span>
            </div>
            <span class="back_text" @click="triggerVersion">返回旧版</span>
          </div>
          <!-- 下单转化 -->
          <div
            v-if="fitersChooseIF([35])"
            style="font-size: 12px; margin-bottom: 4px; color: #999"
          >
            * 该数据不区分渠道
          </div>
          <div class="titClass" v-if="fitersChooseIF([25, 26, 32, 33], '!=')">
            <div class="down">
              下单转化
              <el-popover
                placement="top-start"
                width="400"
                offset="100"
                trigger="hover"
                data-html="true"
              >
                <span>转化数据说明：</span><br />
                <span> 1、人群:参与活动的用户。</span><br />
                <span>
                  2、时间:活动开始至T+1
                  (昨日)的累计成交数据，每天中午12:30后更新。</span
                ><br />
                <span>
                  3、订单维度:已付款的在线支付订单或者选择货到付款的订单。</span
                ><br />
                <span>
                  4、备注:活动结束后15天内的数据都可以统计，超过15天的数据将无法统计。</span
                ><br />
                <span>
                  5、由于京东数据的限制，活动开始和结束时间只能以活动首次创建的时间为准;中途修改活动时间，无法更新转化数据的统计时间范围。</span
                ><br />
                <span style="float: right" slot="reference">
                  <p class="question_iconOne">?</p>
                </span>
              </el-popover>
            </div>
            <div class="borderU"></div>
            <div
              class="titClassOne"
              v-for="(v, index) in hostList"
              :key="index"
            >
              <div style="color: #333333; font-size: 14px">
                {{ v.name }}
              </div>
              <div style="color: #333333; font-size: 18px; font-weight: 600">
                {{
                  index == 0
                    ? tatal_num.users
                    : index == 1
                    ? tatal_num.ordNum
                    : index == 2
                    ? tatal_num.gmv
                    : (tatal_num.ordRate * 100).toFixed(2)
                }}
                <span style="color: #999999; font-size: 14px">
                  {{
                    index == 0
                      ? "人"
                      : index == 1
                      ? "单"
                      : index == 2
                      ? "元"
                      : "%"
                  }}
                </span>
              </div>
            </div>
          </div>
          <div class="background">
            <span class="title"></span>&nbsp;
            <span class="tips">数据总览</span>
          </div>
          <div class="switch">
            <el-tabs v-model="switchIndex" class="switch-tabs">
              <el-tab-pane label="互动参与" name="1"></el-tab-pane>
              <el-tab-pane label="浏览店铺" name="2"></el-tab-pane>
              <el-tab-pane label="浏览商品" name="3"></el-tab-pane>
              <el-tab-pane label="下单" name="4"></el-tab-pane>
              <el-tab-pane label="入会" name="5"></el-tab-pane>
              <el-tab-pane label="中奖" name="6"></el-tab-pane>
            </el-tabs>
          </div>
          <div v-loading="loading">
            <div
              :class="fitersChooseIF([36]) ? 'overview2' : 'overview1'"
              style="float: left"
              v-for="(item, index) in dataSummary"
              :key="index + item.value"
              :style="
                item.value == 'successfulParticipants'
                  ? { width: '25%' }
                  : item.value == 'sharePeoNum'
                  ? { width: '10%', 'border-right': '0px' }
                  : {}
              "
            >
              <div>
                <span class="fontClass">{{ item.name }}</span>
                <!--v-if="item.tips"width="200" 京东v2.4迭代 -->
                <el-popover
                  v-if="item.tipsName"
                  placement="top-start"
                  offset="100"
                  trigger="hover"
                  :content="item.tipsName"
                >
                  <span
                    style="float: right; margin-top: -10px"
                    slot="reference"
                  >
                    <p class="question_icon">?</p>
                  </span>
                </el-popover>
              </div>
              <div class="num">
                {{ tableTotal[item.value] }}{{fitersChooseIF([25, 26, 32, 33]) 
                  &&
                  (item.value == 'orderRate' || item.value == 'cartRate' || item.value == 'clickRate' || item.value == 'payOrderRate' || item.value == 'visitUsrPayOrderRate') ? 
                  '%':'' }}{{fitersChooseIF([37]) 
                  &&
                  (item.value == 'enterReBuyRate' || item.value == 'orderReBuyRate') ? 
                  '%':''}}
              </div>
            </div>
          </div>
          <!-- 折线图 -->
          <div
            style="clear: left"
            ref="payRemindChart"
            class="chart"
            v-loading="loading"
          ></div>
          <div class="flex-end">
            <el-button
              @click="exportData('statisticsTable')"
              type="default"
              v-preventReClick
              >导出</el-button
            >
          </div>
          <el-table
            :data="chartEffectDetail"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%; margin: 40px auto"
            max-height="600"
          >
            <el-table-column
              prop="dateTime"
              label="日期"
            >
            </el-table-column>
            <el-table-column
              v-for="item in dataSummary"
              :prop="item.value"
              :label="item.name"
              :key="item.value"
            >
            </el-table-column>
          </el-table>
          <!-- <el-pagination
            style="text-align: right; margin: 25px"
            @size-change="handleSizeChange"
            background
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            :current-page="formList.current"
          ></el-pagination> -->
        </div>
      </el-tab-pane>
      <!-- 派样付款列表 -->
      <el-tab-pane label="派样付款列表" name="sendReBuyPay" v-if="fitersChooseIF([37])">
        <input-form
          ref="inputSendBuyPayRef"
          :inputData="inputSendBuyPay"
          @toParentVal="searchSendBuyPay"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="width: 150px"
          @click="addCrowd(15)"
          >按查询结果生成人群</el-button
        >
        <el-button
          @click="export_get"
          type="primary"
          v-preventReClick
          >导出</el-button
        >
        <el-table
          v-loading="loading"
          :data="sendBuyPayTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 20px auto 40px"
        >
          <el-table-column prop="pin" label="用户pin" width="150"></el-table-column>
          <el-table-column prop="activityName" label="活动名称"> </el-table-column>
          <el-table-column prop="shopNameDetail" label="商品信息"> 
            <template slot-scope="scope">
              <div>{{ scope.row.skuName }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :width="item.width ? item.width : '160'"
            :key="index"
            v-for="(item, index) in sendBuyList"
          >
          </el-table-column>
          <el-table-column prop="isCommitAddress" label="是否录入收货信息"> 
            <template slot-scope="scope">
              <div>{{ scope.row.isCommitAddressStr }}</div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeSendBuyPay"
          background
          @current-change="handleCurrentSendBuyPay"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSendBuyPayCount"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>

      <!-- 回购付款列表 -->
      <el-tab-pane label="回购付款列表" name="sendReBuyRePay" v-if="fitersChooseIF([37])">
        <input-form
          ref="inputSendBuyRePayRef"
          :inputData="inputSendBuyRePay"
          @toParentVal="searchSendBuyRePay"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="width: 150px"
          @click="addCrowd(15)"
          >按查询结果生成人群</el-button
        >
        <el-button
          @click="export_get"
          type="primary"
          v-preventReClick
          >导出</el-button
        >
        <el-table
          v-loading="loading"
          :data="sendBuyRePayTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 20px auto 40px"
        >
        <el-table-column prop="pin" label="用户pin"  width="150"></el-table-column>
          <el-table-column prop="activityName" label="活动名称"> </el-table-column>
          <el-table-column prop="orderId" label="订单号"></el-table-column>
          <el-table-column prop="orderPayment" label="商品金额"></el-table-column>
          <el-table-column prop="shopNameDetail" label="商品信息"> 
            <template slot-scope="scope">
              <div>{{ scope.row.skuName }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :width="item.width ? item.width : '160'"
            :key="index"
            v-for="(item, index) in sendReBuyList"
          >
          </el-table-column>
          <el-table-column prop="isCommitAddress" label="是否录入收货信息"> 
            <template slot-scope="scope">
              <div>{{ scope.row.isCommitAddressStr }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="isWin" label="是否中奖"> 
            <template slot-scope="scope">
              <div>{{ scope.row.isWin == 1 ? '是': '否' }}</div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeSendBuyRePay"
          background
          @current-change="handleCurrentSendBuyRePay"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSendBuyRePayCount"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="eleven"
        v-if="fitersChooseIF([23, 24])"
      >
        <input-form
          :inputData="inputParticipat"
          @toParentVal="searchParticipationForm"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(6)"
          >按查询结果生成人群</el-button
        >
        <el-table
          v-loading="loading"
          :data="ParticipatTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="chaosPin" label="用户pin（加密）" width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
          <el-table-column prop="joinTime" label="参与时间"> </el-table-column>
          <el-table-column
            v-if="fitersChooseIF([23])"
            prop="score"
            label="得分"
          >
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.score || scope.row.score == 0
                    ? scope.row.score
                    : "--"
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="isPass" label="是否通关">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.isPass == 1
                    ? "是"
                    : scope.row.isPass == 0
                    ? "否"
                    : "--"
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="isDraw" label="是否抽奖">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.isDraw == 1
                    ? "是"
                    : scope.row.isDraw == 0
                    ? "否"
                    : "--"
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="isWin" label="是否中奖">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.isWin == 1
                    ? "是"
                    : scope.row.isWin == 0
                    ? "否"
                    : "--"
                }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeParticipat"
          background
          @current-change="handleCurrentParticipat"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalParticipat"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>

      <!-- 参与记录(会员升级礼) -->
      <el-tab-pane label="参与记录" name="MemberUpGrade" v-if="fitersChooseIF([44])">
        <input-form
          :inputData="inputMemberUpGrade2"
          @toParentVal="searchMemberUpGrade"
          :btnPosition2="true"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(25)"
          >按查询结果生成人群</el-button
        >
        <!-- @click="exportTheData2" -->
        <el-button
         style="float: right; margin-bottom: 20px;"
          @click="export_get"
          v-preventReClick
          :disabled="!MemberUpGradeTable.length"
          >导出</el-button
        >
        <div class="new-table-box">
          <el-table
            v-loading="loading"
            :data="MemberUpGradeTable"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%;"
          >
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
            <el-table-column prop="chaosPin" label="用户pin（加密）"   width="150">
            </el-table-column>
            <el-table-column prop="createTime" label="参与时间"> </el-table-column>
            <el-table-column prop="memberInitialLevel" label="初始会员等级"> </el-table-column>
            <el-table-column prop="latestJoinTime" label="最新访问活动时间"> </el-table-column>
            <el-table-column prop="memberLatestLevel" label="最新会员等级"> </el-table-column>
            <el-table-column prop="isUpgrades" label="是否发生升级">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.isUpgrades == 1 ? "已升级": scope.row.isUpgrades == 0 ? "未升级": "--"}}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="upLevelNumber" label="升级级数"> </el-table-column>
            <el-table-column prop="isWin" label="是否领取奖品">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.isWin == 1 ? "已领取": scope.row.isWin == 0 ? "未领取": "--"}}
                </span>
              </template> 
            </el-table-column>
          </el-table>
        </div>
        <div class="new-pagination-page" style="margin-top: 20px">
          <el-pagination
            style="text-align: right;"
            @size-change="handleSizeMemberUpGrade"
            background
            @current-change="handleCurrentMemberUpGrade"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalMemberUpGrade"
            :current-page="formList.current"
          ></el-pagination>
        </div>
      </el-tab-pane>

      <!-- 参与记录(情书贺卡) -->
      <el-tab-pane label="参与记录" name="BilletDoux" v-if="fitersChooseIF([50])">
        <input-form
          :inputData="billetInput"
          @toParentVal="searchBilletDoux"
          :btnPosition2="true"
        ></input-form>
        <el-button
          style="margin-bottom: 16px; width: 150px;"
          @click="addCrowd(31)"
          >按查询结果生成人群</el-button
        >
        <el-button
          style="float: right;margin-bottom: 16px;"
          @click="export_get"
          v-preventReClick
          :disabled="!BilletDouxTable.length"
          >导出</el-button
        >
        <div class="new-table-box">
          <el-table
            v-loading="loading"
            :data="BilletDouxTable"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%;"
          >
          <el-table-column type="selection">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
            <el-table-column prop="pin" label="用户pin（加密）">
            </el-table-column>
            <el-table-column prop="joinTime" label="参与时间"> </el-table-column>
            <el-table-column prop="isFinish" label="是否完成情书制作">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.isFinish == 1 ? "已完成": scope.row.isFinish == 0 ? "未完成": "--"}}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="receiverMobile" label="接受者手机号"> </el-table-column>
          </el-table>
        </div>
        <div class="new-pagination-page" style="margin-top: 20px">
          <el-pagination
            style="text-align: right;"
            @size-change="handleSizeBilletDoux"
            background
            @current-change="handleCurrentBilletDoux"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalBilletDoux"
            :current-page="formList.current"
          ></el-pagination>
        </div>
      </el-tab-pane>

      <!-- 获取记录(情书贺卡) -->
      <el-tab-pane label="获取记录" name="BilletDouxReceive" v-if="fitersChooseIF([50])">
        <input-form
          :inputData="billetReceive"
          @toParentVal="searchBilletReceive"
          :btnPosition2="true"
        ></input-form>
        <el-button
          style="margin-bottom: 16px; width: 150px;"
          @click="addCrowd(32)"
          >按查询结果生成人群</el-button
        >
        <el-button
          style="float: right;margin-bottom: 16px;"
          @click="export_get"
          v-preventReClick
          :disabled="!BilletReceiveTable.length"
          >导出</el-button
        >
        <div class="new-table-box">
          <el-table
            v-loading="loading"
            :data="BilletReceiveTable"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%;"
          >
          <el-table-column type="selection">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
            <el-table-column prop="pin" label="用户pin（加密）">
            </el-table-column>
            <el-table-column prop="createTime" label="获取时间"> </el-table-column>
            <el-table-column prop="num" label="获取情书数量">
            </el-table-column>
            <el-table-column prop="receiverMobile" label="获取手机号"> </el-table-column>
          </el-table>
        </div>
        <div class="new-pagination-page" style="margin-top: 20px">
          <el-pagination
            style="text-align: right;"
            @size-change="handleSizeBilletReceive"
            background
            @current-change="handleCurrentBilletReceive"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalBilletReceive"
            :current-page="formList.current"
          ></el-pagination>
        </div>
      </el-tab-pane>

      <!-- 签到纪录 -->
      <el-tab-pane label="签到记录" name="second" v-if="fitersChooseIF([1])">
        <input-form
          :inputData="inputData"
          @toParentVal="searchForm"
          :btnPosition="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(1)"
          >按查询结果生成人群</el-button
        >
        <el-table
          v-loading="loading"
          :data="signInTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="chaosPin" label="用户pin（加密）" width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称" width="400">
          </el-table-column>
          <el-table-column prop="signTime" label="签到时间" width="400">
          </el-table-column>
          <el-table-column
            prop="cumulativeTimes"
            label="累计签到次数(含历史记录)"
            width="400"
          >
          </el-table-column>
          <el-table-column
            prop="sequenceTimes"
            label="连续签到次数(不含历史记录)"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeSignIn"
          background
          @current-change="handleCurrentSignIn"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSignIn"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>

       <!-- 签到有礼新增补签卡获取记录 -->
      <el-tab-pane label="补签卡获取记录" name="secondBu" v-if="fitersChooseIF([1])">
        <input-form
          :inputData="inputDataListSupplementary"
          @toParentVal="searchFormBu"
          :btnPosition="true"
          style="margin: 20px 0"
        ></input-form>
        <el-table
          v-loading="loading"
          :data="signInTableSupplementary"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="memberNick" label="用户昵称" width="400">
          </el-table-column>
          <el-table-column prop="chaosPin" label="用户pin" width="150">
          </el-table-column>
          <el-table-column prop="joinTime" label="获取时间" width="400">
          </el-table-column>
         <el-table-column prop="taskTypeStr" label="任务类型" width="400">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.taskTypeStr =='开卡入会' ? '加入会员': scope.row.taskTypeStr}}
                </span>
              </template>
          </el-table-column>
          <el-table-column
            label="赠送次数"
            prop="giveTimes"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeSignInBu"
          background
          @current-change="handleCurrentSignInBu"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSignInSupplementary"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>




      <!-- 预约记录 -->
      <el-tab-pane label="预约记录" name="fifteen" v-if="fitersChooseIF([33])">
        <!-- 头部表单查询 -->
        <input-form
          :inputData="inputDataThir3"
          @toParentVal="searchFormThir2"
          :btnPosition1="true"
          style="margin: 20px 0"
          ref="inputRef2"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(13)"
          >按查询结果生成人群</el-button
        >
        <!-- 表格 -->
        <el-table
          v-loading="loading"
          :data="exchangeList"
          style="width: 100%; margintop: 20px"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img
                src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
              />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column prop="chaosPin" label="用户pin（加密）" width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
          <el-table-column prop="joinTime" label="预约时间"></el-table-column>
          <el-table-column prop="isWin" label="中奖状态">
            <template slot-scope="scope">
              <span v-if="scope.row.isWin == 1">已中奖</span>
              <span v-if="scope.row.isWin == 0">未中奖</span>
              <span v-if="scope.row.isWin == 2">待开奖</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 表格分页 -->
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeExchange2"
          background
          @current-change="handleCurrentExchange2"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalMail"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 加购记录 -->
      <el-tab-pane
        label="加购记录"
        name="thirtyFour"
        v-if="fitersChooseIF([34])"
      >
        <input-form
          :inputData="inputDataAddCart"
          @toParentVal="searchAddCart"
          :btnPosition="true"
          :defaultSelectArr="true"
          style="margin: 20px 0"
        ></input-form>
        <div style="display: flex; margin-bottom: 20px; justify-content: space-between;">
          <el-button
            style="float: left; width: 150px"
            @click="addCrowd(2)"
            >按查询结果生成人群</el-button
          >
          <el-button @click="export_get">导出</el-button>
        </div>
        <el-table
          v-loading="loading"
          :data="addCartTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="chaosPin" label="用户pin（加密）" width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称"></el-table-column>
          <el-table-column
            prop="addCartTime"
            label="加购时间"
          ></el-table-column>
          <el-table-column
            prop="addCartNum"
            label="当前加购件数"
          ></el-table-column>
          <el-table-column label="是否满足领奖条件">
            <template slot-scope="scope">
              <span>{{ scope.row.isAllowGetPrize ? "满足" : "不满足" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否中奖">
            <template slot-scope="scope">
              <span>{{ scope.row.isWin ? "已中奖" : "未中奖" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="checkCartDetail(scope.row)"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeAddCart"
          background
          @current-change="handleCurrentAddCart"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalAddCart"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 锁权记录 -->
      <el-tab-pane label="锁权记录" name="eighteen" v-if="fitersChooseIF([35])">
        <input-form
          :inputData="inputLockRight"
          ref="export_fun18"
          @toParentVal="searchLockRight"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <div class="operate-wrap">
          <div class="operation-wrap-left">
            <el-button
              style="width: 150px"
              @click="addCrowd(16)"
              >按查询结果生成人群</el-button
            >
          </div>
          <div>
            <el-button
              @click="export_get"
              v-preventReClick
              >导出</el-button
            >
          </div>
        </div>
        <el-table
          v-loading="loading"
          :data="lockRightTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 20px auto 40px"
        >
          <el-table-column prop="pin" label="用户PIN"> </el-table-column>
          <el-table-column prop="activityName" label="活动名称">
          </el-table-column>
          <el-table-column prop="point" label="锁权积分"></el-table-column>
          <el-table-column prop="buyMoney" label="活动下单期间购买金额">
          </el-table-column>
          <el-table-column
            prop="buyOrder"
            label="活动下单期间购买订单数"
          ></el-table-column>
          <el-table-column
            prop="isPassStr"
            label="是否符合中奖门槛"
          ></el-table-column>
          <el-table-column
            prop="isEnterStr"
            label="是否录入收货信息"
          ></el-table-column>
          <el-table-column prop="createTime" label="锁权时间"></el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeLockRight"
          background
          @current-change="handleCurrentLockRight"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.totalLockRight"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>

      <!-- 解锁成功记录  -->
      <el-tab-pane label="解锁成功记录" name="twenty-two" v-if="fitersChooseIF([16])">
        <input-form
          :inputData="inputUnlock"
          ref="export_xdyl"
          @toParentVal="searchUnlock"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px"
          @click="exportTheData2"
          type="primary"
          v-preventReClick
          >导出</el-button
        >
        <el-table
           v-loading="loading"
          :data="UnlockTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="chaosPin" label="用户pin（加密）" width="150">
          </el-table-column>
          <el-table-column
            prop="memberNick"
            label="用户昵称"
            width="150"
          >
          </el-table-column>
         
          <el-table-column
            prop="activityName"
            label="活动名称"
          >
          </el-table-column>
          <el-table-column
            prop="unlockOrderId"
            label="订单号"
          >
          </el-table-column>

          <el-table-column
            prop="checkTime"
            label="解锁时间"
          >
          <!-- <template slot-scope="scope">
              <span v-if="scope.row.checkStartTime">{{scope.row.checkStartTime}} - {{ scope.row.checkEndTime }}</span>
              <span v-else> - </span>
            </template> -->
          </el-table-column>

        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleUnlockRecordSize"
          background
          @current-change="handleUnlockWinCurrent"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalAward"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 用户资料 -晒单有礼 -->
      <el-tab-pane label="用户资料" name="thirty-one" v-if="fitersChooseIF([41])">
        <div class="user-info-statics">
          用户资料
          <div class="user-info-statics-item">共提交{{postUserStaticsInfo.totalSubmitNum || 0}}份</div>
          <div class="user-info-statics-item">昨日提交{{postUserStaticsInfo.lastSubmitNum || 0}}份</div>
          <div class="user-info-statics-item">累计审核通过{{postUserStaticsInfo.passNum || 0}}份</div>
          <div class="user-info-statics-item">待审核{{postUserStaticsInfo.unProcessNum || 0}}份</div>
          <div class="user-info-statics-item">驳回{{postUserStaticsInfo.failNum || 0}}份</div>
        </div>
        <input-form
          :inputData="postOrdersInfoInput"
          @toParentVal="searchPostUserInfo"
          :btnPosition="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(20)"
          :disabled="!postOrderInfoTable.length"
          >按查询结果生成人群</el-button
        >
        <el-button
          style="float: left; margin-bottom: 20px; width: 120px"
          @click="onHandleProcess()"
          :disabled="!proccessSelectionArr.length"
          >批量审核</el-button
        >
        <el-button
          style="float: left; margin-bottom: 20px; width: 120px"
          @click="isShowUploadProccess=true"
          :disabled="!postOrderInfoTable.length"
          >上传审核结果</el-button
        >
        <el-button
          style="float: right; margin-bottom: 20px"
          @click="exportData()"
          v-preventReClick
          >导出</el-button
        >
        <el-table
          v-loading="loading"
          :data="postOrderInfoTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
           @selection-change="handlePoccessSelectionChange"
        >
          <el-table-column type="selection" width="55" :selectable="onPoccessSelectable"> </el-table-column>
          <el-table-column prop="id" label="提交记录id" minWidth="150"  width="150"> 
          </el-table-column>          
          <el-table-column prop="chaosPin" label="用户pin" minWidth="150"  width="150"> 
          </el-table-column>
          <el-table-column prop="chaosMemberNick" label="用户昵称">
          </el-table-column>
          <el-table-column prop="createTime" label="提交时间">
          </el-table-column>
          <template v-for="val in postRuleFieldsList">
            <el-table-column v-if="val == '姓名'" prop="chaosName" label="姓名" :key="val">
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.chaosName }}
                  <div
                    class="openHover"
                    v-if="scope.row.chaosName && scope.row.chaosName.indexOf('*') != -1"
                    @click="
                      handleDecrypt(
                        'chaosName',
                        'postOrderInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="val == '订单号'" prop="orderId" label="订单号" :key="val">
            </el-table-column>
            <el-table-column v-if="val == '评价截图'" prop="commentImage" label="评价截图" minWidth="300" :key="val">
              <template slot-scope="{ row }">
                <div class="commend-img-list">
                  <el-image class="commend-img" :src="item" v-for="item, index in row.commentImage.split(',')"
                :key="index" @click="onHandleProcess(row)"></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="val == '手机号'"  prop="chaosMobile" label="手机号" :key="val">
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.chaosMobile }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.chaosMobile && scope.row.chaosMobile.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'chaosMobile',
                        'postOrderInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="val == '地址'"  prop="chaosAddress" label="地址" :key="val">
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.chaosAddress }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.chaosAddress && scope.row.chaosAddress.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'chaosAddress',
                        'postOrderInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="val == '详细地址'"  prop="chaosDetailedAddress" label="详细地址" :key="val">
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.chaosDetailedAddress }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.chaosDetailedAddress &&
                      scope.row.chaosDetailedAddress.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'chaosDetailedAddress',
                        'postOrderInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
           </el-table-column>
           <!-- <el-table-column v-if="val == '扩展信息'" minWidth="0" width="0" :key=val>
            <template slot-scope="scope1">
            <el-table-column
              minWidth="150"
              v-for="(item,index) in formatExtendInfo(scope1.row.extendInfo)" 
              :key="index"
              prop="value"
              :label="item.name"
            >
              <template slot-scope="scope">
                <div style="display: flex;flex-wrap: wrap;">
                  <div class="info">
                    <template v-if="item.type==2">
                      <div class="img-parent" v-for="(child,cIndex) in item.value.split(',')" :key="cIndex">
                        <el-image class="info-img" :src="child" :preview-src-list="[child]"></el-image>                  
                      </div>
                    </template>
                    <span v-else style="margin-left: 4px;">{{item.value}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
          </template>
           </el-table-column> -->
          </template>
          <!-- 扩展信息 -->
          <template v-for="(item,index) in postOrderInfoTable.length ? postOrderInfoTable[0].staticInfoNames : []">
            <el-table-column :label="item.name" minWidth="300" :key="index">
              <template slot-scope="scope">
                <div style="display: flex;flex-wrap: wrap;">
                  <div class="info">
                    <template v-if="item.type==2">
                      <div class="img-parent" v-for="(child,cIndex) in getStaticInfoNames(item,scope.row.staticInfoNames).split(',')" :key="cIndex">
                        <el-image class="info-img" :src="child" @click="onHandleProcess(scope.row)"></el-image>                  
                      </div>
                    </template>
                    <span v-else style="margin-left: 4px;">{{getStaticInfoNames(item,scope.row.staticInfoNames)}}</span>
                  </div>
                </div>
              </template>
           </el-table-column>
          </template>
          <el-table-column prop="processStatus" label="审核状态">
            <template slot-scope="scope">
              <span v-if="scope.row.processStatus==0">待审核</span>
              <span v-if="scope.row.processStatus==1">已通过</span>
              <span v-if="scope.row.processStatus==2">已驳回</span>
              <span v-if="scope.row.processStatus==-1">待参与</span>
            </template>
          </el-table-column>
          <el-table-column label="审核备注" width="200">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.processRemark"
                placement="top-start"
              >
                <div class="remark-tip">{{ scope.row.processRemark}}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="processTime" label="审核时间">
          </el-table-column>
          <el-table-column label="操作" align="left">
            <template slot-scope="scope">
              <el-button class="w30" type="text" :disabled="scope.row.processStatus==1" @click="onHandleProcess(scope.row)">审核</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizePostUserInfo"
          background
          @current-change="handleCurrentPostUserInfo"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalPostOrderUserInfo"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 中奖纪录 -->
      <el-tab-pane
        :label="
          fitersRepurchase([16, 17, 18, 23, 24, 27, 28, 44], '领奖记录', '中奖记录')
        "
        name="third"
        v-if="
          fitersChooseIF(
            [13, 14, 15, 21, 25, 9, 10, 29, 30, 31, 32, 33, 35, 36, 37, 38, 39, 50,55,58,59,60,61],
            '!='
          )
        "
      >
        <!-- 奖品预览 -->
        <prizeList v-if="activeName == 'third'" :activityId="rowData.id"/>
        <!-- 明细 -->
        <div class="award-title">
          <span>{{fitersRepurchase([16, 17, 18, 23, 24, 27, 28], '领奖记录', '中奖记录')}}明细</span>
        </div>
        <input-form
          ref="awardRef"
          :inputData="getRewardInputData()"
          :defaultSelectArr="true"
          @toParentVal="searchAwardOne"
          :btnPosition2="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(3)"
          :disabled="!awardTable.length"
          >按查询结果生成人群</el-button
        >
        <el-button
          style="float: left; margin-bottom: 20px; width: 120px"
          @click="batchMark(2)"
          v-preventReClick
          :disabled="!awardTable.length"
          >批量标记发放</el-button
        >
        <el-button
          style="float: left; margin-bottom: 20px"
          @click="exportTheData"
          v-preventReClick
          :disabled="!awardTable.length"
          >导出</el-button
        >
        <el-table
          v-loading="loading"
          :data="awardTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="chaosPin" label="用户pin（加密）" width="210">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称" width="210">
          </el-table-column>
          <el-table-column
            prop="activityName"
            label="活动名称"
            v-if="rowData.activityType != 6 && rowData.activityType != 5"
          >
          </el-table-column>
          <!-- rowData.activityType == 5   邀请开卡有礼 -->
          <!-- <el-table-column prop="inviteNick" label="被邀请人昵称" width="150" v-if=" rowData.activityType == 6">
          </el-table-column> -->
          <el-table-column label="奖品类型">
            <template slot-scope="scope">
              <span>{{getPrizeTypeName(scope.row.prizeType)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="prizeName" label="奖品名称" width="210">
          </el-table-column>
          <template v-if="fitersChooseIF([16, 17, 18, 19, 27, 28])">
            <el-table-column width="210">
              <template slot="header">
                <div>
                  订单号
                  <el-popover v-if="rowData.activityType == 16" placement="bottom" width="100%" trigger="hover">
                    <div class="referencePopover">
                      <span>梯度奖品会显示所有解锁成功且满足领奖条件的订单号</span>
                    </div>
                    <span slot="reference">
                      <p class="question_iconOne">?</p>
                    </span>
                  </el-popover>
                </div>
              </template>
              <template slot-scope="scope">
                <!-- 下单有礼页面 -->
                <el-popover v-if="rowData.activityType == 16" placement="bottom" width="100%" trigger="hover">
                  <div class="referencePopover" v-for="(item,idx) in scope.row.orderList" :key="idx">
                    <span>订单号：{{ item.orderId }}</span>
                    <span>订单金额：{{ item.price }}元</span>
                    <span>订单状态：{{ item.orderState }}</span>
                  </div>
                  <span class="referenceButton" slot="reference">{{
                    scope.row.unlockOrderIdStr
                  }}</span>
                </el-popover>
                <!-- 非下单有礼页面 -->
                <el-popover v-else placement="bottom" width="100%" trigger="hover">
                  <div class="referencePopover" v-for="(item,idx) in scope.row.orderList" :key="idx">
                    <span>订单号：{{ item.orderId }}</span>
                    <span>订单金额：{{ item.price }}元</span>
                    <span>订单状态：{{ item.orderState }}</span>
                  </div>
                  <span class="referenceButton" slot="reference">{{
                    scope.row.unlockOrderId
                  }}</span>
                </el-popover>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="订单号" prop="unlockOrderId" v-if="fitersChooseIF([41])" width="100">
          </el-table-column>
          <!-- 下单抽奖-白名单 -->
          <el-table-column label="是否白名单" v-if="fitersChooseIF([19])" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.isWhite == 1">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="rowData.activityType != 5 && rowData.activityType != 6"
            :label="fitersRepurchase([16, 17, 18, 27 , 44], '领奖时间', '参与时间')"
            width="210"
          >
            <template slot-scope="scope">
              {{ scope.row.joinTime || "--" }}
            </template>
          </el-table-column>

          <!-- Note----参与时间改为奖时间 -->
          <el-table-column
            v-if="rowData.activityType == 5 || rowData.activityType == 6"
            label="中奖时间"
            width="210"
          >
            <template slot-scope="scope">
              {{
                rowData.activityType == 6
                  ? scope.row.joinTime
                  : scope.row.grantTime || "--"
              }}
            </template>
          </el-table-column>

          <el-table-column
            label="发放时间"
            width="210"
            v-if="fitersChooseIF([16, 17, 18, 19, 27, 28, 41, 44])"
          >
            <template slot-scope="scope">
              {{ scope.row.grantTime || "--" }}
            </template>
          </el-table-column>
          <!-- Note--C端优化邀请开发有礼去除 -->
          <!-- <el-table-column prop="mobile" label="手机号" width="150" v-if="rowData.activityType == 5">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.mobile }}
                <div
                  class="openHover"
                  v-if="scope.row.mobile && scope.row.mobile.indexOf('*') != -1"
                  @click="handleDecrypt('mobile', 'awardTable', scope.row, scope.$index)"
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            :label="fitersRepurchase([16, 17, 18, 27], '发放状态', '中奖状态')"
            width="130"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status == -1" class="y2">
                {{ fitersChooseIF([44], '!=')?'待领取':''}}
                </span>
              <span v-if="scope.row.status == 0">-</span>
              <span v-if="scope.row.status == 1" class="y1">未中奖</span>
              <span v-if="scope.row.status == 2" class="y2">
                {{ fitersChooseIF([16, 17, 18, 27]) ? "待发放" : "已中奖" }}
              </span>
              <span v-if="scope.row.status == 3" class="y4">已发放</span>
              <span v-if="scope.row.status == 4" class="y3">发放失败</span>
              <span v-if="scope.row.status == 5" class="y4">已发放</span>
              <span v-if="scope.row.status == 6" class="y4">已发放</span>
              <span v-if="scope.row.status == 7" class="y2">待发放</span>
              <span v-if="scope.row.status == 8" class="y1">已失效</span>
              <el-tooltip effect="dark" v-if="scope.row.status == 4" :content="scope.row.failReason" placement="top-start">
                <i
                  style="color: #ccc"
                  v-if="scope.row.status == 4"
                  class="el-icon-question"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            v-if="fitersChooseIF([16, 17, 18, 19, 27, 28], '!=')"
          >
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == 1"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
              > -->
              <el-button
               class="w60"
                type="text"
                v-if="scope.row.status == 4"
                @click="markIss(scope.row)"
                >标记发放</el-button
              >
              <el-button
                class="w60"
                type="text"
                v-if="scope.row.status == 6"
                @click="markIss(scope.row)"
                >取消发放</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" v-else>
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == 1"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
              > -->
              <el-button
                class="w60"
                type="text"
                v-if="scope.row.status == 4"
                @click="markIss(scope.row)"
                >标记发放</el-button
              >
              <el-button
                class="w60"
                type="text"
                v-if="scope.row.status == 6"
                @click="markIss(scope.row)"
                >取消发放</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeAward"
          background
          @current-change="handleCurrentAward"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalAward"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 中奖纪录 -->
      <el-tab-pane label="中奖记录" name="third" v-if="fitersChooseIF([33])">
        <!-- 奖品预览 -->
        <prizeList v-if="activeName == 'third'" :activityId="rowData.id"/>
        <!-- 明细 -->
        <div class="award-title">
          <span>中奖记录明细</span>
        </div>
        <input-form
          :inputData="inputAwardTwo"
          ref="export_fun33"
          @toParentVal="searchAwardOne"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(3)"
          >按查询结果生成人群</el-button
        >
        <el-button
          style="float: left; margin-bottom: 20px; width: 120px"
          @click="batchMark(1)"
          v-preventReClick
          >批量标记发货</el-button
        >
        <!-- <el-button style="float: left; margin-bottom: 20px" @click="getApi_Exprot" v-preventReClick>导出</el-button> -->
        <el-button
          style="float: left; margin-bottom: 20px"
          @click="export_get"
          v-preventReClick
          >导出</el-button
        >
        <el-table
          v-loading="loading"
          :data="awardTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="chaosPin" label="用户pin（加密）" width="180">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称" width="180">
          </el-table-column>
          <el-table-column prop="prizeTitle" label="奖品名称" width="180">
          </el-table-column>
          <el-table-column
            prop="isFillAddress"
            label="是否填写地址"
            width="180"
          ></el-table-column>
          <el-table-column prop="joinTime" label="预约时间" width="280">
          </el-table-column>
          <el-table-column prop="grantTime" label="发货时间" width="280">
          </el-table-column>
          <el-table-column prop="grantTime" label="发货状态">
            <template slot-scope="scope">
              {{ scope.row.status == 5 ? "已发货" : "未发货" }}
            </template>
          </el-table-column>
          <el-table-column prop="receiverName" label="收件人">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverName }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.receiverName &&
                    scope.row.receiverName.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverName',
                      'awardTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="receiverMobile"
            label="收件人手机号"
            width="120"
          >
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverMobile }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.receiverMobile &&
                    scope.row.receiverMobile.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverMobile',
                      'awardTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="receiverAddress"
            label="收件人地址"
            width="210"
          >
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverAddress }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.receiverAddress &&
                    scope.row.receiverAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverAddress',
                      'awardTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="detailedAddress"
            label="收件人详细地址"
            width="210"
          >
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.detailedAddress }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.detailedAddress &&
                    scope.row.detailedAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'detailedAddress',
                      'awardTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            v-if="fitersChooseIF([16, 17, 18, 19, 27, 28], '!=')"
          >
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == 1"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
              > -->
              <el-button
                type="text"
                v-if="
                  (scope.row.status == 2 || scope.row.status == 7) &&
                  scope.row.recordId
                "
                @click="markIss(scope.row)"
                style="text-align: left; width: 100"
                >标记发货</el-button
              >
              <el-button
                type="text"
                v-if="scope.row.status == 5"
                @click="markIss(scope.row)"
                style="text-align: left; width: 100"
                >取消发货</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="操作"  v-else>
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == 1"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
              > -->
              <el-button
                type="text"
                v-if="scope.row.status == 4 || scope.row.status == 7"
                @click="markIss(scope.row)"
                >标记发放</el-button
              >
              <el-button
                type="text"
                v-if="scope.row.status == 6 || scope.row.status == 5"
                @click="markIss(scope.row)"
                >取消发放</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeAward"
          background
          @current-change="handleCurrentAward"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalAward"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 中奖纪录 积分锁权 -->
      <el-tab-pane label="中奖记录" name="sixteen" v-if="fitersChooseIF([35,37])">
        <!-- 奖品预览 -->
        <prizeList v-if="activeName == 'sixteen'" :activityId="rowData.id"/>
        <!-- 明细 -->
        <div class="award-title">
          <span>中奖记录明细</span>
        </div>
        <input-form
          :inputData="inputAwardFour"
          ref="export_fun16"
          @toParentVal="searchAwardFour"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <div class="operate-wrap">
          <div class="operation-wrap-left">
            <el-button
              style="width: 150px"
              @click="addCrowd(3)"
              >按查询结果生成人群</el-button
            >
            <el-button
              style="width: 120px"
              @click="batchLock()"
              v-preventReClick
              >批量发货</el-button
            >
          </div>
          <div>
            <el-button
              @click="export_get"
              v-preventReClick
              >导出</el-button
            >
          </div>
        </div>
        <el-table
          v-loading="loading"
          :data="awardTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 20px auto 40px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column prop="pin" label="用户PIN" width="120">
          </el-table-column>
          <el-table-column prop="activityName" label="活动名称">
          </el-table-column>
          <el-table-column prop="memberNick" label="姓名">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.memberNick }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.memberNick &&
                    scope.row.memberNick.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'memberNick',
                      'awardTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号码" width="120">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.mobile }}
                <div
                  class="openHover"
                  v-if="scope.row.mobile && scope.row.mobile.indexOf('*') != -1"
                  @click="
                    handleDecrypt(
                      'mobile',
                      'awardTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverAddress" label="地区" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverAddress }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.receiverAddress &&
                    scope.row.receiverAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverAddress',
                      'awardTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="detailedAddress" label="详细地址" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.detailedAddress }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.detailedAddress &&
                    scope.row.detailedAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'detailedAddress',
                      'awardTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sendStatusStr" label="发放状态">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间">
          </el-table-column>
          <el-table-column prop="sendTime" label="发放时间"> </el-table-column>
          <el-table-column prop="deliveryStatusStr" label="发货状态">
          </el-table-column>
          <el-table-column prop="billCode" label="快递单号"> </el-table-column>
          <el-table-column prop="deliveryTime" label="发货时间">
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == 1"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
              > -->
              <el-button
                type="text"
                v-if="scope.row.sendStatus == 1"
                @click="sendGoods(scope.row)"
                style="text-align: left"
                >发货</el-button
              >
              <el-button type="text" v-else style="text-align: left" disabled
                >发货</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeAward"
          background
          @current-change="handleCurrentAward"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalAward"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 领奖记录 下单冲榜  -->
      <el-tab-pane label="领奖记录(冲榜)" name="twenty-one" v-if="fitersChooseIF([36])">
        <!-- 奖品预览 -->
        <prizeList v-if="activeName == 'twenty-one'" :activityId="rowData.id"/>
        <!-- 明细 -->
        <div class="award-title">
          <span>领奖记录明细</span>
        </div>
        <input-form
          :inputData="inputAwardFiften"
          ref="export_fun_lj2"
          @toParentVal="searchAwardFifteen"
          :btnPosition1="true"
          :defaultSelectArr="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(3)"
          >按查询结果生成人群</el-button
        >
        <el-button
          style="float: left; margin-bottom: 20px"
          @click="export_get"
          type="primary"
          v-preventReClick
          >导出</el-button
        >
        <el-table
           v-loading="loading"
          :data="activityTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="chaosPin" label="用户pin（加密）" width="150">
          </el-table-column>
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :width="item.width ? item.width : '160'"
            :key="index"
            v-for="(item, index) in chongBangAwardList"
          >
            <template slot="header" v-if="item.prop == 'totalPayMoney' || item.prop == 'totalFinishMoney' ">
                <span>{{item.label}}</span>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="自营店铺为订单金额，POP店铺统计规则以活动实际设置为准"
                  placement="top"
                >
                  <span class="question_iconOne">?</span>
                </el-tooltip>
            </template>
            <template v-if="item.prop=='orderIdStr'" slot-scope="scope">
                <el-tooltip effect="light" :content="scope.row.orderIdStr" placement="top">
                  <div class="two-line">{{ scope.row.orderIdStr }}</div>
                </el-tooltip>
             </template>
             <template slot-scope="scope">
              <span>{{scope.row[`${item.prop}`]}}</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="chongBangAwardMark(scope.row)" v-if="scope.row.status == 4">
                标记发放</el-button
              >
              <el-button @click="chongBangAwardMark(scope.row)" v-if="scope.row.status == 6">
                取消发放</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleFifteenWinRecordSize"
          background
          @current-change="handleFifteenWinCurrent"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formExtra.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalAward"
          :current-page="formExtra.current"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="领奖记录(额外奖品)" name="twenty-three" v-if="fitersChooseIF([36])&&isShowExtraWinRecord">
        <!-- 明细 -->
        <div class="award-title">
          <span>领奖记录明细</span>
        </div>
        <input-form
          :inputData="inputAwardExtra"
          ref="export_fun_extra"
          @toParentVal="searchAwardExtra"
          :btnPosition1="true"
          :defaultSelectArr="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(3)"
          >按查询结果生成人群</el-button
        >
        <el-button
          style="float: left; margin-bottom: 20px"
          @click="export_get"
          type="primary"
          v-preventReClick
          >导出</el-button
        >
        <el-table
           v-loading="loading"
          :data="activityTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="chaosPin" label="用户pin（加密）" width="150">
          </el-table-column>
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :key="index"
            v-for="(item, index) in chongBangExraAwardList"
          >
             <template slot-scope="scope">
              <span>{{scope.row[`${item.prop}`]}}</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="chongBangAwardMark(scope.row)" v-if="scope.row.status == 4">
                标记发放</el-button
              >
              <el-button @click="chongBangAwardMark(scope.row)" v-if="scope.row.status == 6">
                取消发放</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleFifteenWinRecordSize"
          background
          @current-change="handleFifteenWinCurrent"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalAward"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 收货信息 锁权和派样回购-->
      <el-tab-pane
        label="收货信息"
        name="seventeen"
        v-if="fitersChooseIF([35, 37])"
      >
        <input-form
          :inputData="inputTakeGoods"
          ref="export_fun17"
          @toParentVal="searchTakeGoods"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <div class="operate-wrap">
          <div class="operation-wrap-left">
            <el-button
              style="width: 150px"
              @click="addCrowd(3)"
              >按查询结果生成人群</el-button
            >
          </div>
          <div>
            <el-button
              @click="export_get"
              v-preventReClick
              >导出</el-button
            >
          </div>
        </div>
        <el-table
          v-loading="loading"
          :data="takeGoodsTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 20px auto 40px"
        >
          <el-table-column prop="pin" label="用户PIN" width="120">
          </el-table-column>
          <el-table-column prop="activityName" label="活动名称">
          </el-table-column>
          <el-table-column prop="memberNick" label="姓名">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.memberNick }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.memberNick &&
                    scope.row.memberNick.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'memberNick',
                      'takeGoodsTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号码" width="120">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.mobile }}
                <div
                  class="openHover"
                  v-if="scope.row.mobile && scope.row.mobile.indexOf('*') != -1"
                  @click="
                    handleDecrypt(
                      'mobile',
                      'takeGoodsTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverAddress" label="地区" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverAddress }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.receiverAddress &&
                    scope.row.receiverAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverAddress',
                      'takeGoodsTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="detailedAddress" label="详细地址" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.detailedAddress }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.detailedAddress &&
                    scope.row.detailedAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'detailedAddress',
                      'takeGoodsTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="inputTime" label="录入时间"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="editAddress(scope.row)"
                style="text-align: left"
                >修改</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeTakeGoods"
          background
          @current-change="handleCurrentTakeGoods"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.totalTakeGoods"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 实物奖品 -->
      <!-- <el-tab-pane label="实物奖品名单" name="four" v-if="fitersChooseIF([1, 3, 4, 5, 6, 7, 8, 16, 17, 18, 19, 20, 22, 23, 24, 26])"> -->
      <el-tab-pane
        label="实物奖品名单"
        name="four"
        v-if="
          fitersChooseIF(
            [13, 14, 15, 21, 25, 9, 10, 29, 30, 31, 32, 33, 35, 36, 37, 38, 39, 50,55,58,59,60,61],
            '!='
          )
        "
      >
      <!-- 领奖记录 首单 复购 下单 预售有礼 下单抽奖（中奖记录） -->
        <input-form
          :inputData="getMaterialInputData()"
          @toParentVal="searchInkind"
          @export_get="export_get"
          ref="export_fun_sw"
          :btnPosition1="true"
          style="margin: 20px 0"
          :defaultSelectArr="true"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(4)"
          :disabled="!inkindTable.length"
          >按查询结果生成人群</el-button
        >
        <el-button
          style="float: left; margin-bottom: 20px; width: 120px"
          @click="batchMarkForShipment"
          v-preventReClick
          :disabled="!inkindTable.length"
          >批量标记发货</el-button
        >
        <el-button
          style="float: right; margin-bottom: 20px"
          @click="export_fun"
          v-if="
            this.permissions &&
            this.permissions.indexOf('receiving:info:export') != '-1'
          "
          v-preventReClick
          >导出</el-button
        >
        <el-table
          v-loading="loading"
          :data="inkindTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          @selection-change="handleSelectionChange"
          style="width: 100%; margin: 10px auto"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="chaosPin" label="用户pin（加密）" width="180">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称" width="180">
          </el-table-column>
          <el-table-column prop="recordId" label="中奖ID" width="180">
          </el-table-column>
          <el-table-column prop="prizeTitle" label="奖品名称" width="180">
          </el-table-column>
          <el-table-column label="商品信息" width="300">
            <template slot-scope="scope">
              <div class="goodsInfo">
                 <div class="goodsInfo_logo">
                  <img :src="scope.row.logo" alt="" />
                </div>
                <template v-if="scope.row.isGoodManage!=1">
                  <div
                    class="goodsInfo_text"
                    @click="jumpTo"
                    v-if="scope.row.skuId"
                  >
                    <a
                      :href="`http://item.jd.com/${scope.row.skuId}.html`"
                      target="_blank"
                      >{{ scope.row.skuName }}<br />
                      <span style="color: #666666"
                        >skuId:{{ scope.row.skuId }}</span
                      >
                    </a>
                  </div>
                  <div class="goodsInfo_text" v-else>
                    <div>{{ scope.row.title }}</div>
                  </div>
              </template>
              <template v-else>
                <div
                  class="goodsInfo_text"
                  @click="jumpTo"
                  v-if="scope.row.assetsId"
                >
                  <a
                    @click="handleToGoods(scope.row.assetsId)"
                    target="_blank"
                    >{{ scope.row.title }}<br />
                    <span style="color: #666666"
                      >id:{{ scope.row.assetsId }}</span
                    >
                  </a>
                </div>
                <div class="goodsInfo_text" v-else>
                  <div>{{ scope.row.title }}</div>
                </div>
              </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="rowData.activityType !=41 && rowData.activityType != 44"
            prop="sendTime"
            :label="
              fitersRepurchase([16, 17, 18, 19, 27, 28], '领奖时间', '中奖时间')
            "
            width="280"
          >
          </el-table-column>
          <el-table-column prop="prizeStatus" :label="fitersChooseIF([16,18,17,27])? '发放状态': '中奖状态'" width="280" v-if="fitersChooseIF([16,18,17,19,27,28])">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeStatus == -1" class="y2">待领取</span>
              <span v-if="scope.row.prizeStatus == 0">-</span>
              <span v-if="scope.row.prizeStatus == 1" class="y1">未中奖</span>
              <span v-if="scope.row.prizeStatus == 2" class="y2">
                {{ fitersChooseIF([19]) ? "已中奖" : "待发放" }}
              </span>
              <span v-if="scope.row.prizeStatus == 3" class="y4">已发放</span>
              <span v-if="scope.row.prizeStatus == 4" class="y3">发放失败</span>
              <span v-if="scope.row.prizeStatus == 5" class="y4">已发放</span>
              <span v-if="scope.row.prizeStatus == 6" class="y4">已发放</span>
              <span v-if="scope.row.prizeStatus == 7" class="y2">待发放</span>
              <span v-if="scope.row.prizeStatus == 8" class="y1">已失效</span>
            </template>
          </el-table-column>
          <el-table-column prop="grantTime" label="发货时间" width="280">
          </el-table-column>
          <el-table-column prop="grantTime" label="发货状态">
            <template slot-scope="scope">
              {{ scope.row.status == 5 ? "已发货" : "未发货" }}
            </template>
          </el-table-column>
          <el-table-column prop="receiverName" label="收件人">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverName ?scope.row.receiverName :'-' }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverName &&
                    scope.row.receiverName.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverName',
                      'inkindTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="receiverMobile"
            label="收件人手机号"
            width="120"
          >
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverMobile ?scope.row.receiverMobile :'-' }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverMobile &&
                    scope.row.receiverMobile.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverMobile',
                      'inkindTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="receiverAddress"
            label="收件人地区"
            width="210"
          >
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverAddress ? scope.row.receiverAddress :'-'  }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverAddress &&
                    scope.row.receiverAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverAddress',
                      'inkindTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="detailedAddress"
            label="收件人详细地址"
            width="210"
          >
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.detailedAddress ?scope.row.detailedAddress :'-' }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.detailedAddress &&
                    scope.row.detailedAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'detailedAddress',
                      'inkindTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverCode" label="邮编" v-if="rowData.activityType !=41 && rowData.activityType != 44"> </el-table-column>
          <el-table-column prop="billCode" label="快递单号"> </el-table-column>
          <el-table-column label="操作" width="450">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == 5" @click="markIss(scope.row)"><i class="y4"></i>取消发货</span>
              <span v-if="scope.row.status == '2,7'" @click="markIss(scope.row)"><i class="y3"></i>标记发货</span> -->
              <el-button
                type="text"
                v-if="scope.row.status == 5"
                @click="markIss(scope.row)"
                class="w60"
                >取消发货</el-button
              >
              <el-button
                type="text"
                v-if="(scope.row.status == '2' || scope.row.status == '7') && scope.row.id"
                @click="markIss(scope.row)"
                class="w60"
                >标记发货</el-button
              >
              <el-button
                type="text"
                v-if="(scope.row.status == '2' || scope.row.status == '7') && !scope.row.id"
                style="color: #666666;"
                >标记发货</el-button
              >
              <!-- 京获客v2.5迭代：快递单号登记 -->
              <el-button type="text" @click="handleEnterCoutierNum(scope.row)" v-if=" scope.row.id"
                >录入快递单号</el-button
              >
              <el-button type="text" style="color: #666666;" v-else
                >录入快递单号</el-button
              >
              <!-- <el-popconfirm
                  style="margin-left: 8px"
                  icon="el-icon-message-solid"
                  v-if="scope.row.prizeStatus === 7 || scope.row.prizeStatus === 2 || scope.row.prizeStatus === 3 || scope.row.prizeStatus === 6 || scope.row.prizeStatus === 5"
                  @confirm="revocationprize(scope.row)"
                  :title="`您的奖品状态为${scope.row.prizeStatus === 2 || scope.row.prizeStatus === 7 ? '待发放' : '已发放'}，是否进行撤回！`"
                >
                  <el-button
                    slot="reference" 
                    type="text"
                    class="w60"
                    >撤回奖品</el-button
                  >
              </el-popconfirm> -->
              <el-button 
                type="text" 
                @click="revocationprize(scope.row)"
                v-if="scope.row.prizeStatus === 7 || scope.row.prizeStatus === 2 || scope.row.prizeStatus === 3 || scope.row.prizeStatus === 6 || scope.row.prizeStatus === 5"
                >撤回奖品</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeInkind"
          background
          @current-change="handleCurrentInkind"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalInkind"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>

      <!-- 登记生日信息 -->
      <el-tab-pane
        label="登记生日信息"
        name="birthInfo"
        v-if="fitersChooseIF([39])"
      >
        <birthInfo ref="birthInfoRef" v-if="activeName == 'birthInfo'" :activityId="rowData.id" @exportTheData="exportTheData" @addCrowd="addCrowd"/>
      </el-tab-pane>
      <!-- 领取记录 -->
      <el-tab-pane
        label="领取记录"
        name="getRecord"
        v-if="fitersChooseIF([39])"
      >
        <!-- 奖品预览 -->
        <prizeList v-if="activeName == 'getRecord'" :activityId="rowData.id"/>
        <!-- 明细 -->
        <div class="award-title">
          <span>领取记录明细</span>
        </div>
        <input-form
          :inputData="getRecordForm"
          @toParentVal="searchFormRecord"
          :btnPosition1="true"
          style="margin: 20px 0"
        >
        </input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(3)"
          >按查询结果生成人群</el-button
        >
        <el-button
            style="margin-bottom: 20px"
            @click="exportTheData"
            type="primary"
            v-preventReClick
            >导出</el-button
          >
        <!-- 表格 -->
        <el-table
          v-loading="loading"
          :data="getRecordList"
          style="width: 100%; margintop: 20px"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img
                src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
              />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column prop="chaosPin" label="用户pin（加密）"  width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
          <el-table-column prop="memberNick" label="登记生日">
            <template slot-scope="scope">
              <span>{{scope.row.birthDay?scope.row.birthDay.split(" ")[0]:'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="activityName" label="活动名称">
          </el-table-column>
          <el-table-column label="领奖类型">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeObjectType  == 0">生日奖品</span>
              <span v-else-if="scope.row.prizeObjectType == 1">兜底奖品</span>
              <span v-else>/</span>
            </template>
          </el-table-column>
          <el-table-column prop="prizeType" label="奖品类型">
            <template slot-scope="scope">
              <span>{{getPrizeTypeName(scope.row.prizeType)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="prizeName" label="奖品名称">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeName"> {{scope.row.prizeName}} </span>
              <span v-else> - </span>
            </template>
          </el-table-column>
          <el-table-column  label="生日池奖品">
            <template slot-scope="scope">
              <span v-if="scope.row.birthGiftPrize">
                <el-tooltip
                  placement="top"
                  popper-class="new-tooltip-width"
                >
                  <div slot="content">
                    {{ scope.row.birthGiftPrize }}
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-left: 5px;
                      width: 140px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    "
                  >
                  {{ scope.row.birthGiftPrize }}
                  </div>
                </el-tooltip>
              </span>
              <span v-else> - </span>
            </template>
          </el-table-column>
          <el-table-column prop="joinTime" label="参与时间"></el-table-column>
          <el-table-column prop="status" label="中奖状态">
            <template slot-scope="scope">
              <span>{{ scope.row.statusStr }}</span>
              <!-- <span v-if="scope.row.status == 2">已中奖</span>
              <span v-if="scope.row.status == 3 || scope.row.status == 5 || scope.row.status == 6">已发放</span>
              <span v-if="scope.row.status == 4">发放失败</span> -->
            </template>
          </el-table-column>
          <el-table-column prop="winTime" label="领奖时间"> </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="recordMark(scope.row)" v-if="scope.row.status == 4">
                标记发放</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <!-- 表格分页 -->
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeExchangeRecord"
          background
          @current-change="handleCurrentExchangeRecord"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formListRecord.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRecord"
          :current-page="formListRecord.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 收集机会获取记录 -->
      <el-tab-pane
        label="收集机会获取记录"
        name="collectOpportunities"
        v-if="fitersChooseIF([39])"
      >
        <collectOpportunitiesRecord ref="collectOpportunitiesRef" v-if="activeName == 'collectOpportunities'"  :activityId="rowData.id" @addCrowd="addCrowd" @exportTask="exportTheData"/>
     </el-tab-pane>
      <!-- 下单冲榜实物奖品名单-->
      <el-tab-pane
        label="实物奖品名单"
        name="twenty"
        v-if="fitersChooseIF([36,39])"
      >
        <!-- 下单冲榜（领奖记录）-生日有礼39区分 -->
        <input-form
          :inputData="rowData.activityType == 39?inputInkind3:inputInkind2"
          @toParentVal="searchGoodRecordsPage"
          ref="export_fun_sw2"
          :btnPosition1="true"
          style="margin: 20px 0"
          :defaultSelectArr="true"
        ></input-form>
        <el-button
          v-if="rowData.activityType != 39"
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(4)"
          >按查询结果生成人群</el-button
        >
        <el-button
          style="float: left; margin-bottom: 20px; width: 120px"
          type="primary"
          @click="physicalBatchShipment"
          v-preventReClick
          >批量发货</el-button
        >
        <el-button
          style="float: left; margin-bottom: 20px"
          @click="export_get"
          type="primary"
          v-preventReClick
          >导出</el-button
        >
        <!-- 表格 -->
        <el-table
          :data="goodsRecordTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
          v-loading="loading"
        >
          <!-- <el-table-column
            v-if="rowData.activityType != 39"
            prop="pin"
            label="用户PIN"
            width="150"
          > -->
          <el-table-column prop="chaosPin" label="用户pin（加密）" width="150">
            <!-- <template slot-scope="scope">
              <div class="open">
                {{ scope.row.pin }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.pin &&
                    scope.row.pin.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'pin',
                      'activityTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div>
              </div>
            </template> -->
          </el-table-column>
          <el-table-column
            prop="memberNick"
            label="用户昵称"
            width="200"
          ></el-table-column>
          <el-table-column
            v-if="rowData.activityType == 39"
            prop="recordId"
            label="中奖ID"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="prizeTitle"
            label="奖品名称"
            width="200"
          ></el-table-column>
          <el-table-column
            v-if="rowData.activityType == 36"
            label="相关订单"
            width="200"
          >
            <template slot-scope="scope">
            <el-button size="small" type="text" @click="handleCheckOrderDetail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            v-if="rowData.activityType == 36"
          >
          <template slot="header" slot-scope="scope">
            <span>附加信息</span>
            <!-- <el-tooltip
              effect="dark"
              :content="getData"
              placement="top-start"
            >
              <i
                style="color: #ccc"
                class="el-icon-question"
              ></i>
            </el-tooltip> -->
          </template>

           <template slot-scope="scope">
            <div v-if="scope.row.shouldCollectExtraData==1">
              <div v-html="getAnswerText(scope.row)"></div>
            </div>
            <div v-else>-</div>
           </template>
          </el-table-column>
          <el-table-column
            prop="receiverName"
            label="姓名"
            width="150"
          >
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverName }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverName &&
                    scope.row.receiverName.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverName',
                      'goodsRecordTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="rowData.activityType == 39"
            prop="receiverMobile"
            label="手机号码"
            width="150"
          >
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverMobile }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverMobile &&
                    scope.row.receiverMobile.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverMobile',
                      'goodsRecordTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号码"
            width="150"
            v-else
          >
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.mobile }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.mobile &&
                    scope.row.mobile.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'mobile',
                      'goodsRecordTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="rowData.activityType == 39"
            prop="receiverAddress"
            label="地区"
            width="200"
          >
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverAddress }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverAddress &&
                    scope.row.receiverAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverAddress',
                      'goodsRecordTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="detailedAddress"
            label="详细地址"
            width="200"
          >
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.detailedAddress }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.detailedAddress &&
                    scope.row.detailedAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'detailedAddress',
                      'goodsRecordTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :width="item.width ? item.width : '150'"
            :key="index"
            v-for="(item, index) in rowData.activityType == 39?chongBangPhysicalList2:chongBangPhysicalList"
          >
          <template slot-scope="scope" >
            <div v-if="rowData.activityType != 39">
              <span v-if="item.prop == 'prizeStatus'">{{ scope.row.prizeStatusStr }}</span>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </div>
            <div v-if="rowData.activityType == 39">
              {{ scope.row[item.prop] }}
            </div>
          </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="chongBangPhysicalMark(scope.row)" size="small">
                发货</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleGoodsRecordSize"
          background
          @current-change="handleGoodsRecordCurrent"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalAward"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>

      <!-- 资料明细 -->
      <el-tab-pane label="用户资料明细" name="five" v-if="fitersChooseIF([7])">
        <input-form
          :inputData="inputUserInfo"
          @toParentVal="searchUserInfo"
          :btnPosition="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: right; margin-bottom: 20px"
          @click="getphone()"
          v-preventReClick
          >导出</el-button
        >
        <el-table
          :data="userInfoTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="chaosPin" label="用户pin（加密）" minWidth="150"  width="150"> 
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称" minWidth="150">
          </el-table-column>
          <el-table-column prop="createTime" label="资料填写时间" minWidth="200"></el-table-column>
          <template v-for="val in RuleFieldsList">
            <el-table-column
              v-if="val == '姓名'"
              prop="name"
              label="姓名"
              minWidth="150"
              :key="val"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.name }}
                  <!-- <div
                    class="openHover"
                    v-if="scope.row.name && scope.row.name.indexOf('*') != -1"
                    @click="
                      handleDecrypt(
                        'name',
                        'userInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="val == '手机号码'"
              prop="mobile"
              label="手机号"
              minWidth="150"
              :key="val"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.mobile }}
                  <!-- <div
                    class="openHover"
                    v-if="
                      scope.row.mobile && scope.row.mobile.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'mobile',
                        'userInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="val == '生日'"
              prop="birthDay"
              label="生日"
              minWidth="200"
              :key="val"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.birthDay }}
                  <!-- <div
                    class="openHover"
                    v-if="
                      scope.row.birthDay &&
                      scope.row.birthDay.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'birthDay',
                        'userInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="val == 'QQ'"
              prop="qq"
              label="QQ"
              minWidth="150"
              :key="val"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.qq }}
                  <!-- <div
                    class="openHover"
                    v-if="scope.row.qq && scope.row.qq.indexOf('*') != -1"
                    @click="
                      handleDecrypt(
                        'qq',
                        'userInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="val == '微信'"
              prop="weChat"
              label="微信"
              minWidth="150"
              :key="val"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.weChat }}
                  <!-- <div
                    class="openHover"
                    v-if="
                      scope.row.weChat && scope.row.weChat.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'weChat',
                        'userInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="val == '性别'"
              label="性别"
              minWidth="150"
              :key="val"
            >
              <template slot-scope="scope">
                <div class="open">
                  <span v-if="scope.row.sex.indexOf('*') != -1">{{
                    scope.row.sex
                  }}</span>
                  <span v-if="scope.row.sex == 0">未知</span>
                  <span v-if="scope.row.sex == 1">男</span>
                  <span v-if="scope.row.sex == 2">女</span>
                  <!-- <div
                    class="openHover"
                    v-if="scope.row.sex && scope.row.sex.indexOf('*') != -1"
                    @click="
                      handleDecrypt(
                        'sex',
                        'userInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="val == '职业'"
              prop="job"
              label="职业"
              minWidth="150"
              :key="val"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.job }}
                  <!-- <div
                    class="openHover"
                    v-if="scope.row.job && scope.row.job.indexOf('*') != -1"
                    @click="
                      handleDecrypt(
                        'job',
                        'userInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="val == '地区'"
              prop="address"
              label="地区"
              minWidth="150"
              :key="val"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.address }}
                  <!-- <div
                    class="openHover"
                    v-if="
                      scope.row.address && scope.row.address.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'address',
                        'userInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="val == '详细地址'"
              prop="detailedAddress"
              label="详细地址"
              minWidth="150"
              :key="val"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.detailedAddress }}
                  <!-- <div
                    class="openHover"
                    v-if="
                      scope.row.detailedAddress &&
                      scope.row.detailedAddress.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'detailedAddress',
                        'userInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="val == '扩展信息'"
              label="扩展信息"
              minWidth="300"
              :key="val"
            >
              <template slot-scope="scope">
                <!-- <span>{{ scope.row.extendInfo | showextendInfo }}</span> -->
                <div style="display: flex;flex-wrap: wrap;">
                  <div v-for="(item,index) in showextendInfo(scope.row.extendInfo)" class="info">
                    <div style="text-align: right;min-width: 40px;">{{item.prop}}:</div>
                    <template v-if="item.isImg">
                      <div class="img-parent" v-for="child in item.keys">
                        <img class="info-img" :src="child" :preview-src-list="[child]"></img>
                        <div class="mask" @click="handlePictureCardPreview(child)">
                          <i class="el-icon-zoom-in"></i>
                        </div>
                      </div>
                    </template>
                    <span v-else style="margin-left: 4px;">{{item.keys}}</span>
                    <span v-if="index!=showextendInfo(scope.row.extendInfo).length-1">；</span>
                  </div>
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeUserInfo"
          background
          @current-change="handleCurrentUserInfo"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalUserInfo"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 发放记录 -->
      <el-tab-pane
        label="发放记录"
        name="six"
        v-if="fitersChooseIF([13, 14, 15])"
      >
        <input-form
          :inputData="inputAwardOne"
          @toParentVal="searchAward"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(12)"
          >按查询结果生成人群</el-button
        >
        <el-button
          style="float: right; margin-bottom: 20px"
          @click="exportTheData"
          v-preventReClick
          >导出</el-button
        >
        <el-table
          v-loading="loading"
          :data="distributionTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="chaosPin" label="用户pin（加密）"  width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
          <el-table-column prop="activityName" label="活动名称">
          </el-table-column>
          <template v-if="rowData.activityType == 15">
            <el-table-column prop="sceneType" label="场景">
              <template slot-scope="scope">
                <span v-if="scope.row.sceneType == 1">未关注店铺用户</span>
                <span v-if="scope.row.sceneType == 2">店铺新客</span>
                <span v-if="scope.row.sceneType == 3">plus会员</span>
                <span v-if="scope.row.sceneType == 4">关注店铺用户</span>
                <span v-if="scope.row.sceneType == 5">店铺会员</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="奖品类型">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeType == 1">优惠券</span>
              <span v-if="scope.row.prizeType == 2">京豆</span>
              <span v-if="scope.row.prizeType == 4">店铺积分</span>
            </template>
          </el-table-column>
          <el-table-column prop="prizeName" label="奖品名称"> </el-table-column>
          <el-table-column label="发放状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0" class="y1">未知</span>
              <span v-if="scope.row.status == 3" class="y4">已发放</span>
              <span v-if="scope.row.status == 4" class="y3">发放失败</span>
              <el-tooltip effect="dark" v-if="scope.row.status == 4" :content="scope.row.failReason" placement="top-start">
                <!-- <img v-if="scope.row.status == 4" src="../../assets/images/ask.png" alt="" /> -->
                <i
                  style="color: #ccc"
                  v-if="scope.row.status == 4"
                  class="el-icon-question"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="发放时间">
            <template slot-scope="scope">
              <span>{{ scope.row.joinTime }} </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeAwardOne"
          background
          @current-change="handleCurrentAwardOne"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.totalDistribution"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 抽奖机会赠送记录 -->
      <el-tab-pane
        label="抽奖机会赠送记录"
        name="seven"
        v-if="fitersChooseIF([20])"
      >
        <input-form
          :inputData="inputComment"
          @toParentVal="searchComment"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(5)"
          >按查询结果生成人群</el-button
        >
        <el-table
          v-loading="loading"
          :data="CommentList"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="chaosPin" label="用户pin（加密）"  width="150">
          </el-table-column>
          <el-table-column prop="nickName" label="用户昵称"> </el-table-column>
          <el-table-column prop="creationTime" label="评价时间">
          </el-table-column>
          <el-table-column prop="skuId" label="SKUID"></el-table-column>
          <el-table-column prop="orderId" label="订单号"> </el-table-column>
          <el-table-column label="过滤状态">
            <template slot-scope="scope">
              <span v-if="scope.row.filterType == 0">未通过</span>
              <span v-if="scope.row.filterType == 1">通过</span>
            </template>
          </el-table-column>
          <el-table-column prop="filterRemark" label="备注"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="commentDetails(scope.row)"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeComment"
          background
          @current-change="handleCurrentComment"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalComment"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 拼券明细 -->
      <el-tab-pane
        label="拼券明细"
        name="eight"
        v-if="fitersChooseIF([21, 31])"
      >
        <input-form
          :inputData="inputCoupon"
          @toParentVal="searchCoupon"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(9)"
          >按查询结果生成人群</el-button
        >
        <el-table
          v-loading="loading"
          :data="couponDetailsList"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <template v-if="fitersChooseIF([21])">
            <el-table-column prop="chaosPin" label="用户pin（加密）"  width="150">
            </el-table-column>
            <el-table-column prop="name" label="用户昵称"> </el-table-column>
            <el-table-column prop="grantTime" label="领取时间">
            </el-table-column>
            <el-table-column prop="prizeName" label="奖励信息">
            </el-table-column>
          </template>
          <template v-if="fitersChooseIF([31])">
            <el-table-column prop="chaosPin" label="用户pin（加密）"  width="150">
            </el-table-column>
            <el-table-column prop="name" label="用户昵称"> </el-table-column>
            <el-table-column prop="grantTime" label="角色">
              <template slot-scope="scope">
                {{ scope.row.memberRole == 1 ? "分享者" : "被分享者" }}
              </template>
            </el-table-column>
            <el-table-column prop="memberType" label="用户身份">
              <template slot-scope="scope">
                {{ scope.row | typeChinese }}
              </template>
            </el-table-column>
            <el-table-column prop="grantTime" label="领券时间">
            </el-table-column>
            <el-table-column prop="prizeInfo" label="优惠券信息">
            </el-table-column>
          </template>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeCoupond"
          background
          @current-change="handleCurrentCoupond"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCoupon"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 优惠券统计 -->
      <el-tab-pane
        :label="fitersRepurchase([21], '优惠券统计', '优惠券发放统计')"
        name="nine"
        v-if="fitersChooseIF([21, 31])"
      >
        <input-form
          :inputData="inputSplitCoupon"
          @toParentVal="searchSplit"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <el-table
          v-loading="loading"
          :data="CouponStatisticsList"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          row-key="id"
          style="width: 100%; margin: 40px auto"
          :tree-props="{ children: 'data' }"
        >
          <template v-if="fitersChooseIF([21])">
            <el-table-column prop="name" label="日期"> </el-table-column>
            <el-table-column prop="grantNum" label="发放量"> </el-table-column>
          </template>
          <template v-if="fitersChooseIF([31])">
            <el-table-column prop="date" label="日期"> </el-table-column>
            <el-table-column
              :prop="item.value"
              :label="item.name"
              v-for="(item, i) in couponList"
              :key="i"
            >
            </el-table-column>
          </template>
        </el-table>
        <template v-if="fitersChooseIF([21])">
          <el-pagination
            style="text-align: right; margin: 25px"
            @size-change="handleSizeCouponStatistics"
            background
            @current-change="handleCurrentCouponStatistics"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCouponstatistics"
            :current-page="formList.current"
          ></el-pagination>
        </template>
      </el-tab-pane>
      <!-- 团队详情 -->
      <el-tab-pane
        :label="fitersRepurchase([21], '团队详情', '助力详情')"
        name="ten"
        v-if="fitersChooseIF([21, 31])"
      >
        <input-form
          :inputData="inputGroupCoupon"
          @toParentVal="searchGroup"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <el-table
          v-loading="loading"
          :data="TeamDetailsList"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <template v-if="fitersChooseIF([21])">
            <el-table-column prop="chaosPin" label="用户pin（加密）"  width="150">
            </el-table-column>
            <el-table-column prop="leaderName" label="团长"> </el-table-column>
            <el-table-column prop="title" label="优惠券"> </el-table-column>
            <el-table-column prop="groupTime" label="组团时间">
            </el-table-column>
            <el-table-column prop="status" label="组团状况">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 0">未知</span>
                <span v-if="scope.row.status === 1">组团中</span>
                <span v-if="scope.row.status === 2">组团成功</span>
              </template>
            </el-table-column>
          </template>
          <template v-if="fitersChooseIF([31])">
            <el-table-column prop="chaosPin" label="用户pin（加密）"  width="150">
            </el-table-column>
            <el-table-column prop="leaderName" label="分享者">
            </el-table-column>
            <el-table-column prop="groupTime" label="首次分享时间">
            </el-table-column>
            <el-table-column prop="status" label="拼券状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 0">未知</span>
                <span v-if="scope.row.status === 1">拼券中</span>
                <span v-if="scope.row.status === 2">拼券成功</span>
                <span v-if="scope.row.status === 3">拼券失败</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="组团成员" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="viewDetails(scope.row)">{{
                fitersRepurchase([21], "查看详情", "查看明细")
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeTeam"
          background
          @current-change="handleCurrentTeam"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalTeam"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 参与赠送记录 -->
      <el-tab-pane
        :label="rowData.activityType == 8?'抽奖机会赠送记录':'参与赠送记录'"
        name="twelve"
        v-if="fitersChooseIF([8,23,24])"
      >
        <input-form
          :inputData="rowData.activityType == 8?inputGiftrecord2:inputGiftrecord"
          @toParentVal="searchGiftrecord"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          v-if="fitersChooseIF([23,24])"
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(7)"
          >按查询结果生成人群</el-button
        >
        <el-table
          v-loading="loading"
          :data="GiftrecordList"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="chaosPin" label="用户pin（加密）"  width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
          <el-table-column prop="taskType" label="获赠类型">
            <template slot-scope="scope">
              <span>{{ rowData.activityType == 8?fitersTypeValue2(scope.row.taskType):fitersTypeValue(scope.row.taskType) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="giveTimes" label="赠送次数" v-if="rowData.activityType == 8">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center">
                <span>{{scope.row.giveTimes}}</span>
                <el-tooltip placement="top" v-if="scope.row.taskType == 17" popper-class="new-tooltip-width">
                  <div slot="content">
                    <div v-for="(fitem, findex) in fitersTypeValue4(scope.row)" :key="'fitersTypeValue4'+ findex">
                      {{ fitem }}
                    </div>
                  </div>
                  <div style="display: inline-block;margin-left: 5px;width: 140px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">(订单号：{{ fitersTypeValue3(scope.row) }})</div>
                </el-tooltip>
              </div>
              
            </template>
          </el-table-column>
          <el-table-column prop="joinTime" label="获赠时间"> </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeGiftrecord"
          background
          @current-change="handleCurrentGiftrecord"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalGiftrecord"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>

      <!-- 兑换记录 -->
      <el-tab-pane
        label="兑换记录"
        name="thirteen"
        v-if="fitersChooseIF([10, 29, 30, 38, 58, 59, 60, 61])"
      >
        <!-- 头部表单查询 -->
        <input-form
          :inputData="inputDataThirRED"
          @toParentVal="searchFormThir"
          :btnPosition1="true"
          style="margin: 20px 0"
          v-if="fitersChooseIF([38])"
        ></input-form>
        <input-form
          :inputData="inputDataThirJ"
          @toParentVal="searchFormThir"
          :btnPosition1="true"
          style="margin: 20px 0"
          v-else-if="fitersChooseIF([10])"
        ></input-form>
        <input-form
          :inputData="inputDataThir"
          @toParentVal="searchFormThir"
          :btnPosition1="true"
          style="margin: 20px 0"
          v-else
        ></input-form>
        <el-button
          v-if="fitersChooseIF([10, 29, 30, 38])"
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(11)"
          >按查询结果生成人群</el-button
        >
        <el-button @click="getphone()" type="primary" style="margin-bottom: 13px;" v-if="fitersChooseIF([38])">导出</el-button>

        <!-- 表格 -->
        <el-table
          v-loading="loading"
          :data="exchangeList"
          style="width: 100%; margintop: 20px"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img
                src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
              />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column prop="chaosPin" label="用户pin（加密）"  width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
          <el-table-column prop="prizeName" label="礼品名称"> </el-table-column>
          <el-table-column label="礼品类型" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeType == 1"> 优惠券 </span>
              <span v-if="scope.row.prizeType == 2"> 京豆 </span>
              <span v-if="scope.row.prizeType == 3"> 实物 </span>
              <span v-if="scope.row.prizeType == 4"> 店铺积分 </span>
              <span v-if="scope.row.prizeType == 5"> E卡 </span>
              <span v-if="scope.row.prizeType == 6"> 爱奇艺会员 </span>
              <span v-if="scope.row.prizeType == 7"> 京豆PlUS会员 </span>
              <span v-if="scope.row.prizeType == 8"> 红包 </span>
              <span v-if="scope.row.prizeType == 9"> 谢谢参与 </span>
              <span v-if="scope.row.prizeType == 10">
                {{ scope.row.activateType==2 ? '百度网盘' :'礼品卡'}}
              </span>
              <span v-if="scope.row.prizeType == 11"> 积分加钱购 </span>
            </template>
          </el-table-column>
          <el-table-column prop="point" label="消耗积分"> </el-table-column>

          <!-- 红包专属 -->
          <el-table-column prop="exchangeNum" label="兑换红包份数" v-if="fitersChooseIF([38])"> </el-table-column>
          <el-table-column prop="exchangeTotalAmount" label="红包金额总数" v-if="fitersChooseIF([38])"> </el-table-column>

          <el-table-column prop="exchangeTime" label="兑换时间">
          </el-table-column>
          <el-table-column label="兑换状态">
            <template slot-scope="scope">
              <span v-if="scope.row.exchangeStatus == 1" class="y4"
                >兑换成功</span
              >
              <span v-if="scope.row.exchangeStatus == 2" class="y3">
                兑换失败
                <!-- <img
                  src="@/assets/images/ask.png"
                  alt=""
                  class="questionMark"
                /> -->
              </span>
              <span v-if="scope.row.exchangeStatus == 3" class="y4"
                >领取成功</span
              >
            </template>
          </el-table-column>
        </el-table>

        <!-- 表格分页 -->
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeExchange"
          background
          @current-change="handleCurrentExchange"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalMail"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>

      <!-- 兑换实物 -->
      <el-tab-pane
        label="兑换记录（实物）"
        name="fourteen"
        v-if="fitersChooseIF([9])"
      >
        <!-- 头部表单查询 -->
        <input-form
          :inputData="inputDataThir9"
          @toParentVal="searchFormThir"
          :btnPosition1="true"
          :defaultSelectArr="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(11)"
          >按查询结果生成人群</el-button
        >
        <el-button
          style="margin-bottom: 20px; width: 120px"
          @click="batchMark2" 
          v-preventReClick
          >批量标记发货</el-button
        >
        <el-button
          @click="getphone()"
          type="primary"
          style="margin-bottom: 20px"
          >导出</el-button
        >

        <!-- 表格 -->
        <el-table
          v-loading="loading"
          :data="exchangeList"
          style="width: 100%; margintop: 20px"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          @selection-change="handleSelectionChange"
        >
          <template slot="empty">
            <div>
              <img
                src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
              />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="chaosPin" label="用户pin（加密）" width="200">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称" width="200">
          </el-table-column>
          <el-table-column prop="winOrderIds" label="关联订单" width="200">
          </el-table-column>
          <el-table-column prop="id" label="中奖id">
          </el-table-column>
          <el-table-column prop="prizeName" label="礼品名称" width="200">
          </el-table-column>
          <el-table-column label="礼品类型" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeType == 1"> 优惠券 </span>
              <span v-if="scope.row.prizeType == 2"> 京豆 </span>
              <span v-if="scope.row.prizeType == 3"> 实物 </span>
              <span v-if="scope.row.prizeType == 5"> E卡 </span>
            </template>
          </el-table-column>
          <el-table-column prop="point" label="消耗积分" width="120">
          </el-table-column>
          <el-table-column prop="exchangeTime" label="兑换时间" width="250">
          </el-table-column>
          <el-table-column label="兑换状态" width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.exchangeStatus == 1" class="y4"
                >兑换成功</span
              >
              <span v-if="scope.row.exchangeStatus == 2" class="y2">
                兑换失败
                <img
                  src="@/assets/images/ask.png"
                  alt=""
                  class="questionMark"
                />
              </span>
              <span v-if="scope.row.exchangeStatus == 3" class="y4"
                >领取成功</span
              >
              <span v-if="scope.row.exchangeStatus === 4" class="y3">
                已撤回
              </span>
            </template>
          </el-table-column>
          <el-table-column label="发货状态" prop="deliveryStatus">
            <template slot-scope="scope">
              <span v-if="scope.row.deliveryStatus == 1" 
                >待发货</span
              >
              <span v-if="scope.row.deliveryStatus == 2" >
                已发货
              </span>
              <span v-if="scope.row.deliveryStatus == 3" 
                >无需发货（非实物）</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="receiverName" label="收货人" width="100">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverName  ? scope.row.receiverName  : '-'}}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverName &&
                    scope.row.receiverName.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt1('receiverName', scope.row, scope.$index)
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverRegion" label="收货地区" width="250">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverRegion ?scope.row.receiverRegion:'-' }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverRegion &&
                    scope.row.receiverRegion.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt1('receiverRegion', scope.row, scope.$index)
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverAddress" label="详细地址" width="250">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverAddress ?scope.row.receiverAddress:'-' }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverAddress &&
                    scope.row.receiverAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt1('receiverAddress', scope.row, scope.$index)
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <!-- 收件人手机号 -->
          <el-table-column
            prop="receiverMobile"
            label="收件人手机号"
            width="120"
          >
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverMobile ?scope.row.receiverMobile:'-'}}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverMobile &&
                    scope.row.receiverMobile.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt1('receiverMobile', scope.row, scope.$index)
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="billCode" label="快递单号">
          </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <div class="btn-wrap">
                <span
                  v-if="scope.row.deliveryStatus == 1 && scope.row.id && scope.row.exchangeStatus != 4"
                  class="delivery"
                  @click="changeShip(scope.row)"
                >
                  标记发货
                </span>
                <span
                  v-else-if="scope.row.deliveryStatus == 1 && scope.row.id && scope.row.exchangeStatus == 4"
                  class="delivery"
                  style="color: #666666;"
                >
                  标记发货
                </span>
                <span class="delivery" v-else-if="scope.row.deliveryStatus == 2 && scope.row.exchangeStatus != 4" @click="cancelShip(scope.row)"> 取消发货 </span>
                <span class="delivery" v-else-if="scope.row.deliveryStatus == 2 && scope.row.exchangeStatus == 4" style="color: #666666;"> 取消发货 </span>
                <span class="delivery" @click="handleEnterCoutierNum(scope.row)" v-if=" scope.row.id && scope.row.exchangeStatus != 4">录入快递单号</span>
                <span class="delivery" v-else style="color: #666666;">录入快递单号</span>
                <!-- B待发货和已发货都可撤回 -->
                <span @click="revocationIntegralGoods(scope.row)" v-if="(scope.row.deliveryStatus == 1 || scope.row.deliveryStatus == 2) && scope.row.exchangeStatus != 4" class="delivery"> 撤回 </span>
                <span style="color: #666666;" class="delivery" v-else> 撤回 </span>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 表格分页 -->
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeExchange"
          background
          @current-change="handleCurrentExchange"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalMail"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>

      <!-- 开卡记录 -->
      <el-tab-pane label="开卡记录" name="fifteen" v-if="fitersChooseIF([32])">
        <!-- 头部表单查询 -->
        <input-form
          :inputData="inputDataThir2"
          @toParentVal="searchFormThir2"
          :btnPosition1="true"
          style="margin: 20px 0"
          ref="inputRef2"
        ></input-form>
        <div style="color: #7b61ff; margin-bottom: 10px">
          注意：仅记录点击【开卡】按钮后1个小时内开卡的用户
        </div>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(14)"
          >按查询结果生成人群</el-button
        >
        <!-- 表格 -->
        <el-table
          v-loading="loading"
          :data="exchangeList"
          style="width: 100%; margintop: 20px"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img
                src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
              />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column prop="chaosPin" label="用户pin（加密）"  width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
          <el-table-column prop="createTime" label="首次点击时间">
          </el-table-column>
          <el-table-column prop="updateTime" label="末次点击时间">
          </el-table-column>
          <el-table-column prop="openCardTime" label="开卡时间">
          </el-table-column>
        </el-table>

        <!-- 表格分页 -->
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeExchange2"
          background
          @current-change="handleCurrentExchange2"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalMail"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>

      <!-- Note---邀请开发有礼C端逻辑优化 -->
      <el-tab-pane label="邀请统计" name="sevent" v-if="fitersChooseIF([5, 6])">
        <input-form
          :inputData="inputAwardThree"
          ref="export_fun"
          @toParentVal="searchAwardStatistics"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(8)"
          >按查询结果生成人群</el-button
        >
        <el-table
          v-loading="loading"
          :data="invitationNum"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="chaosPin" label="用户pin（加密）"  width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
          <el-table-column label="任务" v-if="isTaskPrize">
            <template slot-scope="scope">
              <span>任务{{ $toChinesNum(scope.row.taskIndex) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="joinTime" label="发起时间"> </el-table-column>
          <el-table-column prop="num" label="成功邀请人数"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="invitationDeatils(scope.row)"
                style="text-align: left; margin-left: -10px"
                >邀请明细</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeAward1"
          background
          @current-change="handleCurrentAward1"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalAwardFor"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 订单明细 -->
      <el-tab-pane label="订单明细" name="orderDetail" v-if="fitersChooseIF([9,16,17,18,19,36,27,28,41])">
        <input-form
          :inputData="inputOrderDetail"
          ref="orderDetailRef"
          @toParentVal="searchOrderDetail"
          :btnPosition2="true"
          :defaultSelectArr="true"
        ></input-form>
        <div class="new-table-box">
          <el-table
            v-loading="loading"
            :data="orderDetailData"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%;"
          >
            <el-table-column prop="orderId" label="订单编号">
            </el-table-column>
            <el-table-column prop="rootId" label="父订单号" v-if="fitersChooseIF([27,28,41],'!=')">
              <template slot-scope="scope">
                {{scope.row.rootId || "--"}}
              </template>
            </el-table-column>
            <el-table-column prop="chaosPin" label="用户Pin">
            </el-table-column>
            <el-table-column prop="orderStartTime" label="下单时间"> </el-table-column>
            <el-table-column prop="paymentConfirmTime" label="付款时间"> </el-table-column>
            <el-table-column prop="orderPayment" label="订单金额">
              <template slot="header">
                <span>订单金额</span>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="自营店铺为订单金额，POP店铺统计规则以活动实际设置为准"
                  placement="top"
                >
                  <span class="question_iconOne">?</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="orderStateRemark" label="订单状态"> </el-table-column>
          </el-table>
        </div>
        <div class="new-pagination-page">
          <el-pagination
            style="text-align: right;"
            @size-change="handleSizeOrderDetail"
            background
            @current-change="handleCurrentOrderDetail"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="orderDetailPage.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="orderDetailPage.total"
            :current-page="orderDetailPage.current"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <!-- 被邀请人明细 -->
      <el-tab-pane label="被邀请人明细" name="inviteeDetails" v-if="fitersChooseIF([5])">
        <input-form
          :inputData="inviteeDetailsInputData"
          ref="export_fun"
          @toParentVal="inviteeDetailsSearch"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <el-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(21)"
          >按查询结果生成人群</el-button
        >
        <el-table
          v-loading="loading"
          :data="inviteeDetailsData"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="inviteChaosPin" label="邀请人用户pin(加密)"  width="180">
          </el-table-column>
          <el-table-column prop="inviteNick" label="邀请人昵称" width="200">
          </el-table-column>
          <el-table-column prop="chaosPin" label="被邀请人用户pin(加密)"  width="200">
          </el-table-column>
          <el-table-column prop="memberNick" label="被邀请人昵称"  width="200">
          </el-table-column>
          <el-table-column prop="isValidInvite" label="是否有效邀请"  width="150">
            <template slot-scope="scope">
              <span>{{ Number(scope.row.isValidInvite) == 1 ? '是' : '否'}}</span>
              <el-tooltip effect="dark" v-if="scope.row.isValidInvite != 1" :content="nowActType == 1 ? '不满足成功入会且有付款条件': nowActType == 2 ? '不满足成功入会且有下单条件': '不满足成功入会'" placement="top-start">
                <i
                  style="color: #ccc;margin-left: 4px; cursor: pointer"
                  v-if="scope.row.isValidInvite != 1"
                  class="el-icon-question"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="orderIds" label="订单号"  width="150">
            <template slot-scope="scope">
              {{ scope.row.orderIds ? scope.row.orderIds : '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="orderCount" label="订单数"  width="150">
            <template slot-scope="scope">
              {{ scope.row.orderCount ? scope.row.orderCount : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="itemCount" label="商品件数"  width="150">
            <template slot-scope="scope">
              {{ scope.row.itemCount ? scope.row.itemCount : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="paymentAmount" label="付款金额"  width="150">
            <template slot-scope="scope">
              {{ scope.row.paymentAmount ? scope.row.paymentAmount : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="joinTime" label="邀请时间"  width="250">
            <template slot-scope="scope">
              {{ scope.row.joinTime ? scope.row.joinTime : '-' }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeInviteDetail"
          background
          @current-change="handleCurrentInviteDetail"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="inviteeDetailsTotal"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>
      <!-- 入会用户转化分析 -->
      <el-tab-pane label="入会用户转化分析" name="conversionAnalysis">
        <div class="conversion">
          <div class="card-point tipBg">
            <div class="card-rule" style="min-width: 24px;"></div>
            <div class="card-connet">
              <p>分析在本次活动入会的粉丝在一段时间内的转化数据，转化数据不区分订单类型及不排除本次活动下单的订单，仅2024-11-12 后创建的活动支持</p>
            </div>
          </div>
        </div>
        <input-form
          :inputData="inputConversion"
          ref="export_fun"
          @toParentVal="searchConversion"
          :btnPosition2="true"
        >
          <template slot="statDaysNum">
            <el-input placeholder="请输入" v-model="conversionForm.statDaysNum" class="conversion-statDaysNum" @input="conversionForm.statDaysNum = getNumberData(1, $event, 0, 1, 30)">
              <span slot="suffix">天</span>
            </el-input>
            <span> 内的订单</span>
          </template>
          <template slot="orderMoney">
            <el-select v-model="conversionForm.statType" class="conversion-statType">
              <el-option label="累计下单金额(付款)" :value="0"></el-option>
              <el-option label="累计下单金额(成交)" :value="1"></el-option>
            </el-select>
            <el-select v-model="conversionForm.compareType" class="conversion-compareType">
              <el-option label="大于等于" :value="0"></el-option>
              <el-option label="小于等于" :value="1"></el-option>
            </el-select>
            <el-input placeholder="请输入" v-model="conversionForm.orderAmount" class="conversion-orderMoney" @input="conversionForm.orderAmount = getNumberData(1, $event, 0, 1, 999999)"></el-input>
          </template>
        </input-form>
        <el-button
          :disabled="conversionData.length == 0"
          style="width: 150px;margin-bottom: 16px;"
          @click="addCrowd(18)"
          >按查询结果生成人群</el-button
        >
        <div class="new-table-box">
          <el-table
            v-loading="loading"
            :data="conversionData"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%;"
          >
            <el-table-column prop="chaosPin" label="用户Pin"></el-table-column>
            <el-table-column prop="memberNick" label="用户昵称"></el-table-column>
            <el-table-column prop="openCardTime" label="入会时间"> </el-table-column>
            <el-table-column prop="payOrderNum" label="下单订单数"> </el-table-column>
            <el-table-column prop="commitOrderNum" label="成交订单数"> </el-table-column>
            <el-table-column prop="statPayOrderAmount" label="累计下单金额(付款)"> </el-table-column>
            <el-table-column prop="statDealOrderAmount" label="累计下单金额(成交)"> </el-table-column>
            <el-table-column prop="avgPayOrderAmount" label="客单价(付款)"> </el-table-column>
          </el-table>
        </div>
        <div class="new-pagination-page">
          <el-pagination
            style="text-align: right;"
            @size-change="handleSizeConversion"
            background
            @current-change="handleCurrentConversion"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="conversionPage.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="conversionPage.total"
            :current-page="conversionPage.current"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <!-- Note----结束 -->
    </el-tabs>
    <!-- 团队弹框 -->
    <el-dialog
      :title="fitersRepurchase([21], '组团明细', '拼券明细')"
      :visible.sync="dialogGroup"
      width="820px"
      @close="dialogGroup = false"
    >
      <el-table
        :data="CouponMember"
        stripe
        style="width: 90%; margin: 0 auto"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <template v-if="fitersChooseIF([21])">
          <el-table-column prop="name" label="成员">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center">
                <div class="imgurl"><img :src="scope.row.avatar" alt="" /></div>
                <span>{{ scope.row.name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="joinTime" label="入团时间"> </el-table-column>
          <el-table-column prop="group" label="角色"> </el-table-column>
        </template>
        <template v-if="fitersChooseIF([31])">
          <el-table-column prop="name" label="用户昵称">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center">
                <div class="imgurl"><img :src="scope.row.avatar" alt="" /></div>
                <span>{{ scope.row.name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="joinTime" label="助力时间"> </el-table-column>
        </template>
      </el-table>
    </el-dialog>

    <!-- Note--邀请明细弹框 -->
    <el-dialog
      title="助力明细"
      :visible.sync="dialogDeatils"
      width="820px"
      @close="dialogDeatils = false"
    >
      <el-table
        v-loading="loading1"
        :data="CouponMember1"
        stripe
        style="width: 90%; margin: 0 auto"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
        <el-table-column
          prop="isOpenCard"
          label="入会状态"
          v-if="rowData.activityType == 5"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.isOpenCard == 1 ? "已入会" : "未入会" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="openCardTime"
          label="入会时间"
          v-if="rowData.activityType == 5"
        >
        </el-table-column>
        <el-table-column
          prop="joinTime"
          label="关注时间"
          v-if="rowData.activityType == 6"
        >
        </el-table-column>
      </el-table>

      <!-- 表格分页 -->
      <el-pagination
        style="text-align: right; margin: 25px"
        @size-change="handleSizeExchangeStatics"
        background
        @current-change="handleCurrentExchangeStatics"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="formList1.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        :current-page="formList1.current"
      ></el-pagination>
    </el-dialog>
    <!-- 导出弹框 -下单冲榜导出弹框 -->
    <el-dialog
      v-if="dialogExprot"
      :title="fitersChooseIF([36, 37, 39]) ? '导出' : '身份验证'"
      custom-class="system-dialog"
      :visible.sync="dialogExprot"
      :width="fitersChooseIF([36, 37, 39]) ? '500px' : '600px'"
      @close="dialogExprot = false"
    >
      <div class="form-box">
        <div class="form-item">
          <div :class="fitersChooseIF([36, 37, 39]) ? 'item-label2' : 'item-label'">
            {{ fitersChooseIF([36, 37, 39]) ? "手机号码：" : "手机号：" }}
          </div>
          <div class="item-value">
            <el-input
              disabled
              placeholder="请输入..."
              v-model="phoneNum"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div class="form-item">
          <div :class="fitersChooseIF([36, 37, 39]) ? 'item-label2' : 'item-label'">
            {{ fitersChooseIF([36, 37, 39]) ? "手机验证码：" : "验证码：" }}
          </div>
          <div class="item-value">
            <el-input
              placeholder="请输入"
              v-model="code"
              style="width: 170px; margin-right: 12px"
            ></el-input>
            <el-button
              type="primary"
              :disabled="codeDisabled"
              @click="getCode"
              >{{ codeMsg }}</el-button
            >
          </div>
        </div>
        <div class="form-item" style="margin-bottom: 8px">
          <div class="form-item" style="margin-bottom: 8px">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="tip-box" style="background: #fff"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="save-btn">
        <template v-if="fitersChooseIF([36])">
          <el-button @click="dialogExprot = false">取消</el-button>
          <el-button type="primary" @click="getApi_Exprot2(
            tabName == 'twenty-one' ? 2 : 
            tabName == 'twenty' ? 3 : 
            1)"
          >确认</el-button>
        </template>
        <!-- 生日有礼活动统计导出 -->
        <template v-else-if="fitersChooseIF([39]) && tabName != 'twenty'">
          <el-button @click="dialogExprot = false">取消</el-button>
          <el-button type="primary" @click="getApi_Exprot4"
          >确认</el-button>
        </template>
        <template v-else-if="fitersChooseIF([37]) && tabName != 'seventeen' && tabName != 'sixteen'">
          <el-button @click="dialogExprot = false">取消</el-button>
          <!-- 1是数据统计、2是派样下单、3是回购下单记录 -->
          <el-button type="primary" @click="getApi_Exprot3(
            tabName == 'sendReBuyPay' ? 2 : 
            tabName == 'sendReBuyRePay' ? 3 : 
            1)"
          >确认</el-button>
        </template>
        <template v-else>
          <el-button class="backBtn" @click="dialogExprot = false">取消</el-button>
          <el-button class="keepBtn" type="primary" @click="getApi_Exprot()">确定</el-button>
        </template>
      </div>
    </el-dialog>

    <evaluation-dialog
      v-model="commentDioag"
      :commentItem="commentItem"
      @dialogClose="dialogClose"
    />

    <el-dialog
      title="身份验证"
      width="600px"
      :show-close="false"
      custom-class="system-dialog"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="form-box">
        <div class="form-item">
          <div class="item-label">手机号：</div>
          <div class="item-value">
            <el-input
              disabled
              placeholder="请输入..."
              v-model="phone"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">验证码：</div>
          <div class="item-value">
            <el-input
              placeholder="请输入"
              v-model="code"
              style="width: 170px; margin-right: 12px"
            ></el-input>
            <el-button
              type="primary"
              :disabled="codeDisabled"
              @click="getCodeInit"
              >{{ codeMsg }}</el-button
            >
          </div>
        </div>
        <div class="form-item" style="margin-bottom: 8px">
          <div class="form-item" style="margin-bottom: 8px">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="tip-box" style="background: #fff"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="save-btn">
        <button class="keepBtn" @click="savePhone()">确定</button>
        <button class="backBtn" @click="canclePhone()">取消</button>
      </div>
    </el-dialog>
    <el-dialog
      title="加购详情"
      :visible.sync="addCartDetailShow"
      width="820px"
      @close="addCartDetailShow = false"
    >
      <el-table
        :data="addCartDetailData"
        stripe
        style="width: 90%; margin: 0 auto"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column label="商品">
          <template slot-scope="scope">
            <div class="addCartDetail">
              <div><img :src="scope.row.logo" /></div>
              <div>
                <div>{{ scope.row.title }}</div>
                <div>skuid：{{ scope.row.skuId }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="addCartTime"
          label="加购时间"
          width="200"
        ></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="修改收货信息"
      custom-class="system-dialog"
      :visible.sync="lockTakeGoodsVisible"
      width="450px"
      @close="lockTakeGoodsVisible = false"
    >
      <div class="form-box">
        <div class="form-item">
          <div class="item-label">姓名：</div>
          <div class="item-value">
            <el-input
              placeholder="请输入..."
              v-model="takeGoodsForm.receiverName"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">手机号码：</div>
          <div class="item-value">
            <el-input
              placeholder="请输入..."
              v-model="takeGoodsForm.receiverMobile"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">地区：</div>
          <div class="item-value">
            <el-input
              placeholder="请输入..."
              v-model="takeGoodsForm.receiverAddress"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">详细地址：</div>
          <div class="item-value">
            <el-input
              placeholder="请输入..."
              v-model="takeGoodsForm.detailedAddress"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div style="text-align: center">
          <el-button @click="lockTakeGoodsVisible = false">取消</el-button>
          <el-button type="primary" @click="setTakeGoods">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <lock-batch-dialog
      v-if="batchLockVisible"
      :visible="batchLockVisible"
      :activityId="rowData.id"
      @close="batchLockClose"
    ></lock-batch-dialog>

    <!-- 批量标记发货 -->
    <batch-upload
      v-if="batchMarkVisible"
      :visible="batchMarkVisible"
      action="/jd-hd-web/PointActivityAnalyticController/markingSendStatusBatch/fileUpload"
      @close="batchMarkClose"
    ></batch-upload>

    <!-- 录入快递单号弹窗 -->
    <el-dialog
      title="录入快递单号"
      width="480px"
      :visible.sync="enterCoutierNumShow"
      @close="blankEnterCoutierNum"
      class="enter_coutier_num_dialog"
    >
      <el-form :model="enterCoutierFrom" label-width="120px">
        <el-form-item label="快递单号：">
          <el-input
            placeholder=""
            v-model="enterCoutierNum"
            style="width: 250px"
            @keydown.native="clearInput"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="enter_coutier_num_dialog_floor">
        <el-button type="primary" @click="enterCoutierSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 下单冲榜： 批量发货弹窗 -->
    <el-dialog
      title="批量发货"
      width="600px"
      :visible.sync="physicalBatchShipmentShow"
      @close="physicalBatchShipmentClose"
      class="physical_batch_shipment_dialog"
    >
      <el-form :model="physicalBatchShipmentFrom" label-width="120px">
        <el-form-item label="上传文件：">
          <el-upload
            :before-upload="beforeUploadFile"
            :on-success="handleUpload"
            :show-file-list="false"
            :data="fitersChooseIF([36])?
            { activityId: activityId } :
            { activityId: activityId, type: 1 }"
            class="upload-demo"
            :drag="true"
            multiple
            with-credentials
            :action="'/jd-hd-web/lockRight/markingSendStatusBatch/fileUpload'"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <!-- 下载模板按钮 -->
      <div class="download_template_box">
        <el-button type="primary" @click="handleDownloadTemplate"
          >下载模板</el-button
        >
      </div>
      <div class="downloadMsgBox">
        <p>
          导入成功{{ downloadResData.successNum || 0}}条，导入失败{{
            downloadResData.failNum || 0
          }}条，导入失败相关{{fitersChooseIF([36]) ? "用户PIN": "用户昵称"}}：
        </p>
        <div class="downloadUser">
          <div
            class="downloaditem"
            v-for="(item, index) in downloadUserList"
            :key="index"
          >
            {{ index + 1 + ". " }}{{ item }}
          </div>
        </div>
      </div>
      <div class="physical_batch_shipment_dialog_floor">
        <el-button @click="physicalBatchShipmentClose">关闭</el-button>
        <!-- <el-button type="primary" @click="physicalBatchShipmentSubmit"
          >确认</el-button
        > -->
      </div>
    </el-dialog>

    <!-- 下单冲榜实物发货弹窗 -->
    <el-dialog
      title="发货信息"
      width="480px"
      v-if="sendOutGoodsShow"
      :visible.sync="sendOutGoodsShow"
      @close="blankEnterCoutierNum"
      class="enter_coutier_num_dialog"
    >
      <el-form :model="sendOutGoodsForm" label-width="120px">
        <el-form-item label="快递单号：">
          <el-input
            placeholder="请输入"
            v-model="enterCoutierNum"
            style="width: 250px"
            @keydown.native="clearInput"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="enter_coutier_num_dialog_floor">
        <el-button type="primary" @click="goodsEnterCoutierSubmit">确定</el-button>
      </div>
    </el-dialog>
    <!-- 生成人群 -->
    <crowdDialog v-if="isShowCrowdDialog" 
      :isShowCrowdDialog="isShowCrowdDialog" 
      :searchForm="crowCondition" 
      :activityType="activeName == 'conversionAnalysis'?-1:rowData.activityType"
      :source="source"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      @close="crowdClose" 
    />
    <div class="bigImg" v-if="dialogImageUrl">
      <img :src="dialogImageUrl" alt="">
      <i class="el-icon-circle-close" @click="closeBigImg"></i>
    </div>
    <!-- 导出验证弹窗 -->
    <exportVerify :visible="isShowVerify" @close="isShowVerify = false" @submit="submitExport"/>
    <exportVerify2 :visible="isShowVerify2" @close="isShowVerify2 = false" @submit="submitExport2"/>

    <!-- 晒单有礼-审核 -->
    <ProcessInfo v-model="isShowProcessInfoDialog" :controlType="processControlType" :rowData="processRowData"
     :activityId="rowData.id" :proccessSelection="proccessSelectionArr" @update="_getUserProfileList" :isShowAuditResult="isShowAuditResult"/>
     <!-- 晒单有礼-上传审核结果 -->
    <UploadProccessResult v-model="isShowUploadProccess"  
    action="/jd-hd-web/show-product/userProfile/upload"
    :activityId="rowData.id"  @update="_getUserProfileList"/>

    <!-- 导出字段设置弹窗 -->
    <export-field-setting-dialog 
      :visible.sync="exportSettingDialog" 
      :export-fields-data="exportFieldsData" 
      :export-field-loading="exportFieldLoading" 
      @save="handleExportFieldsSave" 
      @close="handleExportFieldsClose" 
    />
    <!-- 下单冲榜-订单详情 -->
    <rankOrderDetail :currentId="currentId" v-if="isShowOrderDetail" @closeDialog="isShowOrderDetail = false"></rankOrderDetail>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import inputForm from "../../components/inputForm.vue";
import crowdDialog from "@/components/crowd-Dialog.vue"
import evaluationDialog from "./evaluationDialog/evaluationDialog.vue";
import lockBatchDialog from "./lockBatchDialog.vue";
import batchUpload from './components/batchUpload.vue'
import prizeList from "./components/prize-preview.vue"
import {
  getCoupon,
  openCardRecord,
  appointment,
  lockSendStatus,
  updateReceiveAddress,
  markingSendStatusLockRight,
  markingSendStatusForPointActivity,
  orderDetailPage,
  memConvAnalysis,
  pointsExchangeQuash,
  purchaseActivityWithdraw,
  saveFieldJsonConfig,
  getFieldJsonConfig,
  pointOrderDetailPage,
} from "@/api/integralCenter/PointActivityAnalyticController";
import statisticsData from "@/mixin/activity_statistics_new.js";
import exportVerify from "../../components/export-verify.vue";
import exportVerify2 from "../../components/export-verify.vue";

import ProcessInfo from './components/processInfo.vue'
import UploadProccessResult from './components/uploadProccessResult.vue'
import exportFieldSettingDialog from '@/views/integralCenter/components/activity_data_statistics_new/_components/exportFieldSettingDialog.vue'
import rankOrderDetail from "./components/rankOrderDetail.vue";
import {
  getmoble
} from "@/api/paradiseAndTaskCommonController.js";
import birthInfo from "./components/birthInfo.vue";
import collectOpportunitiesRecord from "./components/collectOpportunitiesRecord.vue";
export default {
  mixins: [statisticsData],
  components: {
    inputForm,
    evaluationDialog,
    lockBatchDialog,
    crowdDialog,
    batchUpload,
    prizeList,
    exportVerify,
    exportVerify2,
    ProcessInfo,
    UploadProccessResult,
    exportFieldSettingDialog,
    rankOrderDetail,
    birthInfo,
    collectOpportunitiesRecord
  },
  props: {
    rowData: {
      type: Object,
      default: {},
    },
    ids1: {
      type: String,
      default: "",
    },
    // 用于区分是不是下单冲榜
    isChongBang: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowExtraWinRecord: false,
      formExtra: {
        current:1,
        size: 10,
        pin: "",
        memberNick: "",
        prizeType: "",
        prizeIds: "",
        status: "",
        winTimeStart: "",
        winTimeEnd: "",
        id: this.rowData.id,
        prizeObjectType: 1,
      },
      totalSignInSupplementary: 0,
      signInTableSupplementary:[],
      currentId: -1,
      isShowOrderDetail: false,
      nowActType: 0,
      prizeNames: [],
      isShowAuditResult: true,//审核备注展示
      dialogImageUrl: "",
      source: "",
      isShowCrowdDialog: false,
      lockTakeGoodsVisible: false,
      takeGoodsForm: {
        id: null,
        receiverName: "",
        receiverMobile: "",
        receiverAddress: "",
        detailedAddress: "",
      },
      batchLockVisible: false,
      // 收货信息
      takeGoodsTable: [],
      totalTakeGoods: 0,
      // note--锁权记录
      lockRightTable: [],
      totalLockRight: 0,
      // note--加购记录
      addCartTable: [],
      totalAddCart: 0,
      // 数据总览tabs
      switchIndex: "1",
      tabMap: {
        '1': '互动参与',
        '2': '浏览店铺',
        '3': '浏览商品',
        '4': '下单',
        '5': '入会',
        '6': '中奖',
      },
      // 加购记录查询条件
      inputDataAddCart: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "中奖状态:",
          val: "isWin",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", defaultValue: "", id: "" },
            { label: "已中奖", id: 1 },
            { label: "未中奖", id: 0 },
          ],
        },
        {
          name: "加购时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      // 弹窗
      addCartDetailShow: false,
      addCartDetailData: [],
      // note--结束
      dialogDeatils: false,
      isTaskPrize: false, // 是否为任务奖品类型
      taskIndex: "", // 任务标值
      CouponMember1: [],
      RuleFieldsList: [],
      multipleSelection: [],
      tableShopData: [],
      dialogGroup: false,

      // 晒单有礼
      isShowUploadProccess: false, //上传审核结果弹窗
      proccessSelectionArr:[], //批量选择
      processRowData: {}, 
      isShowProcessInfoDialog: false,//审核弹窗
      processControlType:'single', //审核弹窗类型，批量审核，单个审核
      postUserStaticsInfo: {
        //用户资料信息汇总
        totalSubmitNum: 0, //共提交
        lastSubmitNum: 0, //昨日提交
        passNum: 0, //通过份数
        unProcessNum: 0, //待审核份数
        failNum: 0, //拒绝份数
      },
      postRuleFieldsList: [], //用户资料信息
      totalPostOrderUserInfo:10,
      postOrderInfoTable: [], //用户资料-晒单有礼
      // 晒单有礼-用户资料
      postOrdersInfoInput: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "订单号:",
          val: "orderId",
          placeholder: "请输入",
        },
        {
          name: "提交时间:",
          myDate: true,
          val: ["createStartTime", "createEndTime"],
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
        },
        {
          name: "审核状态",
          val: "processStatus",
          selectArr: [
            { label: "全部" , id:"", defaultValue:[""] },
            { label: "待审核", id: 0 },
            { label: "已通过", id: 1 },
            { label: "已驳回", id: 2 },
            { label: "待参与", id: -1 },
          ],
          multiple:true
        },
        {
          name: "审核时间:",
          myDate: true,
          val: ["processStartTime", "processEndTime"],
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
        },
      ],

      joinSummary: [
        {
          value: "actPv", // 对应tableTotal的字段
          name: "PV",
          tips: true, // 提示的显示隐藏
          tipsName: "活动的累计来访PV", // 提示语
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "actUv",
          name: "UV",
          tips: true,
          tipsName: "活动的累计来访UV，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "participatePv",
          name: "参与次数",
          tips: true,
          tipsName:
            "符合活动参与行为的用户参与次数汇总，用户可能在活动中参与多次，根据活动类型而定",
          color: "#F4ACB9",
        },
        {
          value: "participateUv",
          name: "参与人数",
          tips: true,
          tipsName:
            "符合活动参与行为的用户数汇总、包括但不限于：抽奖、领奖、分享、签到等，单日去重，多日不去重",
          color: "#F2D0B5",
        },
        {
          value: "participateAvg",
          name: "人均参与次数",
          tips: true,
          tipsName: "参与次数/参与人数。",
          color: "#C2CDDE",
        },
        {
          value: "participateRate",
          name: "参与率",
          tips: true,
          tipsName: "参与人数 / UV",
          color: "#96AA08",
        },
        {
          value: "cartPv",
          name: "加购次数",
          tips: false,
          tipsName: "加购了活动指定商品的累计次数",
          color: "#C2D1C8",
        },
        {
          value: "cartUv",
          name: "加购人数",
          tips: false,
          tipsName: "加购了活动指定商品的累计人数，多日不去重",
          color: "#D39595",
        },
        {
          value: "sharePv",
          name: "分享次数",
          tips: false,
          tipsName: "活动中进行分享的次数",
          color: "#B8C7F3",
        },
        {
          value: "shareUv",
          name: "分享人数",
          tips: false,
          tipsName: "活动中进行分享的人数，单日去重，多日不去重",
          color: "#A7878E",
        },
      ],
      stoneSummary: [
        {
          value: "scanshopPv",
          name: "浏览店铺次数",
          tips: false,
          tipsName: "累计从活动页跳转并浏览店铺PV",
          color: "#EFB37E",
        },
        {
          value: "scanshopUv",
          name: "浏览店铺人数",
          tips: false,
          tipsName: "累计从活动页跳转并浏览店铺UV，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "scanshopRate",
          name: "浏览率",
          tips: false,
          tipsName: "浏览店铺人数 / 参与人数",
          color: "#F4ACB9",
        },
        {
          value: "followshopUv",
          name: "新增店铺关注人数",
          tips: false,
          tipsName: "活动中累计关注店铺的人数，不去重",
          color: "#F2D0B5",
        },
        {
          value: "followshopPv",
          name: "新增店铺关注次数",
          tips: false,
          tipsName: "活动中累计关注店铺的次数",
          color: "#C2CDDE",
        },
        {
          value: "followshopRate",
          name: "店铺关注率",
          tips: false,
          tipsName: "新增店铺关注人数/ 参与人数",
          color: "#96AA08",
        },
      ],
      goodsSummary: [
        {
          value: "scanskuPv",
          name: "浏览商品次数",
          tips: false,
          tipsName: "活动中浏览任意商品的次数",
          color: "#EFB37E",
        },
        {
          value: "scanskuUv",
          name: "浏览商品人数",
          tips: false,
          tipsName: "活动中浏览任意商品的人数，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "scanskuRate",
          name: "浏览商品率",
          tips: false,
          tipsName: "浏览商品人数 / 参与人数",
          color: "#F4ACB9",
        },
        {
          value: "followskuUv",
          name: "商品关注人数",
          tips: false,
          tipsName: "活动中关注了任意商品的累计人数，多日不去重",
          color: "#F2D0B5",
        },
        {
          value: "followskuPv",
          name: "商品关注次数",
          tips: false,
          tipsName: "活动中关注了任意商品的累计次数",
          color: "#C2CDDE",
        },
        {
          value: "followSkuRate",
          name: "商品关注率",
          tips: false,
          tipsName: "商品关注人数 / 参与人数",
          color: "#96AA08",
        },
      ],
      orderSummary: [
        {
          value: "orderPayGmv",
          name: "下单GMV(付款)",
          tips: false,
          tipsName: "活动时间范围内，活动中累计产生订单的按订单金额汇总",
          color: "#EFB37E",
        },
        {
          value: "orderPayNum",
          name: "下单人数(付款)",
          tips: false,
          tipsName: "活动时间范围内，活动中累计产生订单的用户数",
          color: "#B2A8DA",
        },
        {
          value: "orderPayQuantity",
          name: "总下单数(付款)",
          tips: false,
          tipsName: "活动时间范围内，活动中累计产生订单的订单数汇总",
          color: "#F4ACB9",
        },
        {
          value: "price",
          name: "客单价",
          tips: false,
          tipsName: "下单GMV(付款) / 下单人数(付款)",
          color: "#F2D0B5",
        },
        {
          value: "orderQuantityAvg",
          name: "平均单量",
          tips: false,
          tipsName: "总下单数(付款) / 下单人数(付款)",
          color: "#C2CDDE",
        },
        {
          value: "orderConversionRate",
          name: "下单转化率",
          tips: false,
          tipsName: "下单人数(付款) / 参与人数",
          color: "#96AA08",
        },
        {
          value: "newOpenCardOrderQuantity",
          name: "新增会员下单人数",
          tips: false,
          tipsName: "活动中新增入会的用户，在活动中累计产生订单的用户数",
          color: "#3498DB",
        },
        {
          value: "oldOpenCardOrderNum",
          name: "老会员下单人数",
          tips: false,
          tipsName: "非活动中入会的会员用户（参与活动用户中为会员身份的用户数量减去新增入会用户），在活动中累计产生订单的用户数",
          color: "#E74C3C",
        },
        {
          value: "newOpenCardOrderGmv",
          name: "新增会员下单金额",
          tips: false,
          tipsName: "活动中新增入会的用户，在活动中累计产生订单的付款金额",
          color: "#9B59B6",
        },
        {
          value: "oldOpenCardOrderGmv",
          name: "老会员下单金额",
          tips: false,
          tipsName: "非活动中入会的会员用户（参与活动用户中为会员身份的用户数量减去新增入会用户），在活动中累计产生订单的付款金额",
          color: "#F39C12",
        },
      ],
      fanSummary: [
        {
          value: "newOpenCardNum",
          name: "新增入会人数",
          tips: false,
          tipsName: "活动中新增入会的用户人数，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "openCardConversionRate",
          name: "入会转化率",
          tips: false,
          tipsName: "新增会员人数 / 参与人数",
          color: "#F4ACB9",
        },
        {
          value: "newOpenCardOrderNum",
          name: "新增会员下单人数",
          tips: false,
          tipsName:
            "活动中新增入会的用户且进行下单的人数，单日去重，多日不去重",
          color: "#F2D0B5",
        },
        {
          value: "newOpenCardOrderGmv",
          name: "新增会员下单GMV(付款)",
          tips: false,
          tipsName: "活动中新增入会在本次活动期间符合下单条件的GMV",
          color: "#C2CDDE",
        },
        {
          value: "newOpenCardOrderQuantity",
          name: "新增会员下单数(付款)",
          tips: false,
          tipsName: "活动中新增入会在本次活动期间符合下单条件的下单次数",
          color: "#96AA08",
        },
        {
          value: "newOpenCardPrize",
          name: "新增会员客单价",
          tips: false,
          tipsName: "新增粉丝下单GMV(付款) / 新增粉丝下单人数",
          color: "#C2D1C8",
        },
      ],
      prizeSummary: [
        {
          value: "accumulateWinTimes",
          name: "累计中奖次数",
          tips: false,
          tipsName: "活动中累计中奖的次数",
          color: "#EFB37E",
        },
        {
          value: "accumulateWinNum",
          name: "累计中奖人数",
          tips: false,
          tipsName: "活动中累计中奖的人数，单日去重，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "winRate",
          name: "中奖率",
          tips: false,
          tipsName: "累计中奖人数 / 参与人数",
          color: "#F4ACB9",
        },
        {
          value: "accumulateReceiveNum",
          name: "累计领奖人数",
          tips: false,
          tipsName: "活动中累计领奖的人数，单日去重，多日不去重",
          color: "#F2D0B5",
        },
        {
          value: "receiveRate",
          name: "领奖率",
          tips: false,
          tipsName: "累计领奖人数/中奖人数",
          color: "#C2CDDE",
        },
      ],
      tatal_num: {
        users: 0, //活动参与用户15天内下单用户量
        ordNum: 0, //活动参与⽤户15天内下单订单总量
        gmv: 0, //活动参与⽤户15天内下单转化金额(元)
        ordRate: 0, //活动参与⽤户15天内下单转化率
      },
      hostList: [
        {
          name: "下单用户量",
          nameOne: 100,
        },
        {
          name: "下单订单总量",
          nameOne: 100,
        },
        {
          name: "下单金额",
          nameOne: 100,
        },
        {
          name: "下单转化率",
          nameOne: 100,
        },
      ],
      loading: false,
      activeName: "first",
      activityTable: [],
      goodsRecordTable:[],
      UnlockTable: [],
      getRecordList:[],
      signInTable: [],
      awardTable: [],
      awardTable1: [
        {
          a: 1,
        },
      ],
      distributionTable: [],
      inkindTable: [],
      userInfoTable: [],
      GiftrecordList: [],
      invitationNum: [], //邀请统计
      queryForm: {
        evaluateTime: "7",
      },
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "15",
            label: "近15天",
          },
          {
            value: "30",
            label: "近30天",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      postForm: {
        startDate: "",
        endDate: "",
        channelCode: "",
      },
      batchTypeList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "商品详情",
          value: 1001,
        },
        {
          label: "店铺首页",
          value: 1002,
        },
        {
          label: "会员二级页",
          value: 1003,
        },
        {
          label: "推广页",
          value: 1004,
        },
        {
          label: "其他",
          value: 1005,
        },
      ],
      tableTotal: {
        pv: 0, //会员中心首页PV
        uv: 0, //会员中心首页uv
        // incrJoinNumber: [], //参与人数今日增量
        joinNumber: 0, //参与人数
        joinTimes: 0, //参与人次
        perJoinNumber: 0, //人均参与次数
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.postForm.startDate) {
            return time.getTime() < new Date(this.postForm.startDate).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.postForm.endDate) {
            return time.getTime() > new Date(this.postForm.endDate).getTime();
          } else {
          }
        },
      },
      //折线图数据
      loading1: false,
      myCharts: null,
      chartEffectDetail: [],
      totalNum: 0,
      totalAward: 0,
      totalSignIn: 0,
      totalInkind: 0,
      totalUserInfo: 0,
      totalDistribution: 0, //发放记录
      totalCoupon: 0,
      totalCouponstatistics: 0,
      totalTeam: 0,
      totalComment: 0,
      totalParticipat: 0,
      totalMemberUpGrade: 0,
      totalBilletDoux: 0, //参与记录(情书贺卡)
      totalBilletReceive: 0, //获取记录(情书贺卡)
      totalGiftrecord: 0,
      totalAwardFor: 0,
      totalRecord:0,
      inviteeDetailsTotal: 0,
      formList: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      activityId: this.rowData.id,
      formList1: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      formListRecord:{
        size: 10,
        current: 1,
        activityId: this.rowData.id
      },
      inputData: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "签到时间:",
          myDate: true,
          val: ["startTime", "startTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputParticipat: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "得分:",
          iptArr: [
            { val: "startScore", placeholder: "请输入" },
            { val: "endScore", placeholder: "请输入" },
          ],
        },
        {
          name: "是否通关:",
          val: "isPass",
          placeholder: "请选择",
          selectArr: [
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
        {
          name: "是否抽奖:",
          val: "isDraw",
          placeholder: "请选择",
          selectArr: [
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
        {
          name: "是否中奖:",
          val: "isWin",
          placeholder: "请选择",
          selectArr: [
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
      ],
      inputMemberUpGrade2: [ // 会员升级礼参与记录
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["createStartTime", "createEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "是否发生升级:",
          val: "isUpgrades",
          placeholder: "请选择",
          selectArr: [
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
        {
          name: "最新访问活动时间:",
          myDate: true,
          val: ["latestJoinStartTime", "latestJoinEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
         {
          name: "是否领取奖品:",
          val: "isWin",
          placeholder: "请选择",
          selectArr: [
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
      ],
      billetInput: [ // 情书贺卡参与记录
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "是否完成制作:",
          val: "finishedFlag",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: '' },
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
      ],
         //TODO:补签卡获取记录
      inputDataListSupplementary: [
        {
          name: "用户昵称：",
          val: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          name: "用户PIN：",
          val: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          name: "获取时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "任务类型：",
          val: "taskType",
          placeholder: "请选择任务类型",
          selectArr: [
            { label: "全部", id: "" },
            { label: "每日签到", id: 1 },
            { label: "浏览店铺", id: 2 },
            { label: "浏览商品", id: 13 },
            { label: "加购商品", id: 4 },
            { label: "分享商品", id: 9 },
            { label: "分享店铺", id: 10 },
            { label: "分享活动", id: 11 },
            { label: "浏览会场", id: 5 },
            { label: "预约商品", id: 12 },
            { label: "积分兑换", id: 16 },
            { label: "购买商品", id: 17 },
            { label: "加入会员", id: 7 },
            { label: "关注店铺", id: 6 },
          ],
        },
      ],
      billetReceive: [ // 情书贺卡获取记录
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "获取时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "用户手机:",
          val: "receiverMobile",
          placeholder: "请选择",
        },
      ],
      inputAward: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          // name: "中奖状态:",
          name: this.fitersRepurchase(
            [16, 17, 18, 27],
            "发放状态:",
            "中奖状态:"
          ),
          val: "status",
          placeholder: "请选择",
          selectArr: [
          {
              label: '全部',
              id: '',
            },
            {
              label: this.fitersRepurchase(
                [16, 17, 18, 27],
                "待领取",
                "未中奖"
              ),
              id: this.fitersRepurchase([16, 17, 18, 27], -1, 1),
            },
            {
              label: this.fitersRepurchase(
                [16, 17, 18, 27],
                "待发放",
                "已中奖"
              ),
              id: 2,
            },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
          ],
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "优惠券", id: 1 },
            { label: "京豆", id: 2 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "京东E卡", id: 5 },
            { label: "爱奇艺会员", id: 6 },
            { label: "PLUS会员", id: 7 },
            { label: "红包", id: 8 },
            { label: "礼品卡", id: 10 },
            { label: "实物（随单发）", id: 14 },
          ],
        },
        {
          name: this.rowData.activityType==41 ? '发放时间' :this.fitersRepurchase(
            [16, 17, 18, 27],
            "领奖时间:",
            "参与时间:"
          ),
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        // {
        //   name: "关联订单状态:",
        //   val: "orderState",
        //   placeholder: "请选择",
        //   selectArr: [
        //     { label: "全部", id: null },
        //     { label: "等待付款", id: "等待付款" },
        //     { label: "暂停", id: "暂停" },
        //     { label: "等待出库", id: "等待出库" },
        //     { label: "等待发货", id: "等待发货" },
        //     { label: "完成", id: "完成" },
        //     { label: "取消", id: "取消" },
        //     { label: "锁定", id: "锁定" },
        //     { label: "等待确认收货", id: "等待确认收货" },
        //     { label: "未知", id: "未知" },
        //   ],
        // },
        // {
        //   name: "订单号:",
        //   val: "unlockOrderId",
        //   placeholder: "请输入",
        // },
      ],
      inputMemberUpGrade: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入用户pin, 精确查询",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: '领奖时间',
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "优惠券", id: 1 },
            { label: "京豆", id: 2 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "京东E卡", id: 5 },
            { label: "爱奇艺会员", id: 6 },
            { label: "PLUS会员", id: 7 },
            { label: "现金红包", id: 8 },
            { label: "礼品卡", id: 10 },
            { label: "实物（随单发）", id: 14 },
          ],
        },
        {
          name: '发放时间',
          myDate: true,
          val: ["sendStartTime", "sendEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name:"中奖状态",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            {
              label: '全部',
              id: '',
            },
            {
              label: '已中奖',
              id: 2
            },
            {
              label: '已发放',
              id: 3,
            },
            { label: "发放失败", id: 4 },
          ],
        },
      ],
      inputAward1: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          // name: "中奖状态:",
          name: this.fitersRepurchase(
            [16, 17, 18, 27],
            "发放状态:",
            "中奖状态:"
          ),
          val: "status",
          placeholder: "请选择",
          selectArr: [
            {
              label: this.fitersRepurchase(
                [16, 17, 18, 27],
                "待领取",
                "未中奖"
              ),
              id: this.fitersRepurchase([16, 17, 18, 27], -1, 1),
            },
            {
              label: this.fitersRepurchase(
                [16, 17, 18, 27],
                "待发放",
                "已中奖"
              ),
              id: 2,
            },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
          ],
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "优惠券", id: 1 },
            { label: "京豆", id: 2 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "京东E卡", id: 5 },
            { label: "爱奇艺会员", id: 6 },
            { label: "PLUS会员", id: 7 },
            { label: "红包", id: 8 },
            { label: "礼品卡", id: 10 },
            { label: "实物（随单发）", id: 14 },
          ],
        },
        {
          name: "中奖时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      // 解锁记录
      inputUnlock: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "解锁时间:",
          myDate: true,
          // type: 'date',
          // valueFormat2: "yyyy-MM-dd 23:59:59",
          val: ["checkStartTime", "checkEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "订单号:",
          val: "unlockOrderId",
          placeholder: "请输入",
        },
      ],
      // 下单冲榜领奖记录form表单数据
      inputAwardFiften: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "中奖名次:",
          val: "rank",
          placeholder: "请输入",
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "未知", id: 0 },
            { label: "优惠券", id: 1 },
            { label: "京豆", id: 2 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "京豆E卡", id: 5 },
            { label: "爱奇艺会员", id: 6 },
            { label: "京豆PLUS会员", id: 7 },
            { label: "红包", id: 8 },
            { label: "谢谢参与", id: 9 },
            { label: "礼品卡", id: 10 },
            { label: "实物（随单发）", id: 14 },
          ],
        },
        {
          name: "奖品名称:",
          val: "prizeIds",
          placeholder: "请选择",
          selectArr: [],
          multiple: true
        },
        {
          name: "中奖状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "未中奖", id: 1 },
            { label: "已中奖", id: 2 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
            { label: "待发放", id: 7 },
          ],
        },
        {
          name: "参与时间:",
          myDate: true,
          // type: 'date',
          // valueFormat2: "yyyy-MM-dd 23:59:59",
          val: ["createTimeStart", "createTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发放时间:",
          myDate: true,
          // type: 'date',
          // valueFormat2: "yyyy-MM-dd 23:59:59",
          val: ["sendTimeStart", "sendTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputAwardExtra: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "未知", id: 0 },
            { label: "优惠券", id: 1 },
            { label: "京豆", id: 2 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "京豆E卡", id: 5 },
            { label: "爱奇艺会员", id: 6 },
            { label: "京豆PLUS会员", id: 7 },
            { label: "红包", id: 8 },
            { label: "谢谢参与", id: 9 },
            { label: "礼品卡", id: 10 },
            { label: "实物（随单发）", id: 14 },
          ],
        },
        {
          name: "中奖状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "未中奖", id: 1 },
            { label: "已中奖", id: 2 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
            { label: "待发放", id: 7 },
          ],
        },
        {
          name: "中奖时间：:",
          myDate: true,
          val: ["winTimeStart", "winTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      // 派样下订单记录表单
      inputSendBuyPay: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "商品SKU:",
          val: "skuId",
          placeholder: "请输入",
        },
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入",
        },
        {
          name: "订单号:",
          val: "orderId",
          placeholder: "请输入",
        },
        {
          name: "录入收货信息:",
          val: "isCommitAddress",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
        {
          name: "付款时间:",
          myDate: true,
          val: ["orderTimeStart", "orderTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "收货时间:",
          myDate: true,
          val: ["receiveTimeStart", "receiveTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      // 派样下单记录表格数据
      sendBuyPayTable: [],
      // 派样下单表格总数
      totalSendBuyPayCount: 0,
      // 回购下单记录表单
      inputSendBuyRePay: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "商品SKU:",
          val: "skuId",
          placeholder: "请输入",
        },
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入",
        },
        {
          name: "订单号:",
          val: "orderId",
          placeholder: "请输入",
        },
        {
          name: "商品金额:",
          connector: "-",
          iptArr: [
            { val: "orderPaymentStart", placeholder: "请输入" },
            { val: "orderPaymentEnd", placeholder: "请输入" },
          ]
        },
        {
          name: "是否中奖:",
          val: "isWin",
          placeholder: "请选择",
          selectArr: [
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
        {
          name: "录入收货信息:",
          val: "isCommitAddress",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
        {
          name: "付款时间:",
          myDate: true,
          val: ["orderTimeStart", "orderTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "收货时间:",
          myDate: true,
          val: ["receiveTimeStart", "receiveTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      // 回购下单记录表格数据
      sendBuyRePayTable: [],
      // 回购下单表格总数
      totalSendBuyRePayCount: 0,


      inputLockRight: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "满足中奖门槛:",
          val: "isPass",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
        {
          name: "录入收货信息:",
          val: "isEnter",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
        {
          name: "下单期间订单数:",
          iptArr: [
            { val: "buyOrderNumMin", placeholder: "请输入" },
            { val: "buyOrderNumMax", placeholder: "请输入" },
          ],
        },
        {
          name: "下单期间总额:",
          iptArr: [
            { val: "buyMoneyMin", placeholder: "请输入" },
            { val: "buyMoneyMax", placeholder: "请输入" },
          ],
        },
        {
          name: "锁权时间:",
          myDate: true,
          val: ["createTimeStart", "createTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputTakeGoods: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "录入时间:",
          myDate: true,
          val: ["inputTimeStart", "inputTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputAwardOne: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "发放状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
          ],
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "优惠券", id: 1 },
            { label: "京豆", id: 2 },
            { label: "店铺积分", id: 4 },
          ],
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputAwardTwo: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "预约时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发货状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "未发货", id: "2,7" },
            { label: "已发货", id: "5" },
          ],
        },
        {
          name: "是否填写地址:",
          val: "isFillAddress",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "已填写", id: 1 },
            { label: "未填写", id: 0 },
          ],
        },
      ],
      inputAwardThree: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "发起时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputAwardFour: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "手机号码:",
          val: "mobile",
          placeholder: "请输入",
        },
        {
          name: "发放状态:",
          val: "sendStatus",
          placeholder: "请选择",
          selectArr: [
            { label: "待发放", id: 0 },
            { label: "已发放", id: 1 },
            { label: "已失效", id: 2 },
          ],
        },
        {
          name: "发货状态:",
          val: "deliveryStatus",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未发货", id: 0 },
            { label: "已发货", id: 1 },
          ],
        },
        {
          name: "创建时间:",
          myDate: true,
          val: ["createTimeStart", "createTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发放时间:",
          myDate: true,
          val: ["sendTimeStart", "sendTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发货时间:",
          myDate: true,
          val: ["deliveryTimeStart", "deliveryTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],

      inputInkind: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: this.rowData.activityType==41 ? '发货时间' : this.fitersRepurchase(
            [16, 17, 18, 27, 28, 19],
            "领奖时间:",
            "中奖时间:"
          ),
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发货状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: '' ,defaultValue: ''},
            { label: "已发货", id: "5" },
            { label: "未发货", id: "2,7" },
          ],
        },
        {
          name: "是否提交地址",
          val: "commitAddressFlag",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "",defaultValue: "" },
            { label: "已提交", id: 1 },
            { label: "未提交", id: 0 },
          ],
        },
        // {
        //   name: "关联订单状态:",
        //   val: "orderState",
        //   placeholder: "请选择",
        //   selectArr: [
        //     { label: "全部", id: null },
        //     { label: "等待付款", id: "等待付款" },
        //     { label: "暂停", id: "暂停" },
        //     { label: "等待出库", id: "等待出库" },
        //     { label: "等待发货", id: "等待发货" },
        //     { label: "完成", id: "完成" },
        //     { label: "取消", id: "取消" },
        //     { label: "锁定", id: "锁定" },
        //     { label: "等待确认收货", id: "等待确认收货" },
        //     { label: "未知", id: "未知" },
        //   ],
        // },
        // {
        //   name: "订单号:",
        //   val: "orderId",
        //   placeholder: "请输入",
        // },
      ],

      inputInkidNeedAward: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: this.rowData.activityType==41 ? '发货时间' : this.fitersRepurchase(
            [16, 17, 18, 27, 28, 19],
            "领奖时间:",
            "中奖时间:"
          ),
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发货状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: '' ,defaultValue: ''},
            { label: "已发货", id: "5" },
            { label: "未发货", id: "2,7" },
          ],
        },
        {
          name: "是否提交地址",
          val: "commitAddressFlag",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "",defaultValue: "" },
            { label: "已提交", id: 1 },
            { label: "未提交", id: 0 },
          ],
        },
        {
          name: "关联订单状态:",
          val: "orderState",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "等待付款", id: "等待付款" },
            { label: "暂停", id: "暂停" },
            { label: "等待出库", id: "等待出库" },
            { label: "等待发货", id: "等待发货" },
            { label: "完成", id: "完成" },
            { label: "取消", id: "取消" },
            { label: "锁定", id: "锁定" },
            { label: "等待确认收货", id: "等待确认收货" },
            { label: "未知", id: "未知" },
          ],
        },
        {
          name: "订单号:",
          val: "orderId",
          placeholder: "请输入",
        },
        {
          name: this.fitersRepurchase(
            [19, 28],
            "中奖状态:",
            "发放状态:"
          ),
          val: "prizeStatus",
          placeholder: "请选择",
          selectArr:  this.fitersRepurchase(
            [19, 28],
            [
            { label: "全部", id: "",defaultValue: "" },
            { label: "未中奖", id: 1 },
            { label: "已中奖", id: 2 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
            { label: "已失效", id: 8 },
            ],
            [
            { label: "全部", id: "",defaultValue: "" },
            { label: "待领取", id: -1 },
            { label: "待发放", id: 2 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
            { label: "已失效", id: 8 },
            ]),
        },
      ],
      inputMemberUpGradeMaterial: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入用户pin, 精确查询",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: '发货时间',
          myDate: true,
          val: ["grantStartTime", "grantEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发货状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: '' ,defaultValue: ''},
            { label: "已发货", id: "5" },
            { label: "未发货", id: "2,7" },
          ],
        },
        {
          name: "是否提交地址",
          val: "commitAddressFlag",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "",defaultValue: "" },
            { label: "已提交", id: 1 },
            { label: "未提交", id: 0 },
          ],
        },
      ],
      inputUserInfo: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "时间范围:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputCoupon: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          // name: "领取时间:",
          name: this.fitersRepurchase([21], "领取时间:", "参与时间:"),
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputSplitCoupon: [
        {
          name: "统计时间:",
          myDate: true,
          type: "date",
          valueFormat: "yyyy-MM-dd",
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputGroupCoupon: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "统计时间:",
          myDate: true,
          type: "date",
          valueFormat: "yyyy-MM-dd",
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputComment: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "nickName",
          placeholder: "请输入",
        },
        {
          name: "订单号:",
          val: "orderId",
          placeholder: "请输入",
        },
        {
          name: "评价时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "过滤状态:",
          val: "filterType",
          placeholder: "请输入",
          selectArr: [
            { label: "未通过", id: 0 },
            { label: "通过", id: 1 },
          ],
        },
      ],
      inputGiftrecord: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "获赠类型:",
          val: "taskType",
          placeholder: "请输入",
          selectArr: [
            { label: "每日打卡", id: 1 },
            { label: "浏览店铺", id: 2 },
            { label: "浏览商品", id: 3 },
            { label: "加购商品", id: 4 },
            { label: "浏览会场", id: 5 },
            { label: "关注店铺", id: 6 },
            { label: "开卡入会", id: 7 },
            { label: "好友助力", id: 8 },
          ],
        },
        {
          name: "获赠时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      // 大转盘
      inputGiftrecord2: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "获赠类型:",
          val: "taskType",
          placeholder: "请输入",
          selectArr: [
            { label: "全部", id:""},
            { label: "每日签到", id: 1 },
            { label: "浏览店铺", id: 2 },
            { label: "浏览商品", id: 13 },
            { label: "加购商品", id: 4 },
            { label: "分享商品", id: 9 },
            { label: "分享店铺", id: 10 },
            { label: "分享活动", id: 11 },
            { label: "好友助力", id: 8 },
            { label: "浏览会场", id: 5 },
            { label: "预约商品", id: 12 },
            { label: "首次赠送", id: 14 },
            { label: "每日赠送", id: 15 },
            { label: "积分兑换", id: 16 },
            { label: "购买商品", id: 17 },
          ],
        },
        {
          name: "获赠时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],

      inviteeDetailsInputData: [
        {
          name: "邀请人用户PIN:",
          val: "invitePin",
          placeholder: "请输入",
        },
        {
          name: "邀请人昵称:",
          val: "inviteNick",
          placeholder: "请输入",
        },
        {
          name: "被邀请人用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "被邀请人昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "是否有效邀请:",
          val: "isValidInvite",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: '' ,defaultValue: ''},
            { label: "是", id: "1" },
            { label: "否", id: "0" },
          ],
        },
        {
          name: "邀请时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inviteeDetailsData: [],
      inviteeDetailsPage: {
        current:1,
        size:10,
        total:0
      },
      orderDetailPage:{
        current:1,
        size:10,
        total:0
      },
      conversionPage:{
        current:1,
        size:10,
        total:0
      },
      inputOrderDetail: [
        {
          name: "用户PIN",
          val: "pin",
          placeholder: "请输入用户Pin,精确查询",
        },
        {
          name: "订单编号",
          val: "orderId",
          placeholder: "请输入",
        },
        {
          name: "父订单号",
          val: "rootId",
          placeholder: "请输入",
        },
        {
          name: "订单状态",
          val: "orderState",
          selectArr: [
            { label: "全部" , id:"", defaultValue:[""] },
            { label: "未付款", id: "WAIT_PAYMENT"},
            { label: "等待出库", id: "WAIT_SELLER_STOCK_OUT" },
            { label: "等待确认收货", id: "WAIT_GOODS_RECEIVE_CONFIRM" },
            { label: "已完成", id: "FINISHED_L" },
            { label: "已取消", id: "TRADE_CANCELED" },
            { label: "退货", id: "LOCKED" },
            { label: "暂停", id: "PAUSE" },
          ],
          multiple:true
        },
        {
          name: "下单时间",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
        },
      ],
      inputConversion:[
        {
          name: "统计活动入会后",
          val:"statDaysNum",
          slot:true
        },
        {
          name: "订单金额",
          val:"orderMoney",
          slot:true
        },
        {
          name: "入会时间",
          myDate: true,
          val: ["openCardStartTime", "openCardEndTime"],
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
        }
      ],
      conversionForm:{
        statDaysNum:30,
        statType:0,
        compareType:0,
        orderAmount:null
      },
      hasDefaultValue:false,
      defaultValueText:"",
      conversionData:[],
      orderDetailData:[],
      couponDetailsList: [],
      CouponStatisticsList: [],
      TeamDetailsList: [],
      CommentList: [],
      CouponMember: [],
      ParticipatTable: [],
      MemberUpGradeTable: [],
      BilletDouxTable: [], // 参与记录(情书贺卡)表格数据
      BilletReceiveTable: [], // 获取记录(情书贺卡)表格数据
      commentItem: {},
      commentDioag: false,

      dialogExprot: false,
      codeMsg: "获取验证码",
      code: "",
      phone: "",
      successMsg: "",
      // timer: "",
      countdown: 60,
      codeDisabled: false,
      ExprotData: "",
      // 验证码
      opentime: true,
      visible: false,
      timer: null, //验证码定时
      saveDisable: false,

      // 兑换记录
      inputDataThir: [
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入礼品名称",
        },
        {
          name: "用户PIN：",
          val: "pin",
          placeholder: "请输入用户PIN",
        },
        // {
        //   name: "礼品名称：",
        //   val: "prizeName",
        //   placeholder: "请输入礼品名称",
        // },
        {
          name: "兑换时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },

        // {
        //   name: "礼品类型：",
        //   val: "prizeType",
        //   placeholder: "请选择",
        //   selectArr: [
        //     { label: "全部", id: null },
        //     { label: "优惠券", id: 9 },
        //     { label: "实物", id: 10 },
        //     { label: "兑换京豆", id: 29 },
        //     { label: "兑换E卡", id: 30 },
        //   ],
        // },
        {
          name: "兑换状态：",
          val: "exchangeStatus",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "兑换成功", id: 1 },
            { label: "兑换失败", id: 2 },
          ],
        },
      ],
      inputDataThir9: [
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入礼品名称",
        },
        {
          name: "用户PIN：",
          val: "pin",
          placeholder: "请输入用户PIN",
        },
        {
          name: "兑换时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "兑换状态：",
          val: "exchangeStatus",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "兑换成功", id: 1 },
            { label: "兑换失败", id: 2 },
            { label: "已撤回", id: 4 },
          ],
        },
        {
          name: "发货状态：",
          val: "deliveryStatus",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "待发货", id: 1 },
            { label: "已发货", id: 2 },
            // { label: "无需发货", id: 3 },
          ],
        },
        {
          name: "是否提交地址",
          val: "commitAddressFlag",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "",defaultValue: ""},
            { label: "已提交", id: 1 },
            { label: "未提交", id: 0 },
          ],
        },
      ],
      inputDataThirJ: [
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入礼品名称",
        },
        {
          name: "用户PIN：",
          val: "pin",
          placeholder: "请输入用户pin",
        },
        // {
        //   name: "礼品名称：",
        //   val: "prizeName",
        //   placeholder: "请输入礼品名称",
        // },
        {
          name: "兑换时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },

        // {
        //   name: "礼品类型：",
        //   val: "prizeType",
        //   placeholder: "请选择",
        //   selectArr: [
        //     { label: "全部", id: null },
        //     { label: "优惠券", id: 9 },
        //     { label: "实物", id: 10 },
        //     { label: "兑换京豆", id: 29 },
        //     { label: "兑换E卡", id: 30 },
        //   ],
        // },
        {
          name: "兑换状态：",
          val: "exchangeStatus",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            // { label: "兑换成功", id: 1 },
            { label: "兑换失败", id: 2 },
            { label: "领取成功", id: 3 },
          ],
        },
      ],
      inputDataThirRED: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入用户昵称",
        },
        {
          name: "兑换状态：",
          val: "exchangeStatus",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "兑换成功", id: 1 },
            { label: "兑换失败", id: 2 },
          ],
        },
        {
          name: "兑换时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
      ],
      inputDataThir2: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入用户PIN",
        },
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入用户昵称：",
        },

        {
          name: "开卡时间：",
          myDate: true,
          val: ["openCardTimeStart", "openCardTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
      ],
      inputDataThir3: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入用户PIN",
        },
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入用户昵称：",
        },
        {
          name: "中奖状态：",
          val: "isWin",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "已中奖", id: 1 },
            { label: "未中奖", id: 0 },
            { label: "待开奖", id: 2 },
          ],
        },
        {
          name: "预约时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
      ],
      getRecordForm: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "奖品类型：",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "优惠券", id: 1 },
            { label: "京豆", id: 2 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "京东E卡", id: 5 },
            { label: "爱奇艺会员", id: 6 },
            { label: "京东PLUS会员", id: 7 },
            { label: "现金红包", id: 8 },
            { label: "礼品卡", id: 10 },
            { label: "实物（随单发）", id: 14 },
          ],
        },
        {
          name: "中奖状态：",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "已中奖", id: 2 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
          ],
        },
        {
          name: "参与时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
        {
          name: "领奖类型：",
          val: "prizeObjectType",
          value: "",
          selectArr: [
            { label: "全部", id: "" },
            { label: "生日奖品", id: 0},
            { label: "兜底奖品", id: 1 },
          ],
        },
        {
          name: "生日奖池：",
          val: "birthGiftPrize",
          placeholder: "请输入，多个奖品用,隔开查询",
        },
      ],
      exchangeList: [],
      totalMail: 0,
      couponList: [],
      formList2: {},

      // 控制录入快递单号弹窗
      enterCoutierNumShow: false,
      // 快递单号
      enterCoutierNum: "",
      // 弹窗表单标识
      enterCoutierFrom: {},
      // 录入快递单号当前行数据存储
      enterCoutierRowData: {},
      // -------下单冲榜数据开始---------
      // 活动统计表头数据
      chongBangTableColumnList: [
        { label: "日期", prop: "statsDate", width: "200" },
        { label: "活动PV", prop: "pv" },
        { label: "活动UV", prop: "uv" },
        { label: "新增入会人数", prop: "openCardNum" },
        { label: "新增关注人数", prop: "followNum" },
        { label: "分享人数", prop: "shareNum" },
        { label: "分享次数", prop: "shareTime" },
        { label: "参与人数", prop: "joinNum" },
        {
          label: "参与人数（有下单）",
          prop: "joinBuyNum",
          width: "210",
        },
        { label: "已付款GMV", prop: "orderAmt" },
        {
          label: "成交订单数（已付款）",
          prop: "orderPayNum",
          width: "210",
        },
        {
          label: "成交商品数（已付款）",
          prop: "orderPayItemNum",
          width: "210",
        },
        {
          label: "成交订单数（已收货）",
          prop: "orderFinishNum",
          width: "210",
        },
        { label: "成交商品数（已收货）", 
          prop: "orderItemNum", 
          width: "210",
        },
        {
          label: "参与成功人数（下单有效金额达到入榜金额）",
          prop: "winNum",
          width: "300",
        },
        { label: "已领奖人数", prop: "receiveNum" },
      ],
      // 折线图颜色数据
      colorList: [
        "#FF0000", "#00FF00", "#0000FF", "#FFFF00", "#FF00FF",
        "#00FFFF", "#FF4500", "#8B4513", "#2E8B57", "#4B0082",
        "#800000", "#008000", "#000080", "#808000", "#800080",
        "#008080", "#DC143C", "#FF8C00", "#00FF7F", "#7B68EE",
        "#8A2BE2", "#A52A2A", "#20B2AA", "#FFD700", "#ADFF2F",
        "#7FFFD4", "#6A5ACD", "#40E0D0", "#FF6347", "#FF69B4",
        "#B0C4DE", "#DAA520", "#48D1CC", "#9370DB", "#2F4F4F",
        "#FFA07A", "#BA55D3", "#7CFC00", "#87CEEB", "#778899"
      ],
      // 小部件管理折线图颜色数组
      colorsList : [
        "#FF5733", "#33FF57", "#5733FF", "#FF33A1", "#A1FF33", "#33A1FF",
        "#FFBB33", "#33FFBB", "#BB33FF", "#FF3366", "#66FF33", "#3366FF",
        "#FF8C33", "#33FF8C", "#8C33FF", "#FF3366", "#66FF33", "#3366FF",
        "#FFB333", "#33FFB3", "#B333FF", "#FF3366", "#66FF33", "#3366FF"
      ],

      // 下单冲榜数据总览数据集合
      dataScreenList: [
        { name: "活动PV", value: "pv" },
        { name: "活动UV", value: "uv" },
        { name: "新增入会人数", value: "openCardNum" },
        { name: "新增关注人数", value: "followNum" },
        { name: "分享人数", value: "shareNum" },
        { name: "分享次数", value: "shareTime" },
        { name: "参与人数", value: "joinNum" },
        { name: "参与人数（有下单）", value: "joinBuyNum" },
        { name: "已付款GMV", value: "orderAmt" },
        { name: "成交订单数（已付款）", value: "orderPayNum" },
        { name: "成交商品数（已付款）", value: "orderPayItemNum" },
        { name: "成交订单数（已收货）", value: "orderFinishNum" },
        { name: "成交商品数（已收货）", value: "orderItemNum" },
        {
          name: "参与成功人数（下单有效金额达到入榜金额）",
          value: "winNum",
        },
        { name: "已领奖人数", value: "receiveNum" },
      ],
      // 派样回购礼数据总览数据集合
      sendReBuydataScreenList: [
        { name: "活动PV", value: "pv" },
        { name: "活动UV", value: "uv" },
        { name: "新增关注人数", value: "followNum" },
        { name: "活动入会人数", value: "openCardNum" },
        { name: "分享人数", value: "shareNum" },
        { name: "分享次数", value: "shareTime" },
        { name: "派样付款金额", value: "sendBuyOrderAmt", tipsName: "派样下单且付款的商品金额（非实付金额）" },
        { name: "派样付款件数", value: "sendBuyItemNum", tipsName: "派样下单且付款的商品件数"},
        { name: "派样付款人数", value: "sendBuyNum", tipsName: "派样下单且付款的人数" },
        { name: "活动入会派样付款人数", value: "openCardSendBuyNum", tipsName: "通过活动入会，派样商品付款的人数"  },
        { name: "活动入会派样付款件数", value: "openCardSendBuyItemNum", tipsName: "通过活动入会，派样商品付款的商品件数"  },
        { name: "活动入会派样付款金额", value: "openCardSendBuyOrderAmt", tipsName: "通过活动入会，派样商品的商品金额（非实付金额）"  },
        { name: "派样收货金额", value: "enterSendBuyOrderAmt", tipsName: "派样商品付款且收货的商品金额（非实付金额）"  },
        { name: "派样收货件数", value: "enterSendBuyItemNum", tipsName: "派样商品付款且收货的商品件数"},
        { name: "派样收货人数", value: "enterSendBuyNum", tipsName: "派样商品付款且收货的人数" },
        { name: "活动入会派样收货人数", value: "openCardEnterSendBuyOrderAmt", tipsName: "通过活动入会且派样商品收货的用户"  },
        { name: "活动入会派样收货件数", value: "openCardEnterSendBuyItemNum", tipsName: "通过活动入会且派样商品收货的商品件数"  },
        { name: "活动入会派样收货金额", value: "openCardEnterSendBuyOrderAmt", tipsName: "通过活动入会且派样商品收货的商品金额（非实付金额）"  },
        { name: "回购付款金额", value: "reBuyOrderAmt", tipsName: "回购商品付款的商品金额（非实付金额）"   },
        { name: "回购付款件数", value: "reBuyItemNum", tipsName: "回购商品付款的件数" },
        { name: "回购付款人数", value: "reBuyNum", tipsName: "回购商品付款的人数"  },
        { name: "活动入会回购付款人数", value: "openCardReBuyNum" , tipsName: "通过活动入会，回购商品付款的人数"},
        { name: "活动入会回购付款件数", value: "openCardReBuyItemNum" , tipsName: "通过活动入会，完成派样付款、回购付款的件数" },
        { name: "活动入会回购付款金额", value: "openCardReBuyOrderAmt" , tipsName: "通过活动入会，回购商品付款的商品金额（非实付金额）" },
        { name: "回购收货金额", value: "enterReBuyOrderAmt" , tipsName: "回购商品付款且收货的商品金额（非实付金额）" },
        { name: "回购收货件数", value: "enterReBuyItemNum", tipsName: "回购商品付款且收货的商品件数" },
        { name: "回购收货人数", value: "enterReBuyNum", tipsName: "回购商品付款且收货的人数" },
        { name: "活动入会回购收货人数", value: "openCardEnterReBuyNum", tipsName: "通过活动入会，回购商品付款且收货的人数" },
        { name: "活动入会回购收货件数", value: "openCardEnterReBuyItemNum", tipsName: "通过活动入会，回购商品付款且收货的商品件数" },
        { name: "活动入会回购收货金额", value: "openCardEnterReBuyOrderAmt", tipsName: "通过活动入会，回购商品付款且收货的商品金额（非实付金额）" },
        { name: "付款回购率", value: "orderReBuyRate", tipsName: "回购付款人数/派样付款人数" },
        { name: "收货回购率", value: "enterReBuyRate", tipsName: "回购收货人数/派样收货人数" },
        { name: "填写收货地址人数", value: "enterNum" },
        { name: "中奖人数", value: "winNum" },
      ],
      // 派样回购礼数据统计表头数据
      sendReBuyTableColumnList: [
        { label: "日期", prop: "statsDate", width: "200" },
        { label: "活动PV", prop: "pv" },
        { label: "活动UV", prop: "uv" },
        { label: "新增店铺关注人数", prop: "followNum" },
        { label: "新增入会人数", prop: "openCardNum" },
        { label: "分享人数", prop: "shareNum" },
        { label: "分享次数", prop: "shareTime" },
        { label: "派样付款金额", prop: "sendBuyOrderAmt" },
        { label: "派样付款件数", prop: "sendBuyItemNum" },
        { label: "派样付款人数", prop: "sendBuyNum" },
        { label: "活动入会派样付款人数", prop: "openCardSendBuyNum", width: "200" },
        { label: "活动入会派样付款件数", prop: "openCardSendBuyItemNum", width: "200" },
        { label: "活动入会派样付款金额", prop: "openCardSendBuyOrderAmt", width: "200" },
        { label: "派样收货金额", prop: "enterSendBuyOrderAmt" },
        { label: "派样收货件数", prop: "enterSendBuyItemNum" },
        { label: "派样收货人数", prop: "enterSendBuyNum" },
        { label: "活动入会派样收货人数", prop: "openCardEnterSendBuyNum", width: "200" },
        { label: "活动入会派样收货件数", prop: "openCardEnterSendBuyItemNum", width: "200" },
        { label: "活动入会派样收货金额", prop: "openCardEnterSendBuyOrderAmt", width: "200" },
        { label: "回购付款金额", prop: "reBuyOrderAmt" },
        { label: "回购付款件数", prop: "reBuyItemNum" },
        { label: "回购付款人数", prop: "reBuyNum" },
        { label: "活动入会回购付款人数", prop: "openCardReBuyNum", width: "200" },
        { label: "活动入会回购付款件数", prop: "openCardReBuyItemNum", width: "200" },
        { label: "活动入会回购付款金额", prop: "openCardReBuyOrderAmt", width: "200"},
        { label: "回购收货金额", prop: "enterReBuyOrderAmt" },
        { label: "回购收货件数", prop: "enterReBuyItemNum" },
        { label: "回购收货人数", prop: "enterReBuyNum" },
        { label: "活动入会回购收货人数", prop: "openCardEnterReBuyNum", width: "200" },
        { label: "活动入会回购收货件数", prop: "openCardEnterReBuyItemNum", width: "200" },
        { label: "活动入会回购收货金额", prop: "openCardEnterReBuyOrderAmt", width: "200" },
        { label: "付款回购率", prop: "orderReBuyRate" },
        { label: "收货回购率", prop: "enterReBuyRate" },
        { label: "填写收货地址人数", prop: "enterNum", width: "200" },
        { label: "中奖人数", prop: "winNum" },
      ],
      // 派样下单记录表头
      sendBuyList: [
        { label: "订单号", prop: "orderId" },
        { label: "付款时间", prop: "orderStartTime" },
        { label: "收货时间", prop: "orderEndTime" },
      ],
      // 回购下单记录表头
      sendReBuyList: [
        { label: "付款时间", prop: "orderStartTime" },
        { label: "收货时间", prop: "orderEndTime" },
      ],

      // 实物奖品查询表单数据 - 下单冲榜
      inputInkind2: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "发放时间:",
          myDate: true,
          // type: 'date',
          // valueFormat2: "yyyy-MM-dd 23:59:59",
          val: ["sendTimeStart", "sendTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发货时间:",
          myDate: true,
          // type: 'date',
          // valueFormat2: "yyyy-MM-dd 23:59:59",
          val: ["deliveryTimeStart", "deliveryTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "是否提交地址",
          val: "commitAddressFlag",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "",defaultValue: "" },
            { label: "已提交", id: 1 },
            { label: "未提交", id: 0 },
          ],
        },
        {
          name: "中奖状态：",
          val: "prizeStatus",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "",defaultValue: "" },
            { label: "未中奖", id: 1 },
            { label: "已中奖", id: 2 },
            { label: "待发放", id: 7 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
          ],
        },
      ],
      inputInkind3: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "发货状态",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "已发货", id: "5" },
            { label: "未发货", id: "2,7" },
          ],
        },
        {
          name: "发放时间:",
          myDate: true,
          // type: 'date',
          // valueFormat2: "yyyy-MM-dd 23:59:59",
          val: ["sendTimeStart", "sendTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发货时间:",
          myDate: true,
          // type: 'date',
          // valueFormat2: "yyyy-MM-dd 23:59:59",
          val: ["deliveryTimeStart", "deliveryTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "是否提交地址",
          val: "commitAddressFlag",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "",defaultValue: ""},
            { label: "已提交", id: 1 },
            { label: "未提交", id: 0 },
          ],
        },
      ],
      // 领奖记录表头数据
      chongBangAwardList: [
        // { label: "用户PIN", prop: "pin", width: "200" },
        { label: "用户昵称", prop: "memberNick", width: "170" },
        { label: "活动名称", prop: "activityName" },
        { label: "总订单金额（已付款）", prop: "totalPayMoney", width: "180" },
        { label: "总订单笔数（已付款）", prop: "orderPayNum", width: "180" },
        { label: "总订单金额（已收货）", prop: "totalFinishMoney", width: "180" },
        { label: "总订单笔数（已收货）", prop: "orderFinishNum", width: "180" },
        { label: "名次", prop: "rank" },
        { label: "奖品类型", prop: "prizeTypeStr" },
        { label: "奖品名称", prop: "prizeName" },
        { label: "订单号", prop: "orderIdStr" },
        { label: "中奖状态", prop: "statusStr" },
        { label: "参与时间", prop: "joinTime", width: "200" },
        { label: "领奖时间", prop: "winTime", width: "200" },
        { label: "发放时间", prop: "grantTime", width: "200" },
      ],
      chongBangExraAwardList: [
        // { label: "用户PIN", prop: "pin", width: "200" },
        { label: "用户昵称", prop: "memberNick", width: "170" },
        { label: "活动名称", prop: "activityName" },
        { label: "奖品类型", prop: "prizeTypeStr" },
        { label: "奖品名称", prop: "prizeName" },
        { label: "中奖状态", prop: "statusStr" },
        { label: "中奖时间", prop: "winTime", width: "200" },
      ],
      // 下单冲榜 - 实物奖品名单
      chongBangPhysicalList: [
        // { label: "用户PIN", prop: "pinInfo", width: "200" },
        // { label: "用户昵称", prop: "memberNick" },
        // { label: "奖品名称", prop: "prizeTitle" },
        // { label: "姓名", prop: "receiverNameInfo" },
        // { label: "手机号码", prop: "mobileInfo" },
        // { label: "地区", prop: "decryptReceiverAddress" },
        // { label: "详细地址", prop: "detailedAddressInfo" },
        { label: "发放时间", prop: "sendTime", width: "200" },
        { label: "中奖状态", prop: "prizeStatus" },
        { label: "发货状态", prop: "deliveryStatusStr" },
        { label: "快递单号", prop: "billCode" },
        { label: "发货时间", prop: "deliveryTime", width: "200" },
      ],
      // 生日有礼-实物奖品名单
      chongBangPhysicalList2: [
        // { label: "用户PIN", prop: "pinInfo", width: "200" },
        // { label: "用户昵称", prop: "memberNick" },
        // { label: "奖品名称", prop: "prizeTitle" },
        // { label: "姓名", prop: "receiverNameInfo" },
        // { label: "手机号码", prop: "mobileInfo" },
        // { label: "地区", prop: "decryptReceiverAddress" },
        // { label: "详细地址", prop: "detailedAddressInfo" },
        { label: "发放时间", prop: "sendTime", width: "200" },
        { label: "发货状态", prop: "statusStr" },
        { label: "快递单号", prop: "billCode" },
        { label: "发货时间", prop: "grantTime", width: "200" },
      ],
      // 批量发货弹窗
      fileList: [],
      // 批量发放请求头设置
      physicalBatchShipmentHeaderOdj: {},
      physicalBatchShipmentShow: false,
      physicalBatchShipmentFrom: {},
      // 发货弹窗
      sendOutGoodsShow: false,
      // 导入结果集合
      downloadResData: {
        successNum: 0,
        failNum: 0,
      },
      // 导入失败用户列表
      downloadUserList: [],
      sendOutGoodsForm: {
        id: "",
        billCode: "",
        isUpdatePrizeStatus: true,
      },
      // -----------下单冲榜数据结束-------------
      tabName: '',
      actTab: "",
      batchMarkVisible:false,
      memberAnalysisSearchQuery:{},
      isShowVerify: false, // 导出验证弹窗
      isShowVerify2: false, // 导出验证弹窗
      phoneNum: "",
      isExportStatistics: false, // 是否导出活动统计数据
      exportSettingDialog: false, // 导出设置弹窗
      exportType: 0, // 导出类型 0全部导出 1部分导出
      exportFieldLoading: false, // 导出字段加载状态
      selectedFields: [], // 已选中的字段
      tempExportFieldsData: [], // 添加临时导出字段数据副本(确保在点击弹窗的确认按钮时才修改数据状态)
      // 导出字段设置
      exportFieldsData: [
      {
        label: '基础信息',
        export: true,
        group: '基础信息',
        disabled: true,
        children: [
          {
            label: '活动名称',
            export: true,
            prop: 'activityName',
            disabled: true,
          },
          {
            label: '活动类型',
            export: true,
            prop: 'activityType',
            disabled: true,
          },
          {
            label: '活动时间',
            export: true,
            prop: 'activityTime',
            disabled: true,
          },
          {
            label: '统计时间',
            export: true,
            prop: 'statisticsTime',
            disabled: true,
          }
        ]
      },
      {
        label: '互动参与',
        export: false,
        group: '互动参与',
        children: [
          {
            label: '活动PV',
            export: false,
            prop: 'actPv'
          },
          {
            label: '活动UV',
            export: false,
            prop: 'actUv'
          },
          {
            label: '参与次数',
            export: false,
            prop: 'participatePv'
          },
          {
            label: '参与人数',
            export: false,
            prop: 'participateUv'
          },
          {
            label: '人均参与次数',
            export: false,
            prop: 'participateAvg'
          },
          {
            label: '参与率',
            export: false,
            prop: 'participateRate'
          },
          {
            label: '加购次数',
            export: false,
            prop: 'cartPv'
          },
          {
            label: '加购人数',
            export: false,
            prop: 'cartUv'
          },
          {
            label: '分享次数',
            export: false,
            prop: 'sharePv'
          },
          {
            label: '分享人数',
            export: false,
            prop: 'shareUv'
          },
        ]
      },
      {
        label: '浏览店铺',
        export: false,
        group: '浏览店铺',
        children: [
          {
            label: '浏览店铺次数',
            export: false,
            prop: 'scanshopPv'
          },
          {
            label: '浏览店铺人数',
            export: false,
            prop: 'scanshopUv'
          },
          {
            label: '浏览率',
            export: false,
            prop: 'scanshopRate'
          },
          {
            label: '新增店铺关注人数',
            export: false,
            prop: 'followshopUv'
          },
          {
            label: '新增店铺关注次数',
            export: false,
            prop: 'followshopPv'
          },
          {
            label: '店铺关注率',
            export: false,
            prop: 'followshopRate'
          },
        ]
      },
      {
        label: '浏览商品',
        export: false,
        group: '浏览商品',
        children: [
          {
            label: '浏览商品次数',
            export: false,
            prop: 'scanskuPv'
          },
          {
            label: '浏览商品人数',
            export: false,
            prop: 'scanskuUv'
          },
          {
            label: '浏览商品率',
            export: false,
            prop: 'scanskuRate'
          },
          {
            label: '商品关注人数',
            export: false,
            prop: 'followskuUv'
          },
          {
            label: '商品关注次数',
            export: false,
            prop: 'followskuPv'
          },
          {
            label: '商品关注率',
            export: false,
            prop: 'followSkuRate'
          },
        ]
      },
      {
        label: '下单',
        export: false,
        group: '下单',
        children: [
          {
            label: '下单GMV（付款）',
            export: false,
            prop: 'orderPayGmv'
          },
          {
            label: '下单人数（付款）',
            export: false,
            prop: 'orderPayNum'
          },
          {
            label: '总下单数（付款）',
            export: false,
            prop: 'orderPayQuantity'
          },
          {
            label: '客单价',
            export: false,
            prop: 'price'
          },
          {
            label: '平均单量',
            export: false,
            prop: 'orderQuantityAvg'
          },
          {
            label: '下单转化率',
            export: false,
            prop: 'orderConversionRate'
          },
          {
            label: "新增会员下单人数",
            export: false,
            prop: "newOpenCardOrderQuantity",
          },
          {
            label: "老会员下单人数",
            export: false,
            prop: "oldOpenCardOrderNum",
          },
          {
            label: "新增会员下单金额",
            export: false,
            prop: "newOpenCardOrderGmv",
          },
          {
            label: "老会员下单金额",
            export: false,
            prop: "oldOpenCardOrderGmv",
          },
        ]
      },
      {
        label: '入会',
        export: false,
        group: '入会',
        children: [
          {
            label: '新增入会人数',
            export: false,
            prop: 'newOpenCardNum'
          },
          {
            label: '入会转化率',
            export: false,
            prop: 'openCardConversionRate'
          },
          {
            label: '新增会员下单人数',
            export: false,
            prop: 'newOpenCardOrderNum'
          },
          {
            label: '新增会员下单GMV（付款）',
            export: false,
            prop: 'newOpenCardOrderGmv'
          },
          {
            label: '新增会员下单数（付款）',
            export: false,
            prop: 'newOpenCardOrderQuantity'
          },
          {
            label: '新增会员客单价',
            export: false,
            prop: 'newOpenCardPrize'
          },
        ]
      },
      {
        label: '中奖',
        export: false,
        group: '中奖',
        children: [
          {
            label: '累计中奖次数',
            export: false,
            prop: 'accumulateWinTimes'
          },
          {
            label: '累计中奖人数',
            export: false,
            prop: 'accumulateWinNum'
          },
          {
            label: '中奖率',
            export: false,
            prop: 'winRate'
          },
          {
            label: '累计领奖人数',
            export: false,
            prop: 'accumulateReceiveNum'
          },
          {
            label: '领奖率',
            export: false,
            prop: 'receiveRate'
          }
        ]
      },
      ],
      exportMold: "",
    };
  },
  filters: {
    // showextendInfo(obj) {
    //   let obj1 = JSON.parse(obj);
    //   let string = "";
    //   for (const key in obj1) {
    //     if (obj1.hasOwnProperty(key)) {
    //       let key1 = key;
    //       let val = obj1[key];
    //       string += key1 + ":" + val + "; ";
    //     }
    //   }

    //   return string;
    // },
    typeChinese(val) {
      let arr = [
        "全部",
        "平台新用户",
        "品类新用户",
        "店铺新用户",
        "店铺近180天未下单客户",
        "店铺已购客户",
        "未入户用户",
        "开卡会员",
      ];
      if (val.memberRole == 1) {
        return "-";
      }
      const tempList = val.memberType.split(",");
      let str = "";
      tempList.map((item) => {
        str = str + "," + arr[Number(item)];
      });
      str = str.slice(1, str.length);
      return str;
    },
  },
  computed: {
    ...mapState(["loginUserInfo"]),
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    // 数据总览
    dataSummary(){
      if(this.switchIndex == 1){
        return this.joinSummary
      }else if(this.switchIndex == 2){
        return this.stoneSummary
      }else if(this.switchIndex == 3){
        return this.goodsSummary
      }else if(this.switchIndex == 4){
        return this.orderSummary
      }else if(this.switchIndex == 5){
        return this.fanSummary
      }else if(this.switchIndex == 6){
        return this.prizeSummary
      }
    },
    // 生成人群参数
    crowCondition(){
      if(this.activeName == 'conversionAnalysis'){
        return this.memberAnalysisSearchQuery
      }  if(this.activeName == 'twenty-three'){
        return this.formExtra
      }else{
        return this.rowData.activityType == 39?this.formListRecord:this.formList
      }
    },
    getAnswerText(){
      return (row)=>{
        let text = ''
        if(row.extraQuestion&&row.extraQuestion.type==1) {
          row.extraQuestion.options.some(item => {
            if(row.extraQuestionAnswer.optionIds&&item.optionId == row.extraQuestionAnswer.optionIds[0]){
              text = item.description
            }
          })
        } else if(row.extraQuestion&&row.extraQuestion.type==2) {
          if(row.extraQuestionAnswer.optionIds&&row.extraQuestionAnswer.optionIds.length>0) {
            const list = row.extraQuestion.options.filter(item => {
              return row.extraQuestionAnswer.optionIds.includes(Number(item.optionId))
            })
            const descriptions = list.map(item => item.description).join(",")
            text = `<div>${descriptions}</div>` 
          }
        } else {
          text = row.extraQuestionAnswer&&row.extraQuestionAnswer.submitInputText ? row.extraQuestionAnswer.submitInputText : '-'
        }
        return text;
      }
    },
    getData() {
      const types = {
        1: "单选题",
        2: "多选题",
        3: "填空题"
      }
      const isMusts = {
        0: "非不填",
        1: "必填"
      }
      if(this.goodsRecordTable.length>0&&this.goodsRecordTable[0].extraQuestionAnswer) {
       return `${types[this.goodsRecordTable[0].extraQuestion.type]}(${isMusts[this.goodsRecordTable[0].extraQuestion.isMust]}): ${this.goodsRecordTable[0].extraQuestionAnswer.title}`
      } else {
        return '未设置附加信息收集'
      }
    }
  },
  watch:{
    switchIndex(){
      this.initChart()
    }
  },
  async created() {
    console.log("rowData", this.rowData);
    console.log("ids", this.ids1);
    if(this.rowData.activityType == 25 || this.rowData.activityType == 32 || this.rowData.activityType == 33 || this.rowData.activityType == 26){
      this.dataSummary = [
        {
          value: "onlineUv",
          name: "访客数",
          tips: false, // 提示的显示隐藏
        },
        {
          value: "avgRead",
          name: "人均浏览量",
          tips: false,
        },
        {
          value: "cartRate",
          name: "访客加购率",
          tips: false,
        },
        {
          value: "clickUv",
          name: "点击用户数",
          tips: false,
        },
        {
          value: "clickPv",
          name: "点击次数",
          tips: false,
        },
        {
          value: "ordUsrNum",
          name: "下单用户数",
          tips: false,
        },
        {
          value: "payOrderNum",
          name: "成交订单量",
          tips: false,
        },
        {
          value: "orderNum",
          name: "引入订单量",
          tips: false,
        },
        {
          value: "orderRate",
          name: "点击用户下单转化率",
          tips: false,
        },
        {
          value: "cartNum",
          name: "加购商品数",
          tips: false,
        },
        {
          value: "uvValue",
          name: "UV价值",
          tips: false,
        },
        {
          value: "payOrdLineNum",
          name: "引入订单行",
          tips: false,
        },
        {
          value: "onlinePv",
          name: "浏览量",
          tips: false,
        },
        {
          value: "sumPayOrdAmount",
          name: "成交金额",
          tips: false,
        },
        {
          value: "avgOrderAmount",
          name: "客单价",
          tips: false,
        },
        {
          value: "payOrdUsrNum",
          name: "成交用户数",
          tips: false,
        },
        {
          value: "clickRate",
          name: "点击率",
          tips: false,
        },
        {
          value: "payOrderRate",
          name: "下单-支付转化率",
          tips: false,
        },
        {
          value: "visitUsrPayOrderRate",
          name: "访客成交转化率",
          tips: false,
        },
        {
          value: "payOrdLine",
          name: "成交订单行",
          tips: false,
        },
      ];
      this.dataSummary.forEach((item, index) => {
        item.color = this.colorList[index];
      })
    }
    // 下单冲榜
    if (this.rowData.activityType == 36) {
      let arr = this.dataScreenList;
      arr.forEach((item, index) => {
        item.color = this.colorList[index];
        item.tips = false;
      });
      this.dataSummary = arr;
      this.isShowExtraWinRecord = this.rowData.ruleInfo ? JSON.parse(this.rowData.ruleInfo).isExtraPrizes : false
    }
    // 派样回购礼
    if (this.rowData.activityType == 37) {
      let arr = this.sendReBuydataScreenList;
      arr.forEach((item, index) => {
        item.color = this.colorList[index];
        // item.tips = false;
      });
      this.dataSummary = arr;
    }
    if (this.rowData.activityType == 35) {
      // this.activeName = "eighteen"
      // this.handleClick({name: "eighteen",})
      this.dataSummary = [
        {
          value: "pv", // 对应tableTotal的字段
          name: "活动PV",
          tips: false, // 提示的显示隐藏
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "uv",
          name: "活动UV",
          tips: false,
          color: "#B2A8DA",
        },
        {
          value: "lockNum",
          name: "参与锁权人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "openCardNum",
          name: "活动入会人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "shareUv",
          name: "分享人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "sharePv",
          name: "分享次数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockBuyNum",
          name: "锁权用户购买人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockBuyOrderAmt",
          name: "锁权用户购买金额",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockBuyOrderNum",
          name: "锁权用户购买订单数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockPassBuyOrderAmt",
          name: "锁权且满足活动门槛用户的购买金额",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockPassBuyOrderNum",
          name: "锁权且满足活动门槛用户的购买订单数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "openCardBuyOrderAmt",
          name: "活动入会用户下单金额",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "openCardBuyNum",
          name: "活动入会用户下单人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "passNum",
          name: "订单满足活动中奖门槛人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "winNum",
          name: "中奖人数",
          tips: false,
          color: "#F2D0B5",
        },
      ];
      this.dataSummary1 = [
        {
          value: "pv", // 对应tableTotal的字段
          name: "活动PV",
          tips: false, // 提示的显示隐藏
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "uv",
          name: "活动UV",
          tips: false,
          color: "#B2A8DA",
        },
        {
          value: "lockNum",
          name: "参与锁权人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "openCardNum",
          name: "活动入会人数",
          tips: false,
          color: "#F2D0B5",
        },
        // {
        //   value: "shareUv",
        //   name: "分享人数",
        //   tips: false,
        //   color: "#F2D0B5",
        // },
        // {
        //   value: "sharePv",
        //   name: "分享次数",
        //   tips: false,
        //   color: "#F2D0B5",
        // },
        {
          value: "lockBuyNum",
          name: "锁权用户购买人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockBuyOrderAmt",
          name: "锁权用户购买金额",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockBuyOrderNum",
          name: "锁权用户购买订单数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockPassBuyOrderAmt",
          name: "锁权且满足活动门槛用户的购买金额",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockPassBuyOrderNum",
          name: "锁权且满足活动门槛用户的购买订单数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "openCardBuyOrderAmt",
          name: "活动入会用户下单金额",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "openCardBuyNum",
          name: "活动入会用户下单人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "passNum",
          name: "订单满足活动中奖门槛人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "winNum",
          name: "中奖人数",
          tips: false,
          color: "#F2D0B5",
        },
      ];
      setTimeout(() => {
        this.timeChange();
        this.queryTotal();
        this.getShopGiftParticipateConver();
        this.initChart(); //折线图
      }, 1000);
    } else {
      this.timeChange();
      await this.queryTotal();
      await this.initChart(); //折线图
      //下单转化数据
      this.getShopGiftParticipateConver();
      if (this.rowData.activityType == 24) this.inputParticipat.splice(2, 1);
      // if (this.fitersChooseIF([16, 17, 18, 27])) {
      //   this.inputAward[1].selectArr.push({ label: "未发放", id: 7 });
      // }
      if (this.fitersChooseIF([16, 17, 18, 19, 27, 28])) {
        this.inputInkind.push(
          {
            name: "关联订单状态:",
            val: "orderState",
            placeholder: "请选择",
            selectArr: [
              { label: "全部", id: null },
              { label: "等待付款", id: "等待付款" },
              { label: "暂停", id: "暂停" },
              { label: "等待出库", id: "等待出库" },
              { label: "等待发货", id: "等待发货" },
              { label: "完成", id: "完成" },
              { label: "取消", id: "取消" },
              { label: "锁定", id: "锁定" },
              { label: "等待确认收货", id: "等待确认收货" },
              { label: "未知", id: "未知" },
            ],
          },
          {
            name: "订单号:",
            val: "orderId",
            placeholder: "请输入",
          }
        );
        this.inputAward[2].selectArr.push({ label: "已失效", id: 8 });
        this.inputAward.push(
          {
            name: "关联订单状态:",
            val: "orderState",
            placeholder: "请选择",
            selectArr: [
              { label: "全部", id: null },
              { label: "等待付款", id: "等待付款" },
              { label: "暂停", id: "暂停" },
              { label: "等待出库", id: "等待出库" },
              { label: "等待发货", id: "等待发货" },
              { label: "完成", id: "完成" },
              { label: "取消", id: "取消" },
              { label: "锁定", id: "锁定" },
              { label: "等待确认收货", id: "等待确认收货" },
              { label: "未知", id: "未知" },
            ],
          },
          {
            name: "订单号:",
            val: "unlockOrderId",
            placeholder: "请输入",
          }
        );
        // 下单抽奖添加白名单
        if(this.fitersChooseIF([19])){
          this.inputAward.push({
            name: "是否白名单:",
            val: "isWhite",
            selectArr: [
              { label: "不限", id: "",defaultValue:"" },
              { label: "是", id: 1 },
              { label: "否", id: 0 },
            ]
          })
        }
      }
    // 晒单有礼新增订单号
    if (this.fitersChooseIF([41])) {
      this.inputAward.push({
        name: "订单号:",
        val: "unlockOrderIds",
        placeholder: "请输入订单号，多个请使用英文“，”进行隔开",
        type: "Input",
      });
    }
      if (this.fitersChooseIF([31])) {
        this.inputCoupon.splice(0, 1);
        this.inputGroupCoupon.push({
          name: "拼券状态:",
          val: "status",
          placeholder: "请输入",
          selectArr: [
            { label: "全部", id: null },
            { label: "拼券中", id: 1 },
            { label: "拼券失败", id: 3 },
            { label: "拼券成功", id: 2 },
          ],
        });
        const { data: res } = await getCoupon(this.rowData.id);
        this.couponList = res;
      }
      if (this.fitersChooseIF([32])) {
        this.inputCoupon.splice(0, 1);
        this.getopenCardRecord();
      }
      if (this.fitersChooseIF([33])) {
        this.getappointment();
      }
    }
    if(this.fitersChooseIF([16, 17, 18, 23, 24, 27, 28, 31])) {
      let obj =  {
        name: "奖品名称:",
        val: "prizeIds",
        placeholder: "请选择",
        selectArr: [],
        multiple: true
      }
      this.inputAward.splice(this.getinputAwardPriceIndex(),0,obj)
    }
    this.getPhoneNUm();
    this.getPrizeNameList()
    // 获取导出字段
    this.getExportFieldJsonConfig();
  },
  methods: {
    // 查看订单详情
    handleCheckOrderDetail(row){
      this.currentId = row.recordId
      this.isShowOrderDetail = true
    },
    getinputAwardPriceIndex() {
      return this.inputAward.findIndex(item=>item.val=="prizeType") + 1;
    },
    async getPhoneNUm() {
      const { data: res } = await getmoble();
      this.phoneNum = res.mobile;
    },
    handleToGoods(id) {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/goods_management",
        query: {
          id,
          tabActive: 1
        }
      });
      window.open(routeUrl.href, "_blank");
    },
    getStaticInfoNames(item,staticInfoNames) {
      let value = '';
      staticInfoNames.forEach(cItem => {
        if(cItem.name == item.name) {
          value = cItem.value
        }
      })
      return value;

    },

    formatExtendInfo(extendInfo) {
      return JSON.parse(extendInfo)
    },

    onPoccessSelectable(row,index) {
      // 已通过的不能再选择
      if(row.processStatus !=1) {
        return true;
      }else {
        return false;
      }
    },
    handlePoccessSelectionChange(val) {
      this.proccessSelectionArr = val;
    },
    // 晒单有礼-审核
    onHandleProcess(row) {
      this.isShowProcessInfoDialog = true;
      if(row) {
        this.processControlType = 'single'
        // 扩展字段
        row.parseExtendInfo = row.extendInfo ? JSON.parse(row.extendInfo) : null;
        // console.log(row.extendInfo)
        this.processRowData = {...row}
      }else {
         this.processControlType = 'batch'
      }
    },
    closeBigImg() {
      this.dialogImageUrl = "";
    },
    // 放大图片
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
    },
    showextendInfo(obj) {
      let obj1 = obj ? JSON.parse(obj) : {};
        let arr = []
        for (const key in obj1) {
          if (obj1.hasOwnProperty(key)) {
            let keys = key;
            let isImg = false
            let val = ""
            if(this.isLink(obj1[key]).flag) {
              isImg = true
            }
            console.log(this.isLink(obj1[key]),'4444');
            val = this.isLink(obj1[key]).newVal;
            arr.push({prop: keys,keys:val,isImg})
          }
        }
        return arr;
    },
    isLink(val) {
      let newVal = ""
      let flag = false
      let reg = new RegExp(/^http|https?:\/\//)
      if(val.indexOf("[")!=-1) {
        flag = reg.test(val)
        newVal = JSON.parse(val)
      }else {
        newVal = val
      }
      return {flag,newVal}
    },
    addCrowd(val){
      console.log(this.loginUserInfo)
      if(!this.loginUserInfo.isPlatformSeller){
        return this.$message.warning("您不满足使用该功能，请联系专属客服了解~")
      }
      this.source = val
      this.isShowCrowdDialog = true
      // 用户分析默认值
      if(val == 18){
        this.hasDefaultValue = true
        this.defaultValueText = '入会用户转化分析'
      }
      // 晒单有礼-默认值
      if(this.rowData.activityType == 41) {
        this.hasDefaultValue = true
        let txtMap = {
          20: '用户资料',
          3: '中奖记录',
          4: '实物奖品名单'
        }
        this.defaultValueText = txtMap[val]
      }
      // 生日有礼按查询生成人群
      if(this.rowData.activityType == 39) {
        this.hasDefaultValue = true;
        if(val == 52) {
        this.defaultValueText = "登记生日"
        } else if(val==7) {
          this.defaultValueText = "收集机会获取记录"
        } else if(val==3) {
          this.defaultValueText = "生日有礼领奖记录"
        }
      }
      if (this.rowData.activityType == 45 && val == 3) {
        this.hasDefaultValue = true;
        this.defaultValueText = this.tabName == "twenty-one" ? "领奖记录(冲榜)" : "领奖记录(额外奖品)";
      }
    },
    crowdClose(){
      this.isShowCrowdDialog = false
      // 关闭时重置
      if(this.hasDefaultValue){
        this.hasDefaultValue = false
        this.defaultValueText = ''
      }
    },
    editAddress(row) {
      this.takeGoodsForm.id = row.id;
      this.$decryptBatch
        .decrypt([
          row.decryptMemberNick,
          row.decryptMobile,
          row.decryptReceiverAddress,
          row.decryptDetailedAddress,
        ])
        .then((res) => {
          if (res.code == 1) {
            let data = res.data;
            this.takeGoodsForm.receiverName = data[0];
            this.takeGoodsForm.receiverMobile = data[1];
            this.takeGoodsForm.receiverAddress = data[2];
            this.takeGoodsForm.detailedAddress = data[3];
            this.lockTakeGoodsVisible = true;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    setTakeGoods() {
      if (!this.takeGoodsForm.receiverName) {
        return this.$message.info("请输入姓名");
      } else if (!this.takeGoodsForm.receiverMobile) {
        return this.$message.info("请输入手机号码");
      } else if (!this.takeGoodsForm.receiverAddress) {
        return this.$message.info("请输入地区");
      } else if (!this.takeGoodsForm.detailedAddress) {
        return this.$message.info("请输入详细地址");
      }
      updateReceiveAddress({ ...this.takeGoodsForm }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.$message.success("修改成功");
          this.lockTakeGoodsVisible = false;
          this.takeGoodsRecord();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 单个发货
    sendGoods(row) {
      let billCode = row.billCode || null;
      this.$prompt("快递单号：", "发货信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "lock_message_box",
        inputValue: billCode,
        inputValidator: (value) => {
          if (!value) {
            this.$message({
              type: "info",
              message: "请输入快递单号",
            });
            return "";
          }
        },
      })
        .then(({ value }) => {
          if (!value) {
            this.$message({
              type: "info",
              message: "请输入快递单号",
            });
            return false;
          } else {
            lockSendStatus({ id: row.id, billCode: value }).then((res) => {
              if (res.code == 1) {
                // 刷新列表
                this.winningRecord();
              } else {
                this.$message({
                  type: "info",
                  message: res.messaga,
                });
              }
            });
          }
        })
        .catch(() => {});
    },
    // 确权 中奖记录批量发货
    batchLock() {
      this.batchLockVisible = true;
    },
    // 确权 中奖记录批量发货
    batchLockClose() {
      this.winningRecord();
      this.batchLockVisible = false;
    },
    // 跳转至商品详情页
    jumpTo() {},
    //Note----邀请明细
    // invitationDeatils(val){
    //   this.dialogDeatils = true;
    // },
    handleCurrentExchange2(val) {
      this.formList.current = val;
      // this.getopenCardRecord()
      if (this.rowData.activityType == 32) {
        this.getopenCardRecord();
      } else if (this.rowData.activityType == 33) {
        this.getappointment();
      }
    },
    handleSizeExchange2(val) {
      this.formList.size = val;
      // this.getopenCardRecord()
      if (this.rowData.activityType == 32) {
        this.getopenCardRecord();
      } else if (this.rowData.activityType == 33) {
        this.getappointment();
      }
    },
    searchFormThir2(val) {
      this.formList2 = val;
      if (this.rowData.activityType == 32) {
        this.getopenCardRecord();
      } else if (this.rowData.activityType == 33) {
        this.getappointment();
      }
    },
    getopenCardRecord() {
      var obj = {
        ...this.formList,
        id: this.rowData.id,
        memberNick: this.formList2.memberNick,
        createTimeStart: this.formList2.createTimeStart,
        createTimeEnd: this.formList2.createTimeEnd,
        openCardTimeStart: this.formList2.openCardTimeStart,
        openCardTimeEnd: this.formList2.openCardTimeEnd,
      };
      openCardRecord(obj).then((res) => {
        this.exchangeList = res.data.records;
        this.totalMail = Number(res.data.total);
      });
    },
    getappointment() {
      var obj = {
        ...this.formList,
        memberNick: this.formList2.memberNick,
        isWin: this.formList2.isWin,
        startTime: this.formList2.startTime,
        endTime: this.formList2.endTime,
      };
      appointment(obj).then((res) => {
        this.exchangeList = res.data.records;
        this.totalMail = Number(res.data.total);
      });
    },
    // 监听录入快递单号按钮
    handleEnterCoutierNum(row) {
      this.enterCoutierNum = row.billCode;
      this.enterCoutierRowData = row;
      this.$forceUpdate();
      // 打开弹窗
      this.enterCoutierNumShow = true;
    },
    // 输入框限制输入数字
    // enterCoutierInputLimit(value) {
    //   // console.log("input", value);
    //   this.enterCoutierNum = Number(value.replace(/[^\d]/g, ""));
    // },
    clearInput (e) {
      let key = e.key;
      if (key === 'e' || key === 'E' || key === '+' || key === '-') {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    // 置空录入快递单号输入框并关闭弹窗
    blankEnterCoutierNum() {
      this.enterCoutierNum = "";
      // 清除当前行存储数据
      this.enterCoutierRowData = {};
      this.enterCoutierNumShow = false;
      this.sendOutGoodsShow = false;
    },
    // 录入快递单号提交
    enterCoutierSubmit() {
      let params = {
        billCode: this.enterCoutierNum,
        // 这里默认传true
        isUpdatePrizeStatus: true,
      }
      if(this.rowData.activityType == 9){
        params.recordId = this.enterCoutierRowData.id
      }else{
        params.id = this.enterCoutierRowData.id
      }
      let fn = markingSendStatusLockRight
      if(this.rowData.activityType == 9){
        fn = markingSendStatusForPointActivity
      }
      fn(params).then((res) => {
        console.log("markingSendStatusLockRight", res);
        if(res.code == 1){
          if(this.rowData.activityType == 9){
            this.$message.success("录入快递单号成功");
            this.getList()
          }else{
            this.inKingRecord();
          }
          this.blankEnterCoutierNum();
        }else {
          this.$message.error(res.message);
        }
      }).catch(() => {
        this.$message.error("录入快递单号失败");
      })
      
      
    },
    // 下单冲榜领奖记录标记发放
    chongBangAwardMark(row) {
      this.markIss(row);
    },
    // 下单冲榜发货弹框回调
    // 录入快递单号提交
    goodsEnterCoutierSubmit() {
      let params = {
        id: this.enterCoutierRowData.id,
        billCode: this.enterCoutierNum,
        // 这里默认传true
        isUpdatePrizeStatus: true,
      }
      // console.log("enterCoutierRowData", this.enterCoutierRowData);
      // console.log("录入快递单信息参数", params);
      markingSendStatusLockRight(params).then((res) => {
        console.log("markingSendStatusLockRight", res);
        if(res.code == 1){
          // 标记发货
          // this.markIss(this.enterCoutierRowData).then(()=>{
            // 置空录入快递单号输入框
            this.blankEnterCoutierNum();
            // 刷新列表
            this.getGoodsRecord();
          // });
        }else {
          this.$message.error(res.message);
        }
      }).catch(() => {
        this.$message.error("录入快递单号失败");
      })
    },

    // 下单冲榜实物标记发货
    chongBangPhysicalMark(row) {
      // 回显数据
      this.enterCoutierNum = row.billCode;
      this.enterCoutierRowData = row;
      this.sendOutGoodsShow = true;
    },
    // 下单冲榜批量发货
    physicalBatchShipment() {
      // console.log("1111");
      this.physicalBatchShipmentShow = true;
    },
    physicalBatchShipmentClose() {
      this.physicalBatchShipmentShow = false;
      this.downloadResData = {};
      this.downloadUserList = [];
      this.handleClick(this.actTab);
      // TODO: 清空上传信息
      // this.downloadResData = {};
      // this.downloadUserList  = [];
    },
    // 下单冲榜批量发货弹框确认按钮
    physicalBatchShipmentSubmit() {
      // TODO: 清空上传列表，刷新表格
      // this.fileList = [];
      this.downloadResData = {};
      this.downloadUserList = [];
      // this.searchInkind();
    },
    // 上传文件回调
    handleUpload(res) {
      console.log("res", res);
      // 上传文件
      if(res.code == 0){
        this.$message.error(res.message);
      }else if(res.code == 1){
        this.downloadResData = res.data;
        this.downloadUserList = res.data.failUserName;
      }
    },
    // 上传文件处理
    beforeUploadFile(file) {
      this.loading = true;
    },
    chongBangExport() {
      this.chongBangExportDialogShow = true;
      // export_get
    },
    // 下载模板
    handleDownloadTemplate() {
      let url = "";
      if(this.fitersChooseIF([36])){
        url = "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF.xlsx";
      }else {
        url = "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF2.xlsx";
      }
      let fileName= "实物奖品名单批量发货模板.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    // 订单明细搜索
    searchOrderDetail(val){
      this.loading = true
      const {size,current} = this.orderDetailPage
      const query = {
        size,
        current,
        activityId:this.rowData.id
      }
      if(val.pin){
        query.pin = val.pin
      }
      if(val.orderId){
        query.orderId = val.orderId
      }
      if(val.rootId){
        query.rootId = val.rootId
      }
      if(val.orderState && val.orderState.length){
        // 不等于全部
        if(!val.orderState.some(item=>!item)){
          query.orderState = val.orderState.join(",")
        }
      }
      if(val.startTime){
        query.startTime = val.startTime
      }
      if(val.endTime){
        query.endTime = val.endTime
      }
      let orderAip = orderDetailPage;
      if(this.fitersChooseIF([9])){
        orderAip = pointOrderDetailPage;
      }
      orderAip(query).then(res=>{
        this.loading = false
        this.orderDetailData = res.data.records
        this.orderDetailPage.total = Number(res.data.total)
      }).catch(()=>{
        this.loading = false
      })
    },
    // 订单明细分页-数量
    handleSizeOrderDetail(size){
      this.orderDetailPage.size = size
      // this.searchOrderDetail()
      this.$refs.orderDetailRef.submitForm('formSearch', true)
    },
    // 订单明细分页-页数
    handleCurrentOrderDetail(current){
      this.orderDetailPage.current = current
      this.$refs.orderDetailRef.submitForm('formSearch', true)
      // this.searchOrderDetail()
    },
    // 入会分析
    searchConversion(val,type){
      // 重置
      if(type == 'reset'){
        this.conversionForm.statDaysNum = 30
        this.conversionForm.statType = 0
        this.conversionForm.compareType = 0
        this.conversionForm.orderAmount = null
      }
      this.loading = true
      const {size,current} = this.conversionPage
      const query = {
        size,
        current,
        activityId:this.rowData.id,
        statType:this.conversionForm.statType,
        compareType:this.conversionForm.compareType,
        source:this.fitersChooseIF([9,10,29,30,38]) ? 2 : 1
      }
      if(this.conversionForm.statDaysNum){
        query.statDaysNum = this.conversionForm.statDaysNum
      }
      if(this.conversionForm.orderAmount){
        query.orderAmount = this.conversionForm.orderAmount
      }
      if(val && val.openCardStartTime){
        query.openCardStartTime = val.openCardStartTime
      }
      if(val && val.openCardEndTime){
        query.openCardEndTime = val.openCardEndTime
      }
      this.memberAnalysisSearchQuery = query
      memConvAnalysis(query).then(res=>{
        this.loading = false
        this.conversionData = res.data.records
        this.conversionPage.total = Number(res.data.total)
      }).catch(()=>{
        this.loading = false
      })
    },
    // 入会用户转化分析-数量
    handleSizeConversion(size){
      console.log('size>>',size)
      this.conversionPage.size = size
      this.searchConversion()
    },
    // 入会用户转化分析-页数
    handleCurrentConversion(current){
      console.log('current>>',current)
      this.conversionPage.current = current
      this.searchConversion()
    },
    // 切换版本
    triggerVersion(){
      this.$emit("triggerVersion",false)
    },
    // 撤回发货
    revocationIntegralGoods(row){
      this.$confirm(`您的订单状态为${row.deliveryStatus === 1 ? '待发货' : '已发货'}，是否进行撤回！`,"提示",{
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(res=>{
        console.log(row);
        pointsExchangeQuash({
          id: row.id,
        }).then(res=>{
          this.$message.success("撤回成功")
          this.getList()
        })
      })
    },
    // 撤回奖品
    revocationprize(row){
      this.$confirm(`您的奖品状态为${row.prizeStatus === 2 || row.prizeStatus === 7 ? '待发放' : '已发放'}，是否进行撤回！`,"提示",{
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(res=>{
        purchaseActivityWithdraw({
          recordId:row.recordId
        }).then(res=>{
          if(res.code == 1){
            this.$message.success("撤回奖品成功")
            this.inKingRecord()
          }else{
            this.$message.error(res.message)
          }
        })
      })
    },
    // 获取领奖/中奖记录的表单配置
    getRewardInputData(){
      let self = this
      function getInputConfig(){
        // 会员升级礼
        if(self.rowData.activityType == 44){
          return self.inputMemberUpGrade
        }else{
          return self.inputAward
        }
      }
      return this.rowData.activityType != 5 ? getInputConfig() : this.inputAward1      
    },
    getMaterialInputData(){
      let self = this
      function getInputConfig2(){
        // 会员升级礼
        if(self.rowData.activityType == 44){
          return self.inputMemberUpGradeMaterial
        }else{
          return self.inputInkidNeedAward
        }
      }
      // 为什么写成这样，因为我从 html上面拆下来的, 我也不好多改
      return this.fitersChooseIF([16,18,17,19,27,28,44])? getInputConfig2(): this.inputInkind
    },
    // 关闭验证码弹窗
    canclePhone(){
      this.visible = false
      this.isExportStatistics = false; // 重置状态
    },
    // 获取导出字段配置
    getExportFieldJsonConfig() {
      this.exportFieldLoading = true;
      getFieldJsonConfig().then((res) => {
        this.exportFieldLoading = false;
        if (res.code == 200 || res.code == 1) {
          try {
            if (!res.data || res.data === '' || res.data === 'undefined') {
              return;
            }
            if (!res.data.fieldJson || res.data.fieldJson === '' || res.data.fieldJson === 'undefined') {
              return;
            }
            // 解析返回的 JSON 字符串
            const savedFields = JSON.parse(res.data.fieldJson);
            // 创建一个 Set，用于快速查找需要勾选的字段
            const selectedPropsSet = new Set();
            savedFields.forEach(field => {
              selectedPropsSet.add(field.prop);
            });

            // 更新 exportFieldsData 中的 export 状态
            this.exportFieldsData.forEach(group => {
              if (group.children) {
                group.children.forEach(child => {
                  // 如果这个字段的 prop 在接口返回的数据中，就勾选它
                  if (selectedPropsSet.has(child.prop)) {
                    child.export = true;
                  } else {
                    // 如果没有找到，说明它没有被选中（除了默认必选的字段）
                    if (!child.disabled) {
                      child.export = false;
                    }
                  }
                });
                // 更新父级分组的 export 状态
                this.updateParentExportStatus2(group);
              }
            });
            console.log('导出字段配置已更新:', this.exportFieldsData);
          } catch (error) {
            console.log("--- error:---", error)
            this.$message.error('解析导出字段配置失败');
          }
        }
      }).catch((err) => {
        this.exportFieldLoading = false;
        this.$message.error('获取导出字段配置失败');
      });
    },
    // 当子项都勾选了, 父项也勾选
    updateParentExportStatus2(group) {
      if (group.children && group.children.length > 0) {
        // 检查是否有子项被选中
        const hasSelectedChildren = group.children.some(child => child.export);
        // 检查是否所有子项都被选中
        const allChildrenSelected = group.children.every(child => child.export);
        if (allChildrenSelected) {
          group.export = true;
        } else if (hasSelectedChildren) {
          // 部分选中状态，可以根据需要设置为 false 或保持当前状态
          group.export = false;
        } else {
          group.export = false;
        }
      }
    },
    exportRule(type, row) {
      if (type == "setting") {
        console.log("导出字段设置")
        this.exportSettingDialog = true;
      }
      if (type == "exportAll") {
        console.log("导出全部")
        if (this.queryForm.evaluateTime == 0) {
          if (!this.postForm.startDate || !this.postForm.endDate) {
            this.$message.warning("自定义时间不能为空")
            return;
          }
        }
        this.exportType = 0
        this.isExportStatistics = true
        this.getphone()
      }
      if (type == "exportSetting") {
        console.log("按设置导出")
        if (this.queryForm.evaluateTime == 0) {
          if (!this.postForm.startDate || !this.postForm.endDate) {
            this.$message.warning("自定义时间不能为空")
            return;
          }
        }
        this.isExportStatistics = true
        this.exportType = 1
        this.getphone()
      }
    },
    // 处理导出字段保存
    handleExportFieldsSave(tempExportFieldsData) {
      // 将临时数据保存到正式数据
      this.exportFieldsData = JSON.parse(JSON.stringify(tempExportFieldsData));
      const selectedFields = this.generateExportFields(this.exportFieldsData);
      console.log("--- selectedFields:---", selectedFields)
      // 调用保存接口
      let params = {
        fieldJson: JSON.stringify(selectedFields),
        type: 1,
      }
      this.exportFieldLoading = true;
      saveFieldJsonConfig(params).then((res) => {
        this.exportSettingDialog = false;
        if (res.code == 200 || res.code == 1) {
          this.$message.success("保存成功");
          // 重新获取导出字段配置
          this.getExportFieldJsonConfig()
        }
      }).catch((err) => {
        this.$message.error("保存失败");
        this.exportSettingDialog = false;
      });
    },
    // 处理导出字段弹窗关闭
    handleExportFieldsClose() {
      this.exportSettingDialog = false;
    },
    // 生成导出字段列表的通用方法
    generateExportFields(fieldsData) {
      if (!fieldsData || !Array.isArray(fieldsData)) {
        return [];
      }
      const selectedFields = [];
      fieldsData.forEach(parent => {
        // 过滤掉group为'基础信息'的父级数据
        if (parent.group === '基础信息') {
          return;
        }
        if (parent.export && !parent.children) {
          selectedFields.push({
            prop: parent.prop,
            label: parent.label,
            group: parent.group || ''
          });
        }
        if (parent.children) {
          parent.children.forEach(child => {
            if (child.export) {
              selectedFields.push({
                prop: child.prop,
                label: child.label,
                group: parent.group || ''
              });
            }
          });
        }
      });
      return selectedFields;
    },
  },
};
</script>
<style lang="scss">
.el-popover {
  min-width: 100px !important;
}
.lock_message_box {
  .el-message-box__content {
    display: flex;
    align-items: center;
    padding: 20px 60px !important;
  }
  .el-message-box__container {
    width: 80px;
    text-align: right;
  }
  .el-message-box__input {
    flex: 1;
    padding-top: 0;
  }
  .el-message-box__errormsg {
    display: none;
  }
}
</style>

<style scoped lang="scss">
.w30 {
  width: 30px;
}
.w60 {
  width: 60px;
  margin-left:-10px;
}
.commend-img-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .commend-img {
    width: 50px;
    height: 50px;
    margin-right: 4px;
    margin-top: 4px;
    &:nth-last-child(1) {
      margin-right: 0px;
    }
  }
}
.user-info-statics {
  display: flex;
  align-items: center;
  font-weight: 600;
  .user-info-statics-item {
    margin-left:10px;
    color: #333;
    font-size: 14px;
    font-weight: 400;
  }
}

.award-title{
  font-weight: bold;
  margin-bottom: 16px;
}
.switch {
  margin-top: 16px;
  &-tabs {
    /deep/.el-tabs__header {
      margin-bottom: 0px;
    }
  }
}
.new-pagination-page{
  margin: 25px 0px;
}
.conversion{
  margin-bottom: 15px;
  &-statDaysNum,&-compareType,&-orderMoney{
    width: 100px;
  }
  &-statType{
    width: 180px;
  }
  &-compareType{
    margin: 0px 10px;
  }
}
.data-title-wrap{
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  .back_text{
    margin-left: 10px;
    color: #7B61FF;
    cursor: pointer;
    line-height: normal;
  }
}
.operate-wrap{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.actName {
  padding: 20px 0 0 24px;
  display: flex;
  &_img {
    width: 60px;
    height: 60px;
  }
  &_info {
    div {
      margin-top: 14px;
    }
  }
}
.delivery {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #7b61ff;
  }
  &+&{
    margin-left: 8px;
  }
}
.backBtn {
  margin-left: 20px;
  width: 98px;
  height: 32px;
  color: #666666;
  border-radius: 3px;
  border: 1px solid #dddddd;
  background-color: #fff;
  &:hover {
    color: #7b61ff;
    border: 1px solid #7b61ff;
    background: rgba(123, 97, 255, 0.1);
  }
  &:active {
    color: #7b61ff;
    border: 1px solid #7b61ff;
    background: rgba(123, 97, 255, 0.1);
  }
}
.keepBtn {
  width: 98px;
  height: 32px;
  border-radius: 3px;
  background-color: #7b61ff;
  color: #fff;
  &:hover {
    opacity: 0.9;
  }
}
/deep/.system-dialog {
  .el-dialog__body {
    padding: 16px 30px 30px 30px;
  }
  .form-box {
    padding-top: 16px;
    .form-item {
      font-size: 14px;
      color: #333;
      margin-bottom: 12px;
      .item-label {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .item-label2 {
        display: inline-block;
        width: 100px;
        text-align: right;
      }
      .item-value {
        display: inline-block;
      }
    }
  }
  .save-btn {
    text-align: center;
  }
}
.imgurl {
  border-radius: 50%;
  width: 80px;
  height: 80px;
  overflow: hidden;
  margin-right: 7px;
  img {
    width: 80px;
  }
}
.referenceButton {
  cursor: pointer;
  // color: #7B61FF;
  &:hover {
    color: #7b61ff;
  }
}
.referencePopover {
  display: flex;
  span {
    display: block;
    margin-right: 20px;
  }
  span:last-child {
    margin-right: 0px;
  }
}
.decryptHover {
  display: none;
  margin-left: 4px;
  background: none;
}
.decrypt {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}
.decrypt:hover .decryptHover {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  background: none;
}

.question_iconOne {
  width: 13px;
  height: 13px;
  display: inline-block;
  line-height: 13px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #ccc;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 4px;
  color: #ccc;
}
.titClass {
  padding: 36px 24px;
  // margin: 35px;
  margin-bottom: 25px;
  background: #fafafa;
  opacity: 1;
  display: flex;
  align-items: center;
  line-height: 22px;
  position: relative;
  .titClassOne {
    margin: 0px 100px 0px 30px;
  }
  .down {
    margin-right: 30px;
  }
  .borderU {
    position: absolute;
    width: 1px;
    height: 110px;
    background: #f3f3f3;
    left: 122px;
  }
}
.acitvityAll {
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      cursor: default;
    }
  }
  .formSty {
    margin: 24px;
    .question_icon {
      width: 15px;
      height: 15px;
      display: inline-block;
      line-height: 12px !important;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #ccc;
      font-size: 14px !important;
      font-weight: normal !important;
      margin-left: 4px;
    }
    .y1,
    .y2,
    .y3,
    .y4 {
      display: inline-block;
      padding: 6px 10px;
      border-radius: 17px;
      margin-right: 5px;
    }
    .y1 {
      color: #5b5b5b;
      background-color: #f1f1f1;
    }
    .y2 {
      color: #02b1ff;
      background: #e6f7ff;
    }
    .y3 {
      color: #f56c6c;
      background-color: #fef0f0;
    }
    .y4 {
      color: #67c23a;
      background-color: #f0f9eb;
    }
    .section-right-content-box {
      // min-width: 1000px;
      // border-bottom: 6px;
      // padding: 15px 28px 30px 28px;
      // background: rgba(255, 255, 255, 1);
      // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      // opacity: 1;
      // -webkit-box-sizing: border-box;
      // -moz-box-sizing: border-box;
      // box-sizing: border-box;
      // margin: 0 20px 20px 20px;
      .tabList {
        display: flex;
        box-sizing: border-box;
        height: 36px;
        line-height: 35px;
        // margin-top: 20px;
        color: #666;
        font-size: 14px;
        margin: 20px 0;
        span {
          margin-right: 3px;
          width: 106px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          vertical-align: middle;
          transform: perspective(1px) translateZ(0);
          box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          border-radius: 2px 2px 0px 0px;
          border: 1px solid #dddddd;
          text-align: center;
        }
        .active {
          position: relative;
          transition: all 0.2s;
          color: #7b61ff;
          border-bottom: none;
          &::before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            width: 100%;
            top: 0;
            height: 2px;
            background: #7b61ff;
            border-radius: 6px 6px 0px 0px;
          }
        }
        i {
          flex: 1;
          border-bottom: 1px solid #dddddd;
          margin-left: -3px;
        }
      }
      .b1 {
        width: 98px;
        height: 32px;
        color: #fff;
        border: 1px solid #7b61ff;
        background-color: #7b61ff;
        &:hover {
          opacity: 0.8;
        }
      }
      .b2 {
        width: 98px;
        height: 32px;
        color: #7b61ff;
        border: 1px solid #7b61ff;
        background-color: #fff;
        &:hover {
          color: #fff;
          border: 1px solid #7b61ff;
          background-color: #7b61ff;
        }
      }
      .background {
        height: 32px;
        background: rgba(250, 250, 250, 1);
        opacity: 1;
        line-height: 32px;
        padding-left: 12px;
        .title {
          display: inline-block;
          width: 2px;
          height: 14px;
          background: #7b61ff;
          opacity: 1;
          border-radius: 3px;
          vertical-align: middle;
        }
        .tips {
          width: 56px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgba(51, 51, 51, 1);
          opacity: 1;
          vertical-align: middle;
        }
      }

      .overview1 {
        padding: 26px 30px 22px 30px;
        width: 20%;
        height: 100px;
        border-right: 1px solid #f3f3f3;
        opacity: 1;
        margin: 20px 0px;
        .fontClass {
          width: 102px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgba(102, 102, 102, 1);
          opacity: 1;
        }
        .question_icon {
          width: 14px;
          height: 14px;
          color: #cccccc;
          display: inline-block;
          line-height: 12px;
          text-align: center;
          border-radius: 14px;
          border: 1px solid #cccccc;
          font-size: 12px;
          font-weight: normal;
        }
        .num {
          width: 65px;
          height: 29px;
          font-size: 24px;
          font-family: DIN;
          font-weight: bold;
          line-height: 29px;
          color: #7b61ff;
          opacity: 1;
          margin-top: 14px;
          margin-bottom: 30px;
        }
      }
      /** 下单冲榜 */
      .overview2 {
        padding: 26px 30px 22px 30px;
        width: 18%;
        height: 100px;
        border-right: 1px solid #f3f3f3;
        opacity: 1;
        margin: 20px 0px;
        .fontClass {
          width: 102px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgba(102, 102, 102, 1);
          opacity: 1;
        }
        .question_icon {
          width: 14px;
          height: 14px;
          color: #cccccc;
          display: inline-block;
          line-height: 12px;
          text-align: center;
          border-radius: 14px;
          border: 1px solid #cccccc;
          font-size: 12px;
          font-weight: normal;
        }
        .num {
          width: 65px;
          height: 29px;
          font-size: 24px;
          font-family: DIN;
          font-weight: bold;
          line-height: 29px;
          color: #7b61ff;
          opacity: 1;
          margin-top: 14px;
          margin-bottom: 30px;
        }
      }

      .chart {
        // flex: 1;
        height: 380px;
        min-width: 1100px;
      }
      .chart2 {
        // flex: 1;
        height: 450px;
        min-width: 1100px;
      }
    }
    .el-table .two-line {
      height: 40px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
  }
  }
}

/* 导出数据模态框 */
.sendHug {
  width: 345px;
  height: 30px;
  background: rgba(255, 118, 0, 0.1);
  margin-left: 10px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  line-height: 30px;
  color: rgba(255, 118, 0, 1);
}
.hug-send {
  // overflow: hidden;
  margin-top: 10px;
  height: 32px;
  display: flex;
  align-items: center;

  .send-left {
    float: left;
    height: 32px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 20px;
    color: rgba(102, 102, 102, 1);
    margin-left: 50px;
  }
  .send-right {
    float: left;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 21px;
    color: rgba(51, 51, 51, 1);
    width: 280px;
    height: 100%;
    .send-ipnut {
      display: flex;
      width: 100%;
      height: 32px;
      line-height: 32px;
      background-color: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
      cursor: not-allowed;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      text-indent: 6px;
    }
  }
  .send-right2 {
    height: 32px;
    // border-bottom: 2px solid rgba(245, 245, 245, 1);
  }
  .codeBtn {
    width: 170px;
    display: inline-block;
    line-height: 32px;
    height: 32px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    color: rgba(51, 51, 51, 1);
    outline-style: none;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding-left: 6px;
  }
  .getNumber {
    display: inline-block;
    width: 100px;
    // border: none;
    // background: none;
    outline-style: none;
    color: #7b61ff;
    line-height: 32px;
    color: #fff;
    background: #7b61ff;
    border: 1px solid #7b61ff;
    margin-left: 10px;
    height: 32px;
    border-radius: 4px;
    cursor: pointer;
  }
  .getNumber-Disabled {
    color: rgba(51, 51, 51, 0.2) !important;
    border-color: rgba(51, 51, 51, 0.2) !important;
    cursor: no-drop;
  }
  .msg {
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 14px;
    color: #7b61ff;
    text-align: center;
  }
}
.dialogExprot-btn {
  width: 100%;
  display: inline-flex;
  justify-content: center;
  > span {
    display: inline-flex;
    width: 98px;
    height: 32px;
    line-height: 32px;
    border: 1px solid #ccc;
    text-align: center;
    font-size: 14px;
    // background: #7B61FF;
    border-radius: 5px;
    margin-right: 8px;
    cursor: pointer;
  }
  > span:nth-of-type(1) {
    background: #7b61ff;
    color: #fff;
    border-color: #7b61ff;
  }
}
.addCartDetail {
  display: flex;
  align-items: center;
  img {
    max-width: 60px;
    border-radius: 5px;
  }
  > div:nth-of-type(1) {
    flex: 1;
  }
  > div:nth-of-type(2) {
    flex: 5;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //设置超出几行省略内容
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.goodsInfo {
  display: flex;
  align-items: center;
  &_logo {
    display: flex;
    width: 80px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 70px;
      border-radius: 4px;
    }
  }
  &_text {
    flex: 1;
    color: #666666;
    cursor: pointer;
    margin-left: 5px;
    a {
      color: #666666;
      margin-top: 5px;
    }
  }
}
.enter_coutier_num_dialog {
  .enter_coutier_num_dialog_floor {
    text-align: center;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.physical_batch_shipment_dialog {
  .upload-demo {
    /deep/ .el-upload .el-upload-dragger {
      width: 250px;
    }
  }
  .download_template_box {
    position: absolute;
    right: 11%;
    top: 17%;
  }
  .downloadMsgBox {
    width: 100%;
    min-height: 100px;
  }
  .physical_batch_shipment_dialog_floor {
    text-align: center;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.btn-wrap{
  display: flex;
  align-items: center;
}
.info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 8px;
  .img-parent {
    margin-left: 4px;
    // margin-right: 4px;
    margin-top: 4px;
    height: 50px;
    position: relative;
    display: inline-block;
    // width: 84px;
    // height: 50px;
    &:hover {
      cursor: pointer;
      .mask {
        opacity: 1;
      }
    }
    .mask {
      position: absolute;
      opacity: 0;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      transition: all 0.3s;
      i {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        color: #fff;
      }
    }
    .info-img  {
      width: 50px;
      height: 50px;
    }
  }
}
.bigImg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);
  z-index: 99;
  img {
    height: 80%;
  }
  i {
    cursor: pointer;
    margin-top: 12px;
    font-size: 25px;
    color: #fff;
  }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 9px 14px;
  display: flex;
  .card-rule {
    background: url("~@/assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}
.remark-tip {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;   //设置超出几行省略内容
  text-overflow:ellipsis;
  overflow: hidden;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
